/* ============================================================================
 * LPO-SCHALTER                                          26.09.2026 (PageSpeed)
 * ----------------------------------------------------------------------------
 * LPO (Cloudlift Live Product Options) ist durch den Eigenbau-Konfigurator
 * ersetzt und laedt auf keiner Seite mehr. Elf Bloecke weiter unten warten
 * trotzdem per MutationObserver auf LPO-Elemente (#clu4al1wbeiu, .cl-po--*,
 * Tippy an [data-option]) und laufen dabei bei JEDER Aenderung am Dokument mit.
 * Gemessen am 26.09.2026 auf /products/fenstergitter-01 (CPU-Profil, 4x
 * gedrosselt): wurzel() allein 391 ms, dazu anzeigen/laschenOption/galerieDa/
 * massKnoten/pflegen/ziel - Code, der nichts mehr findet. Test per
 * Interception auf 6 Seiten/Breiten: Stil-Schnappschuss 0 Abweichungen,
 * Preise gleich, Beobachter-Rueckrufe -36 %.
 *
 * Diese Bloecke starten jetzt nur, wenn LPO wirklich im Dokument steckt.
 * Wird LPO wieder eingeschaltet, laufen sie wie vorher - nichts ist geloescht.
 * RUECKBAU: den Schalter auf true setzen oder die Riegelzeilen entfernen.
 * ============================================================================ */
window.MO_LPO_AKTIV = !!document.querySelector('script[src*="cloudlift"], #clu4al1wbeiu, .cl-po--wrapper, [class*="cl-po--"]');
jQuery( document ).ready(function($) {
     $('.list-menu__item span').click(function(){
       $(this).closest('.list-menu__item').toggleClass('active_item');
    })
 

  var $backToTop = $(".back-to-top");
  $backToTop.hide();
  
  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 100) {
      $backToTop.fadeIn();
    } else {
      $backToTop.fadeOut();
    }
  });
  
  $backToTop.on('click', function(e) {
    $("html, body").animate({scrollTop: 0}, 500);
  });

  $('.product-grid-container').addClass('grid-view-section');
    // Toggle between grid and list view
    $('.grid-view').click(function() {
        $(this).addClass('active');
        $('.list-view').removeClass('active');
        $('.product-grid-container').removeClass('list-view-section1').addClass('grid-view-section');
        $('#product-grid').removeClass('grid--4-col-desktop grid--2-col-tablet-down').addClass('grid--2-col-desktop grid--1-col-tablet-down');
    });
  
    $('.list-view').click(function() {
        $(this).addClass('active');
        $('.grid-view').removeClass('active');
        $('.product-grid-container').removeClass('grid-view-section1').addClass('list-view-section1');
        $('#product-grid').removeClass('grid--2-col-desktop grid--1-col-tablet-down').addClass('grid--4-col-desktop grid--2-col-tablet-down');
      
    });
  });




document.addEventListener("DOMContentLoaded", function () {
  const stickyForm = document.querySelector("product-sticky-form");
  const footer = document.querySelector("footer");

  if (stickyForm && footer) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Footer is visible → hide sticky form
            stickyForm.style.display = "none";
          } else {
            // Footer is not visible → show sticky form
            stickyForm.style.display = "";
          }
        });
      },
      {
        root: null, // viewport
        threshold: 0, // trigger as soon as footer touches viewport
      }
    );

    observer.observe(footer);
  }
});


/* ===========================================================================
   Metallbau Odenthal - Warenkorb: Optionspreis nicht an die Eigenschaft haengen
   Version 1.0.0 - 05.08.2026
   Gepflegte Quelle mit ausfuehrlicher Begruendung:
   Produktkonfigurator/Theme/mo_warenkorb_optionspreis.js

   Live Product Options schreibt im Warenkorb hinter jeden Eigenschaftswert den
   Optionspreis ("Masse: 1001 mm x 500 mm | 20,34 EUR"). Das ist irrefuehrend:
   die 20,34 EUR sind nur der Massaufschlag, nicht der Preis des Gitters - der
   steht als Zeilenpreis ohnehin darueber.

   Die App kennt dafuer den Schalter "cartItemPriceOptions". Ihr Default steht
   hart auf true, wird beim Start der App aber aus Cloudlift.options.config.theme
   uebernommen. Wir setzen ihn dort, bevor die App startet - custom.js laeuft
   synchron im head vor content_for_header, window.Cloudlift gibt es hier also
   noch nicht. Deshalb zwei Netze: ein MutationObserver (feuert, sobald der
   Loader sein script-Tag einhaengt) und ein Intervall.

   Am Preis aendert das nichts: _cl_options_price wird weiterhin uebergeben,
   abgerechnet wird ueber den Draft Order der App. Nur die Anzeige entfaellt.
   =========================================================================== */
(function () {
  var fertig = false;

  function flaggeSetzen() {
    var config = window.Cloudlift && window.Cloudlift.options && window.Cloudlift.options.config;
    if (!config) return false;
    if (!config.theme) config.theme = {};
    config.theme.cartItemPriceOptions = false;
    return true;
  }

  if (flaggeSetzen()) return;

  var beobachter = new MutationObserver(pruefen);
  beobachter.observe(document.documentElement, { childList: true, subtree: true });

  var takt = setInterval(pruefen, 5);

  /* Nach 20 Sekunden ist die App entweder da oder sie kommt nicht mehr. */
  var frist = setTimeout(aufraeumen, 20000);

  function pruefen() {
    if (!fertig && flaggeSetzen()) aufraeumen();
  }

  function aufraeumen() {
    fertig = true;
    beobachter.disconnect();
    clearInterval(takt);
    clearTimeout(frist);
  }
})();


/* ===========================================================================
   Metallbau Odenthal - Preisuebersicht: Befestigungsart und Spitzenform
   Version 1.0.1 - 05.08.2026
   Gepflegte Quelle mit ausfuehrlicher Begruendung:
   Produktkonfigurator/Theme/mo_preisuebersicht_zeilen.js

   Die erste Zeile der Preisuebersicht heisst jetzt "Fenstergitter in der
   Laibung:" statt "Fenstergitter nach Maß:", und darunter steht eine eigene
   Zeile "Spitzenform: Spitze 1". Beides kommt wortwoertlich aus den gewaehlten
   Optionswerten; ist keine Spitzenform gewaehlt, gibt es die Zeile nicht.

   Wir schreiben EIGENE Attribute (data-mo-label / data-mo-wert), nicht die der
   Partner-Datei lpo_fenstergitter_v3.0_code.js: die setzt ihre bei jeder
   Neuberechnung zurueck, wer dieselben benutzt, kaempft gegen sie. Der Betrag
   rechts bleibt ihrer - an Zahlen aendert dieser Code nichts.

   Inhaltlich gehoert das in die Partner-Datei. Dort laesst sich eine
   bestehende Zeile aber nicht aendern, ohne die komplette Datei (rund 33.000
   Zeichen) neu zu speichern; im App-Editor kann man nur einfuegen, nicht
   ersetzen. Sobald die Datei aus anderem Anlass einmal vollstaendig neu
   hochgeladen wird, wandert dieser Block dorthin.
   =========================================================================== */
(function () {
  if (!window.MO_LPO_AKTIV) return;  /* LPO aus: Block ruht - siehe LPO-SCHALTER oben (26.09.2026) */
  var STIL =
    '.cl-po--price-summary .cl-po--price-summary-row[data-mo-label]::before{' +
    'content:attr(data-mo-label);font-size:13px;font-weight:500;color:#374151}' +
    '.cl-po--price-summary .cl-po--price-summary-row[data-mo-wert]::after{' +
    'content:attr(data-mo-wert);font-size:13px;font-weight:600;color:#111827;white-space:nowrap}' +
    '.cl-po--price-summary .mo-pu-zeile{display:flex;justify-content:space-between;' +
    'column-gap:10px;padding:3px 0}';

  function stilEinhaengen() {
    if (document.getElementById('mo-pu-stil')) return;
    var s = document.createElement('style');
    s.id = 'mo-pu-stil';
    s.textContent = STIL;
    (document.head || document.documentElement).appendChild(s);
  }

  /* Gewaehlter Wert einer Option, oder null. */
  /* ⚠️ 07.08.2026 — HAT DIESES GITTER UEBERHAUPT SPITZEN?
     Der Block "Spitzenform ausblenden" versteckt Gruppe und Option und
     deaktiviert die Felder, damit nichts in den Warenkorb geht. Was er NICHT
     aendert: `input:checked`. Die Vorauswahl "Spitze 1" bleibt gesetzt — LPO
     stellt sie ohnehin sofort wieder her — und gewaehlt() findet sie weiter.
     Ohne diese Pruefung baut die Preisuebersicht eine Zeile "Spitzenform:
     Spitze 1" fuer ein Gitter, das gar keine hat.
     ⚠️ Beim Nachmessen leicht zu uebersehen: Der Text der Zeile steht in
     ::before/::after, textContent liefert einen leeren String. */
  function moOhneSpitzen() {
    var t = document.querySelector('[data-mo-metafelder]');
    return !!t && t.getAttribute('data-hat-spitzen') === 'false';
  }
  function gewaehlt(option) {
    var o = document.querySelector('.cl-po--option[data-option="' + option + '"]');
    var i = o && o.querySelector('input:checked');
    return i && i.value ? i.value : null;
  }

  function kleinAmAnfang(t) {
    return t ? t.charAt(0).toLowerCase() + t.slice(1) : t;
  }

  /* Produktwort der Basiszeile. Vorher stand hier fest "Fenstergitter" — auf
     der Balkonseite las sich das als "Fenstergitter auf der Außenwand:".
     Kein Treffer heisst: das Wort entfaellt und die Zeile lautet nur noch
     "auf der Außenwand:". Lieber knapp als falsch. */
  /* ⚠️ 12.08.2026 — zwei Felder dazu, beide nur fuer Konfiguratoren mit EINEM
     Mass noetig:
       massName  Ueberschrift der Masszeile im Warenkorb. Die Option heisst in
                 ALLEN vier Configs intern "Maße" (seit der Handlauf umbenannt
                 wurde, damit die 15 CSS-Regeln greifen). Beim Handlauf gehoert
                 dort aber "Länge" hin — er hat kein zweites Mass.
       mindest   Text des "ab"-Hinweises unter der Preisuebersicht. Stand fest
                 auf "300 × 300 mm", dem Fenstergitter-Mindestmass. */
  var MO_KONFIG = window.MO_KONFIG = {
    cld1mz2nxbum: { wort: 'Fenstergitter',        bereich: '300 – 2200', mindest: '300 × 300 mm' }, /* 3.2, Testprodukt */
    clu4al1wbeiu: { wort: 'Fenstergitter',        bereich: '300 – 2200', mindest: '300 × 300 mm' }, /* 3.1 */
    clbitbebkhwi: { wort: 'Fenstergitter',        bereich: '300 – 2200', mindest: '300 × 300 mm' }, /* 1.2, Kundenseiten */
    clhhq7h0rl4m: { wort: 'Fenstergitter',        bereich: '200 – 2500', mindest: '200 mm' },       /* nur die Laenge */
    clzcvcioym0b: { wort: 'Französischer Balkon', bereich: '200 – 2500', mindest: '200 mm Breite' },/* FB 3.0 */
    clf2igcpiwur: { wort: 'Fensterstange',        bereich: '200 – 2500', mindest: '200 mm' },       /* Stangen 3.0 */
    clscy95tcugw: { wort: 'Handlauf',             bereich: '100 – 6000', mindest: '100 mm Länge',
                    massName: 'Länge' } /* Handlauf 3.0 */
  };
  function moKonfig() {
    var w = document.querySelector('.cl-po--wrapper');
    var t = w && w.closest('[id]');
    return (t && MO_KONFIG[t.id]) || {};
  }
  function moProduktwort() {
    var wort = moKonfig().wort;
    return wort ? wort + ' ' : '';
  }

  function pflegen() {
    var ps = document.querySelector('.cl-po--price-summary');
    var basis = ps && ps.querySelector('.cl-po--price-summary-base');
    if (!basis) return;

    /* 1. Basiszeile: "Fenstergitter in der Laibung:" statt "nach Maß" */
    var bef = gewaehlt('Befestigung');
    if (bef) {
      var label = moProduktwort() + kleinAmAnfang(bef) + ':';
      if (basis.getAttribute('data-mo-label') !== label) {
        basis.setAttribute('data-mo-label', label);
      }
    }

    /* 2. Eigene Zeile fuer die Spitzenform, direkt unter der Basiszeile */
    var spitze = moOhneSpitzen() ? null : gewaehlt('Spitzenform');
    var zeile = ps.querySelector('.mo-pu-zeile');

    if (!spitze) {
      if (zeile && zeile.parentNode) zeile.parentNode.removeChild(zeile);
      return;
    }
    if (!zeile) {
      zeile = document.createElement('div');
      zeile.className = 'cl-po--price-summary-row mo-pu-zeile';
      basis.parentNode.insertBefore(zeile, basis.nextSibling);
    }
    if (zeile.getAttribute('data-mo-label') !== 'Spitzenform:') {
      zeile.setAttribute('data-mo-label', 'Spitzenform:');
    }
    if (zeile.getAttribute('data-mo-wert') !== spitze) {
      zeile.setAttribute('data-mo-wert', spitze);
    }
  }

  function start() {
    stilEinhaengen();
    pflegen();

    var geplant = false;
    var beobachter = new MutationObserver(function () {
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(function () { geplant = false; pflegen(); });
    });
    beobachter.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-pu-label', 'data-pu-wert']
    });

    document.addEventListener('change', pflegen, true);

    /* Nachlauf fuer die ersten 12 Sekunden. Ohne ihn stand nach dem Laden noch
       "Fenstergitter nach Maß:", erst der erste Klick brachte die richtige
       Beschriftung: LPO setzt seine Vorauswahl ueber die checked-EIGENSCHAFT
       der Radios, nicht ueber das Attribut - das sieht kein MutationObserver,
       und ein change-Ereignis gibt es dabei auch nicht. */
    var versuche = 0;
    var takt = setInterval(function () {
      pflegen();
      if (++versuche >= 40) clearInterval(takt);
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


/* ===========================================================================
   Metallbau Odenthal - Farbauswahl: vier sichtbar, Rest unter "Weitere Farben"
   Version 1.0.2 - 05.08.2026
   Gepflegte Quelle mit ausfuehrlicher Begruendung:
   Produktkonfigurator/Theme/mo_farbauswahl_kompakt.js

   Die ersten vier Farbkacheln stehen immer offen da, die restlichen sieben
   liegen hinter einem eigenen Schalter "Weitere Farben (7)". Die Klappe der
   App ("Farbe auswaehlen") wird ausgeblendet und ihr Panel dauerhaft geoeffnet.

   Bis jetzt steckten alle elf Farben hinter der zugeklappten Zeile. Damit war
   auch die VORAUSGEWAEHLTE Farbe unsichtbar: der Kunde konfigurierte
   feuerverzinkt, ohne das je zu sehen. Bei einer Option, deren Aufpreis
   dreistellig werden kann, ist das der eigentliche Mangel - die Kompaktheit
   ist nur der Nebeneffekt.

   Waehlt jemand eine Sonderfarbe und klappt zu, waere sie nach der reinen
   "erste vier"-Regel wieder verschwunden. Deshalb die Ausnahme per
   :has(input:checked): die gewaehlte Sonderfarbe bleibt als fuenfte Kachel
   stehen, markiert, und der Schalter zaehlt eine Farbe herunter.

   Welche vier vorne stehen, entscheidet die REIHENFOLGE in der App
   (Fenstergitter version 3.0, Option "Oberflaeche") - sortiert man dort um,
   wandert die Vorauswahl automatisch mit. Hier steht nur die Zahl.

   !important ist Pflicht: die App setzt
   ".cl-po--group .cl-po--swatch-item{display:block!important}".
   max-height:0% haelt das Panel offen - so macht es die App selbst, eine
   Prozentangabe ohne definierte Elternhoehe wird ignoriert.
   =========================================================================== */
(function () {
  if (!window.MO_LPO_AKTIV) return;  /* LPO aus: Block ruht - siehe LPO-SCHALTER oben (26.09.2026) */
  /* Wieviele Kacheln stehen immer offen da. Reihenfolge kommt aus der App. */
  var SICHTBAR = 4;

  var OPT_FARBGRUPPE = 'Farbauswahl';
  var OPT_KACHELN = 'Oberfläche';

  var n = SICHTBAR + 1;
  var STIL =
    /* Klappe der App weg, ihr Panel dauerhaft offen */
    '.cl-po--option[data-option="' + OPT_FARBGRUPPE + '"] > .cl-po--collapse{display:none!important}' +
    '.cl-po--option[data-option="' + OPT_FARBGRUPPE + '"] > .cl-po--panel{max-height:0%!important;overflow:visible!important}' +
    /* ab der fuenften Kachel: aus ... */
    '.mo-farben > .cl-po--swatch-item:nth-child(n+' + n + '){display:none!important}' +
    /* ... ausser sie ist gewaehlt (die fuenfte Kachel) ... */
    '.mo-farben > .cl-po--swatch-item:nth-child(n+' + n + '):has(input:checked){display:block!important}' +
    /* ... oder der Kunde hat aufgeklappt */
    '.mo-farben.mo-offen > .cl-po--swatch-item:nth-child(n+' + n + '){display:block!important}' +
    /* Schalter, im Look der App-Klappe (dort 18px/#555, hier etwas kleiner) */
    '.mo-farben-schalter{display:flex!important;align-items:center;gap:6px;width:100%;' +
      'padding:10px 0;margin:2px 0 0;background:none;border:0;font:inherit;font-size:16px;' +
      'color:#555;cursor:pointer;text-align:left}' +
    '.mo-farben-schalter:hover{color:#111}' +
    '.mo-farben-schalter:focus-visible{outline:2px solid #ea5b0b;outline-offset:2px}' +
    '.mo-farben-schalter .mo-pfeil{display:inline-block;font-size:14px;line-height:1;' +
      'transition:transform .2s ease-out}' +
    '.mo-farben-schalter[aria-expanded="true"] .mo-pfeil{transform:rotate(90deg)}' +
    '.mo-farben-schalter .mo-zahl{color:#888;font-size:14px}' +
    /* Damit die vier Standardfarben eine VOLLE Reihe ergeben.
       Die App rechnet mit repeat(auto-fill,minmax(150px,1fr)). Bei einem
       Fenster von 1440px ist der Kachelbereich 597px breit - das reicht fuer
       drei Spalten a 150px, aber nicht fuer vier. Ergebnis waere 3+1: drei
       Kacheln oben, eine einsam darunter. Mit 140px passen vier hinein
       (142px je Kachel, mobil sind es 151px - also gut lesbar), die Reihe ist
       voll und der Block schrumpft von 248px auf 88px.
       Schmale Container bleiben unberuehrt: bei 377px ergeben sich weiter
       zwei Spalten, dann stehen die vier als 2+2. */
    '.cl-po--option[data-option="' + OPT_KACHELN + '"] .cl-po--swatch-container.mo-farben' +
      '{grid-template-columns:repeat(auto-fill,minmax(140px,1fr))!important}' +
    /* Innenabstand gleich wie in den anderen Kaesten.
       Am 05.08.2026 gemessen: im Maße-Kasten liegen zwischen Oberkante und
       Ueberschrift 19px (18px Padding der Option + 1px Rahmen). In der
       Farbgruppe waren es 43px, weil dort ZWEI Abstaende zusammenkamen:
       24px Innenabstand der Gruppe PLUS 18px Aussenabstand der Option.
       Mit padding-top:0 bleibt nur der 18px-Abstand der Option uebrig - macht
       19px, exakt wie beim Maße-Kasten. Unten dieselben 19px.
       Diese Regel gilt ueberall und ersetzt die fruehere Mobil-Sonderregel
       (padding 12px); sie spart auf dem Handy sogar mehr.
       Die Kacheln selbst sind Bilder im Format 400x250, ihre Hoehe folgt dem
       Seitenverhaeltnis - flacher ginge nur mit neuen Grafiken. */
    '.cl-po--option[data-option="' + OPT_FARBGRUPPE + '"] .cl-po--group' +
      '{padding-top:0!important;padding-bottom:18px!important}';

  function stilEinhaengen() {
    if (document.getElementById('mo-farben-stil')) return;
    var s = document.createElement('style');
    s.id = 'mo-farben-stil';
    s.textContent = STIL;
    (document.head || document.documentElement).appendChild(s);
  }

  /* Ueberlebt das Neurendern der App. */
  var offen = false;

  function beschriften(schalter, container) {
    var versteckt = 0;
    [].forEach.call(container.children, function (kachel, i) {
      var eingabe = kachel.querySelector('input');
      if (i >= SICHTBAR && !(eingabe && eingabe.checked)) versteckt++;
    });
    var text = offen ? 'Weniger Farben' : 'Weitere Farben';
    var zahl = offen ? '' : ' <span class="mo-zahl">(' + versteckt + ')</span>';
    var neu = '<span class="mo-pfeil">&#9656;</span>' + text + zahl;
    if (schalter.innerHTML !== neu) schalter.innerHTML = neu;
    schalter.setAttribute('aria-expanded', offen ? 'true' : 'false');
  }

  function pflegen() {
    var option = document.querySelector('.cl-po--option[data-option="' + OPT_KACHELN + '"]');
    if (!option) return;
    var container = option.querySelector('.cl-po--swatch-container');
    if (!container || container.children.length <= SICHTBAR) return;

    if (!container.classList.contains('mo-farben')) container.classList.add('mo-farben');
    container.classList.toggle('mo-offen', offen);

    var schalter = option.querySelector('.mo-farben-schalter');
    if (!schalter) {
      schalter = document.createElement('button');
      /* type="button" ist Pflicht - ohne ihn schickt der Klick das Formular ab. */
      schalter.type = 'button';
      schalter.className = 'mo-farben-schalter';
      schalter.addEventListener('click', function () {
        offen = !offen;
        container.classList.toggle('mo-offen', offen);
        beschriften(schalter, container);
      });
      container.parentNode.insertBefore(schalter, container.nextSibling);
    }
    beschriften(schalter, container);
  }

  function start() {
    stilEinhaengen();
    pflegen();

    var geplant = false;
    var beobachter = new MutationObserver(function () {
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(function () { geplant = false; pflegen(); });
    });
    beobachter.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('change', pflegen, true);

    /* Nachlauf fuer die ersten 12 Sekunden - gleicher Grund wie bei der
       Preisuebersicht: die App setzt ihre Vorauswahl ueber die checked-
       EIGENSCHAFT der Radios, nicht ueber das Attribut. */
    var versuche = 0;
    var takt = setInterval(function () {
      pflegen();
      if (++versuche >= 40) clearInterval(takt);
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


/* ===========================================================================
   Metallbau Odenthal - Maße-Tooltip: breiter statt gequetscht
   Version 1.2.0 - 07.08.2026
   1.1.1  Schliessen-Knopf im Grundzustand ausgeblendet (blieb beim Wechsel
          von Handy- auf Desktopbreite grau im Tooltip stehen), 85dvh und
          env(safe-area-inset-bottom) fuers Handy.
   1.1.0  Mobil: der Tooltip wird zum Panel am unteren Bildschirmrand ueber
          die volle Breite, mit abgedunkeltem Hintergrund und Schliessen-
          Knopf. Schrift 15px statt 13px.
   1.0.0  Desktop: 620px breit, Aufmaßbild links umflossen.
   1.1.0  Desktop: 760px breit, Bild oben ueber die volle Breite (max 62vh),
          Text darunter. Mobil unveraendert.

   AUSGELIEFERT IN: Theme "Version 2.01 / DeinMetallbauer.shop" (203215634764),
   angehaengt an assets/custom.js. Diese Datei hier ist die gepflegte Quelle.

   WAS

     DESKTOP                        MOBIL
     +--------------------------+   +---------------------+
     | [Aufmaß-] Bitte tragen   |   |                     |  <- abgedunkelt
     | [bild   ] Sie die Maße   |   |                     |
     | [       ] millimeter-    |   +---------------------+
     | [-------] genau ein. ... |   | [   Aufmaßbild   ] X|  <- volle Breite,
     +--------------------------+   | Bitte tragen Sie... |     am Boden
     620x423 (vorher 350x785)       +---------------------+
                                    375x687, Schrift 15px

   WARUM MOBIL EIN PANEL UND KEIN TOOLTIP
   Auf dem Handy ist der Bildschirm 375px breit - ein Tooltip mit Tippys
   Standardbreite 350px lag also praktisch schon an der Grenze, und mehr
   Breite gibt es nicht zu holen. Deshalb war die Schrift im info-Feld der
   Config mobil auf 13px/1.35 heruntergesetzt (statt 16px/1.45): damit der
   Kasten nicht zu hoch wird. Das war der Grund fuer den gequetschten
   Eindruck. Am 05.08.2026 durchgerechnet, wie teuer mehr Schrift waere:

     jetzt 13px            543px hoch = 67% des Bildschirms
     14px/1.45             621px      = 76%
     15px/1.5              681px      = 84%
     15px, Bild 140px hoch 557px      = 69%  (Bild dann nur 124px breit,
                                              Maßpfeile unlesbar)

   Jeder Millimeter Schrift zahlt direkt in Hoehe - im 350px-Korsett ist das
   nicht zu gewinnen. Als Panel am unteren Rand faellt das Korsett weg: volle
   375px Breite, der abgedunkelte Hintergrund macht klar, dass etwas
   geoeffnet ist, und 85% Bildschirmhoehe sind fuer ein bewusst geoeffnetes
   Panel normal - fuer einen Tooltip, der einem "passiert", waeren sie es
   nicht. Gemessen: 375x687, Bild 339px statt 300px, Schrift 15px, der
   Inhalt passt ohne Scrollen hinein.

   WIE DAS PANEL ENTSTEHT
   Ohne eigenes Overlay-JS: Tippy erzeugt das Element ohnehin, wir loesen nur
   seinen Wurzelknoten aus Poppers Positionierung (position:fixed,
   inset:auto 0 0 0, transform:none) und geben ihm volle Breite. Oeffnen,
   Schliessen und der Klick daneben bleiben Tippys Sache. Der abgedunkelte
   Hintergrund ist ein ::before am Wurzelknoten mit z-index:-1, also auch
   kein zusaetzliches Element.

   WARUM DER X-KNOPF PER JS KOMMT
   Ein Panel ohne sichtbaren Ausgang laesst Kunden ratlos zurueck - Tippys
   Klick-daneben allein reicht nicht. Der Knopf wird beim Oeffnen eingehaengt
   und ruft die Tippy-Instanz am Info-Symbol auf (ico._tippy.hide()).
   Achtung beim Nachpruefen: nach hide() bleibt die Box noch rund 300ms im
   DOM (Ausblendanimation) - wer sofort danach misst, haelt sie faelschlich
   fuer offen.

   WARUM !important
   Die 350px kommen NICHT aus einem Stylesheet, sondern stehen als
   Inline-Style an der .tippy-box ("max-width: 350px"). Tippy.js setzt das
   per JS, 350px ist sein Standardwert. Dasselbe gilt fuer die Position am
   Wurzelknoten, die Popper laufend nachfuehrt. Gegen Inline-Styles hilft nur
   !important - Spezifitaet allein reicht nicht.

   WARUM .tippy-content > img UND NICHT .mass-tooltip img
   Das Aufmaßbild steht NICHT im <div class="mass-tooltip"> aus der Config,
   sondern davor: die Partner-Datei haengt es beim Oeffnen als erstes Kind an
   .tippy-content ("<img ...><style>...<div class=mass-tooltip>"). Eine Regel
   ".mass-tooltip img" trifft es deshalb nicht - am 05.08.2026 genau so
   danebengegriffen. Das Bild traegt zudem sein eigenes inline
   "max-width:300px", auch hier ist !important noetig.

   WARUM :has(.mass-tooltip) UND NICHT .tippy-box
   Der Konfigurator benutzt Tippy auch fuer die Farbkacheln und die
   Befestigungsbilder. Die sind klein (gemessen 136x36) und sollen bleiben
   wie sie sind. Die Klasse .mass-tooltip steht im info-HTML der Option
   "Maße" und kommt nur dort vor.

   WARUM IM THEME UND NICHT IN DER APP
   Der <style>-Block im info-Feld wird erst mit dem Tooltip-Inhalt eingefuegt.
   Tippy misst seine Breite aber beim Oeffnen - eine Regel, die erst danach
   ankommt, ergaebe im ersten Moment eine falsche Position. Aus dem Theme
   heraus steht sie von Anfang an im Dokument. Gleiches Vorgehen wie bei
   mo_farbauswahl_kompakt.js.
   =========================================================================== */
(function () {
  if (!window.MO_LPO_AKTIV) return;  /* LPO aus: Block ruht - siehe LPO-SCHALTER oben (26.09.2026) */
  var STIL =
    /* Grundzustand des Schliessen-Knopfes: unsichtbar. Er wird nur mobil
       eingehaengt, aber Tippy verwendet seinen Knoten wieder - wer das
       Fenster danach breiter zieht oder das Tablet dreht, haette sonst
       einen grauen, unformatierten x-Knopf im Tooltip stehen. Am
       05.08.2026 genau so vorgefunden: 12x19px, hellgrau, mitten im Text. */
    '.mo-tip-zu{display:none!important}' +

    /* Die Skizze SIEHT anklickbar aus ("Zum Vergroessern" steht darunter), war
       es auf dem Desktop aber nicht: Tippy lief mit dem Standardausloeser
       'mouseenter focus'. cursor:help sagte zusaetzlich das Falsche - das ist
       der Zeiger fuer eine Worterklaerung, nicht fuer eine Lupe. */
    '.cl-po--info{cursor:zoom-in!important}' +

    /* ---------- Desktop: zentriertes Fenster ----------
       v1.2.0 (10.08.2026). v1.1.0 stellte das Bild ueber den Text und deckelte
       es auf 62vh. Auf grossen Schirmen wurde daraus ein Kasten von 758x1093px
       (gemessen bei 1917x1317) — hoeher als der halbe Bildschirm, und Popper
       schob ihn oben aus dem Bild heraus, weil der Ausloeser weit oben sitzt.

       Deshalb jetzt derselbe Weg wie mobil: aus Poppers Positionierung loesen
       und selbst setzen — nur eben in die Mitte statt an den unteren Rand. Ein
       Fenster, das seine Position kennt, kann nicht mehr herausragen; der
       Anker unter dem Ausloeger entfaellt und mit ihm der Zeiger.

       Bild und Text stehen nebeneinander statt uebereinander. Das halbiert die
       Hoehe und nutzt die Breite, die auf dem Desktop ohnehin da ist. */
    '@media screen and (min-width:750px){' +
      '[data-tippy-root]:has(.mass-tooltip){position:fixed!important;' +
        'top:50%!important;left:50%!important;right:auto!important;bottom:auto!important;' +
        'transform:translate(-50%,-50%)!important;z-index:99999!important}' +
      /* Abgedunkelter Hintergrund - ohne zusaetzliches Element, wie mobil. */
      '[data-tippy-root]:has(.mass-tooltip)::before' +
        '{content:"";position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:-1}' +
      /* 14.08.2026: 980 -> 1500px, auf Stefans Wunsch ("koennen wir das noch
         groesser machen"). Das Bild nimmt im Zweispalter die halbe Breite: bei
         980px waren das gemessene 462px fuer eine Zeichnung mit Bemassung, bei
         1500px sind es rund 720px. Die Deckelung auf Bildschirmbreite steigt
         von 92 auf 94vw — bei 1280px Fenster aendert das nichts Sichtbares,
         weil dort ohnehin die vw-Grenze greift, auf grossen Schirmen wirkt die
         1500. Hoehe unveraendert: 88vh an der Box, 74vh am Bild; auf flachen
         Fenstern bleibt die Hoehe die Grenze und das Bild wird proportional
         schmaler statt abgeschnitten. */
      /* ⚠️ `width` ZUSAETZLICH zu `max-width` — sonst passiert fast nichts.
         Am 14.08.2026 gemessen: mit max-width:1500 allein blieb die Box bei
         1154px stehen, weil Tippy die Breite dem Inhalt ueberlaesst und
         max-width nur eine Obergrenze ist. Erst `width` fuellt sie aus; das
         Bild waechst damit von 462 ueber 549 auf rund 720px. */
      '.tippy-box:has(.mass-tooltip){max-width:min(1500px,94vw)!important;' +
        'width:min(1500px,94vw)!important;' +
        'max-height:88vh!important;display:flex!important;flex-direction:column!important}' +
      /* Der Zeiger zeigt ins Leere, sobald das Fenster nicht mehr am
         Ausloeser haengt. */
      '.tippy-box:has(.mass-tooltip) .tippy-arrow{display:none!important}' +
      /* Sicherheitsnetz bleibt: passt es einmal nicht, scrollt der Inhalt. */
      '.tippy-box:has(.mass-tooltip) .tippy-content{overflow-y:auto!important}' +
      '.tippy-box:has(.mass-tooltip) .tippy-content>img' +
        '{float:none!important;display:block!important;width:100%!important;' +
        'max-width:100%!important;max-height:74vh!important;height:auto!important;' +
        'object-fit:contain!important;margin:0!important;border-radius:6px}' +
      '.tippy-box:has(.mass-tooltip) .mass-tooltip{max-width:none;margin:0}' +
    '}' +

    /* Zwei Spalten erst ab 990px. Zwischen 750 und 989 stuenden dem Text sonst
       rund 300px zu - dort bleibt es einspaltig, nur eben zentriert. */
    '@media screen and (min-width:990px){' +
      '.tippy-box:has(.mass-tooltip) .tippy-content' +
        '{display:grid!important;grid-template-columns:minmax(0,1fr) minmax(0,1fr)!important;' +
        'gap:24px!important;align-items:start!important}' +
    '}' +

    /* ---------- Mobil: Panel am unteren Rand ---------- */
    '@media screen and (max-width:749px){' +
      /* Aus Poppers Positionierung loesen und unten andocken. */
      '[data-tippy-root]:has(.mass-tooltip){position:fixed!important;inset:auto 0 0 0!important;' +
        'transform:none!important;width:100%!important;max-width:100%!important;z-index:99999!important}' +
      /* Abgedunkelter Hintergrund - ohne zusaetzliches Element. */
      '[data-tippy-root]:has(.mass-tooltip)::before' +
        '{content:"";position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:-1}' +
      /* 85vh als Deckel: passt der Text einmal nicht mehr, scrollt er im
         Panel, statt oben aus dem Bildschirm zu laufen. dvh dahinter, weil
         vh auf dem Handy die Adressleiste mitzaehlt, die beim Scrollen
         ein- und ausfaehrt - dvh rechnet mit dem, was gerade zu sehen ist.
         Kennt der Browser dvh nicht, bleibt es bei der Zeile davor. */
      '.tippy-box:has(.mass-tooltip){max-width:100%!important;width:100%!important;' +
        'border-radius:14px 14px 0 0!important;max-height:85vh!important;' +
        'display:flex!important;flex-direction:column!important}' +
      '.tippy-box:has(.mass-tooltip){max-height:85dvh!important}' +
      /* env(safe-area-inset-bottom): auf iPhones liegt unten der
         Home-Indicator. Ohne diesen Zuschlag stuende der letzte Satz
         darunter. */
      '.tippy-box:has(.mass-tooltip) .tippy-content' +
        '{overflow-y:auto!important;' +
        'padding:18px 18px calc(24px + env(safe-area-inset-bottom,0px))!important}' +
      /* Der Zeiger ergibt bei einem Panel am Bildschirmrand keinen Sinn. */
      '.tippy-box:has(.mass-tooltip) .tippy-arrow{display:none!important}' +
      /* Die 13px/1.35 aus dem info-Feld der Config zuruecknehmen. */
      '.mass-tooltip{font-size:15px!important;line-height:1.5!important}' +
      '.mass-tooltip p{margin-bottom:12px!important}' +
      '.tippy-box:has(.mass-tooltip) .tippy-content>img' +
        '{max-width:100%!important;margin:0 0 14px!important}' +
      '.mo-tip-zu{position:absolute!important;top:8px;right:8px;z-index:2;width:34px;height:34px;' +
        'display:flex!important;align-items:center;justify-content:center;' +
        'background:rgba(255,255,255,.16);border:0;border-radius:50%;color:#fff;' +
        'font-size:22px;line-height:1;padding:0;cursor:pointer}' +
      '.mo-tip-zu:focus-visible{outline:2px solid #fff;outline-offset:2px}' +
    '}';

  var INFO = '.cl-po--option[data-option="Maße"] .cl-po--info';

  function stilEinhaengen() {
    if (document.getElementById('mo-masse-tip-stil')) return;
    var s = document.createElement('style');
    s.id = 'mo-masse-tip-stil';
    s.textContent = STIL;
    (document.head || document.documentElement).appendChild(s);
  }

  function knopfEinhaengen() {
    if (!matchMedia('(max-width:749px)').matches) return;
    var boxen = document.querySelectorAll('.tippy-box');
    for (var i = 0; i < boxen.length; i++) {
      var box = boxen[i];
      if (!box.querySelector('.mass-tooltip')) continue;
      if (box.querySelector('.mo-tip-zu')) continue;
      var b = document.createElement('button');
      b.type = 'button';   /* ohne ihn schickt der Klick das Formular ab */
      b.className = 'mo-tip-zu';
      b.innerHTML = '&times;';
      b.setAttribute('aria-label', 'Schließen');
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var ico = document.querySelector(INFO);
        if (ico && ico._tippy) ico._tippy.hide();
        else if (ico) ico.click();
      });
      box.appendChild(b);
    }
  }

  /* ⚠️ 14.08.2026 — DAS BILD IM TOOLTIP KAM IN 800 px.
     Die Adresse baut das LPO-Design-JS aus [data-aufmass-bild-*], und die
     traegt aus main-product.liquid ein "width=800". Fuer die kleine Skizze
     neben den Maßfeldern (150-320px) ist das genau richtig, und dort soll es
     auch bleiben — die Seite laedt sonst das Vierfache an Bytes fuer nichts.
     Im vergroesserten Tooltip ist dieselbe Datei aber 460 bis 720px breit: bei
     doppelter Pixeldichte sichtbar weich, und mit der Verbreiterung auf 1500px
     waere es schlechter geworden statt besser. Das Original misst 2048 x 1825
     (am 14.08.2026 gemessen), Reserve ist also da.
     Deshalb wird NUR im geoeffneten Tooltip auf 1600 hochgezogen. Der Browser
     holt die Datei einmal nach und cacht sie; das data-mo-gross verhindert,
     dass bei jedem Beobachterlauf neu geladen wird.
     ⚠️ NICHT das data-tippy-content anfassen: Auf dem Attribut sitzt der
     MutationObserver der Partner-Datei (Aufmaß-Skizze). Wer es beschreibt,
     baut sich eine Rueckkopplung. Deshalb erst am fertigen <img> in der Box.
     ⚠️ getAttribute('src'), nicht .src — die Adresse ist protokollrelativ
     ("//www.deinmetallbauer.shop/…"); .src liefert sie absolut zurueck und
     wuerde beim Zurueckschreiben das Protokoll festnageln. */
  function bildScharf() {
    var boxen = document.querySelectorAll('.tippy-box');
    for (var i = 0; i < boxen.length; i++) {
      var box = boxen[i];
      if (!box.querySelector('.mass-tooltip')) continue;
      var img = box.querySelector('img');
      if (!img || img.getAttribute('data-mo-gross') === '1') continue;
      /* ⚠️ MOBIL NICHT NACHLADEN. Am 14.08.2026 bei 375px gemessen: das Bild
         im Tooltip steht dort auf display:none — die Regel kommt aus der App
         (app-options.css), nicht von uns. Ohne diese Zeile holt das Handy ein
         1600px-Bild, das niemand zu sehen bekommt. Der Test fragt das
         gerenderte Ergebnis ab statt eine Breite, damit er auch stimmt, wenn
         die App ihre Regel einmal aendert. */
      if (getComputedStyle(img).display === 'none') continue;
      var alt = img.getAttribute('src') || '';
      var neu = alt.replace(/([?&]width=)\d+/, '$11600');
      if (neu !== alt) img.setAttribute('src', neu);
      img.setAttribute('data-mo-gross', '1');
    }
  }

  /* Auf dem Desktop war die Skizze nur ein Hover-Ziel. Tippy laeuft mit dem
     Standardausloeser 'mouseenter focus'; ein Klick tat nachweislich nichts
     (07.08.2026 gemessen: Instanz vorhanden, nach dem Klick keine Box).
     Wer ein Bild mit "Zum Vergroessern" darunter sieht, klickt aber darauf.
     Den Ausloeser zu erweitern ist besser als ein eigener Klick-Weg: Tippy
     regelt Hover und Klick zusammen, sonst schliesst der Klick, was der Hover
     gerade geoeffnet hat. */
  function klickbarMachen() {
    var ico = document.querySelector(INFO);
    if (!ico || !ico._tippy) return false;
    if (ico.getAttribute('data-mo-klick') === '1') return true;
    ico._tippy.setProps({ trigger: 'mouseenter focus click', hideOnClick: true });
    ico.setAttribute('data-mo-klick', '1');
    return true;
  }

  function start() {
    stilEinhaengen();

    /* Die App baut das Info-Symbol erst nach dem Rendern; bis zu 10s warten,
       danach steht es oder es gibt keins. */
    var versuche = 0;
    var takt = setInterval(function () {
      if (klickbarMachen() || ++versuche > 40) clearInterval(takt);
    }, 250);

    /* Kein Dauerbeobachter: der Knopf wird nur gebraucht, wenn jemand das
       Info-Symbol antippt. Zwei Anlaeufe, weil Tippy die Box erst nach dem
       Klick einhaengt - der erste Frame kommt manchmal zu frueh. */
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest(INFO)) return;
      klickbarMachen();          // falls die App die Instanz ersetzt hat
      requestAnimationFrame(knopfEinhaengen);
      setTimeout(knopfEinhaengen, 80);
      requestAnimationFrame(bildScharf);
      setTimeout(bildScharf, 80);
    }, true);

    /* Der Tooltip oeffnet auch per Hover — der Klick-Weg oben wuerde das grosse
       Bild dabei nie nachladen. `mouseover` statt `mouseenter`, weil nur ersteres
       aufsteigt und sich damit an document haengen laesst. Zwei Anlaeufe wie
       oben: Tippy haengt die Box erst nach dem Ereignis ein. */
    document.addEventListener('mouseover', function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest(INFO)) return;
      requestAnimationFrame(bildScharf);
      setTimeout(bildScharf, 80);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/* ===========================================================================
   Metallbau Odenthal - Preisuebersicht unter das Bild holen
   Version 1.2.0 - 06.08.2026
   Gepflegte Quelle mit ausfuehrlicher Begruendung:
   Produktkonfigurator/Theme/mo_uebersicht_unter_bild.js

   Holt die Preisuebersicht der App - die Option vom Typ price-summary,
   also die ganze .cl-po--option mit ihrer Ueberschrift - aus der rechten
   Spalte in den Behaelter unter dem Produktbild
   (snippets/product-below-media.liquid).

   Bis 1.1.0 kam die Box "Ihre Auswahl" (#cl-po--summary-container) der
   Partner-Datei als zweiter Block mit - Mass, Preis pro Stueck, Gesamtpreis
   und Druckknopf. Seit 1.2.0 wird sie stattdessen weggeraeumt, siehe
   Punkt 5 weiter unten. Im Behaelter steht damit nur noch die
   Preisuebersicht mit ihren Einzelzeilen.

   Warum ein Umhaenger und nicht die App selbst: die Optionsliste rendert die
   App an einer festen Stelle im Produktformular, an ihrer Position laesst
   sich in der App nichts einstellen. Die Partner-Datei
   lpo_fenstergitter_v3.0_code.js zu aendern hiesse, sie komplett (rund 33.000
   Zeichen) neu hochzuladen - im App-Editor laesst sich nur einfuegen, nicht
   ersetzen. Hier genuegen ein paar Zeilen, und die Partner-Datei bleibt
   unberuehrt.

   Vier Dinge, die den Umhaenger sonst scheitern lassen:

   1. Es gibt ZWEI Behaelter im Theme (Bild links / Bild rechts), von denen
      immer nur einer sichtbar ist. Welcher, entscheidet offsetParent - ein
      ausgeblendeter hat keinen. Damit das ueberhaupt funktioniert, muss der
      leere Behaelter sichtbar bleiben; das Theme versteckt sonst alle leeren
      Elemente (div:empty), siehe assets/section-main-product.css.

   2. Die App rendert ihre Optionen bei Bedarf neu. Dann entsteht die
      Preisuebersicht ein zweites Mal an ihrem alten Platz, waehrend die
      verschobene als Leiche im Behaelter zurueckbleibt. Deshalb gilt: die
      Instanz AUSSERHALB des Behaelters ist immer die frische - sie kommt
      herein, alle aelteren im Behaelter fliegen raus.

   3. Ohne den Guard parentElement !== ziel loest jedes Verschieben den
      Beobachter erneut aus und der Umhaenger triggert sich selbst -
      Endlosschleife.

   4. Die App baut ihre Box erst nach dem eigenen Rendern und ruft
      placeSummaryContainer nach 500ms noch einmal auf. Ein Umhaenger, der nur
      bei DOMContentLoaded laeuft, verliert dieses Rennen. Daher Beobachter
      plus 12-Sekunden-Nachlauf, wie beim Farbschalter weiter oben.

   5. Warum die Box umgehaengt und nicht ausgeblendet wird (ab 1.2.0).

      Auf #cl-po--summary-container laesst sich display mit KEINER
      Stylesheet-Regel ueberschreiben. Nachgemessen am 06.08.2026: eine
      eigene Regel mit ID-Selektor und !important setzt auf demselben
      Element outline und height klaglos durch, display aber nicht.
      Deshalb wirkt auch das display:none!important nicht, das im
      Design-CSS der App seit dem 04.08.2026 steht (Abschnitt 22).
      Nur eine Inline-Deklaration mit Prioritaet greift, also
      style.setProperty("display", "none", "important").

      Die taugt hier aber nicht: updateSummary() der Partner-Datei
      lpo_fenstergitter_v3.0_code.js setzt bei JEDER Preisaenderung
      style.display = "block" (Zeile 1369) und loescht damit die
      Prioritaet gleich wieder mit. Ein Wettlauf um dasselbe Attribut.

      Ein unsichtbarer Elternknoten umgeht beides: was in der Box steht,
      spielt keine Rolle, wenn der Behaelter nicht angezeigt wird. Die Box
      selbst bleibt dabei im Dokument - updateSummary() schreibt weiter in
      #cl-po--total-price und #cl-po--masse-wert und findet beide. Sie zu
      loeschen waere die naheliegende Alternative, liesse diese Zugriffe
      aber ins Leere laufen.

      Rueckbau: den Ablage-Block unten wieder durch z.appendChild(box)
      ersetzen und Abschnitt 3 aus 1.1.0 zurueckholen (Theme-Changelog,
      Eintrag vom 06.08.2026).

   Der Beobachter der Partner-Datei haengt an .cl-po--wrapper. Aendert der
   Kunde etwas, feuert er weiterhin - die Funktion, die die Zeilen umbaut,
   sucht die Preisuebersicht global und findet sie auch nach dem Umzug.
   =========================================================================== */
(function () {
  if (!window.MO_LPO_AKTIV) return;  /* LPO aus: Block ruht - siehe LPO-SCHALTER oben (26.09.2026) */
  var ERSATZ_ID = 'mo-below-media-ersatz';
  var UNTEN_ID  = 'mo-preisbox-unten';

  /* MOBIL STEHT DIE PREISUEBERSICHT UNTER DEM KONFIGURATOR (1.4.0, 20.08.2026)

     Stefan: "beim Farbe auswaehlen springt das noch runter."

     GEMESSEN bei 375 x 812 an fenstergitter-01: Die Box steht mobil OBERHALB
     des Konfigurators (Box top 663, Konfigurator top 1370), weil die
     Live-Preview der App den Behaelter aus dem Bildbereich ausraeumt und
     stattdessen #mo-below-media-ersatz im .product__media-wrapper entsteht.
     Waehlt der Kunde eine RAL-Farbe, kommen zwei Zeilen dazu
     ("Zusatzoptionen:" und "Farbauswahl: (RAL 7016) 50,00 EUR"), die Box
     waechst 254 -> 336 px, und ALLES darunter rutscht 82 px nach unten.

     Das trifft nicht nur die Farbe: jede Option mit Aufpreis fuegt hier eine
     Zeile ein. Deshalb wandert die Box mobil ans ENDE des Konfigurators. Was
     unter dem letzten Schritt waechst, verschiebt nichts mehr, was der Kunde
     gerade bearbeitet - der Sprung ist damit an der Wurzel weg, fuer jede
     Option.

     Den Preis verliert der Kunde dabei nicht aus den Augen: die klebende
     Schrittleiste traegt ihn oben mit ("ab 238,00 EUR").

     AM RECHNER UNVERAENDERT - dort steht die Box weiterhin unter dem Bild.

     Kein Scroll-Ausgleich, aus demselben Grund wie im Block AUFMASSBILD
     (v2.0.0): der ersetzt einen Sprung nur durch einen zweiten.

     ⚠ Dieser Behaelter traegt BEWUSST KEIN data-below-media. Die Schleife in
     ziel() sucht danach; ein zweiter Treffer wuerde je nach Reihenfolge mal
     hier, mal oben landen. */
  function schmal() { return window.matchMedia('(max-width: 749px)').matches; }

  function unten() {
    if (!document.querySelector('.cl-po--price-summary')) return null;
    var w = document.querySelector('.cl-po--wrapper');
    if (!w || w.offsetParent === null) return null;
    var e = document.getElementById(UNTEN_ID);
    if (!e) {
      e = document.createElement('div');
      e.id = UNTEN_ID;
      e.style.display = 'block';
    }
    /* Guard wie bei ersatz(): ohne ihn haengt jeder Durchlauf neu an und
       loest die naechste Mutation aus. */
    if (e.parentElement !== w) w.appendChild(e);
    return e;
  }

  /* Der sichtbare der beiden Behaelter, oder null.

     Ab 1.3.0 mit Rueckfallebene fuer die Live-Preview der App: Ist sie
     aktiv, ersetzt die App den kompletten Inhalt von
     .product__media-wrapper durch ihre eigene Galerie - und nimmt den
     Behaelter aus snippets/product-below-media.liquid mit. Dann findet die
     Schleife nichts, und die Preisuebersicht bleibt in der rechten Spalte
     stehen (gemessen am 10.08.2026 auf test2: x=1042 statt x=392).
     In dem Fall legen wir selbst einen an. */
  function ziel() {
    /* Mobil hat der Behaelter unter dem Konfigurator Vorrang - siehe 1.4.0
       im Kopf dieses Blocks. */
    if (schmal()) { var u = unten(); if (u) return u; }
    var alle = document.querySelectorAll('[data-below-media]');
    for (var i = 0; i < alle.length; i++) {
      if (alle[i].offsetParent !== null) return alle[i];
    }
    /* Nur wenn es ueberhaupt etwas zu verschieben gibt - sonst stuende auf
       jeder Seite ohne Konfigurator ein leeres div im Bildbereich. */
    if (!document.querySelector('.cl-po--price-summary')) return null;
    return ersatz();
  }

  /* Behaelter ans Ende des sichtbaren .product__media-wrapper, also unter
     die Galerie der App.

     ⚠ display:block ist Pflicht, nicht Kosmetik. Das Theme versteckt leere
     Elemente (div:empty in assets/section-main-product.css), und leer ist
     der Behaelter in der Sekunde, in der er entsteht. Ohne die Zeile bleibt
     offsetParent null, und die Schleife oben uebergeht beim naechsten
     Durchlauf den eigenen Behaelter - am 10.08.2026 genau so gemessen. */
  function ersatz() {
    var mw = null;
    var wrapper = document.querySelectorAll('.product__media-wrapper');
    for (var i = 0; i < wrapper.length; i++) {
      if (wrapper[i].offsetParent !== null) { mw = wrapper[i]; break; }
    }
    if (!mw) return null;

    var e = document.getElementById(ERSATZ_ID);
    if (!e) {
      e = document.createElement('div');
      e.id = ERSATZ_ID;
      e.setAttribute('data-below-media', '');
      e.style.display = 'block';
    }
    /* Der Guard haelt den Beobachter ruhig: Ohne ihn haengt jeder Durchlauf
       das Element erneut an, das loest die naechste Mutation aus, und der
       Umhaenger triggert sich selbst. */
    if (e.parentElement !== mw) mw.appendChild(e);
    return e;
  }

  /* Die ganze Option, damit die Ueberschrift "Preisuebersicht" mitkommt. */
  function alsOption(el) {
    return el.closest('.cl-po--option') || el;
  }

  function pflegen() {
    var z = ziel();
    if (!z) return;

    /* --- 1. Preisuebersicht der App --- */
    var frisch = null;
    var alle = document.querySelectorAll('.cl-po--price-summary');
    for (var i = 0; i < alle.length; i++) {
      if (!z.contains(alle[i])) { frisch = alsOption(alle[i]); break; }
    }
    if (frisch) {
      /* Leichen einer frueheren Runde entfernen */
      var drin = z.querySelectorAll('.cl-po--price-summary');
      for (var j = 0; j < drin.length; j++) {
        var alt = alsOption(drin[j]);
        if (alt !== frisch && alt.parentElement === z) z.removeChild(alt);
      }
      z.insertBefore(frisch, z.firstChild);
    }

    /* --- 2. Box "Ihre Auswahl" wegraeumen (Wunsch vom 06.08.2026) ---
       Nicht loeschen, nur unsichtbar parken - Begruendung im Kopf, Punkt 5. */
    var box = document.getElementById('cl-po--summary-container');
    if (box) {
      var ablage = document.getElementById('mo-ablage');
      if (!ablage) {
        ablage = document.createElement('div');
        ablage.id = 'mo-ablage';
        ablage.style.display = 'none';
        document.body.appendChild(ablage);
      }
      if (box.parentElement !== ablage) ablage.appendChild(box);
    }
  }

  function start() {
    pflegen();

    var geplant = false;
    var beobachter = new MutationObserver(function () {
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(function () { geplant = false; pflegen(); });
    });
    beobachter.observe(document.body, { childList: true, subtree: true });

    var versuche = 0;
    var takt = setInterval(function () {
      pflegen();
      if (++versuche >= 40) clearInterval(takt);
    }, 300);

    /* Dreht der Kunde das Geraet oder aendert sich die Breite, muss die Box
       die Seite wechseln. pflegen() entscheidet das in ziel() jedes Mal neu,
       laeuft nach dem Takt aber nur noch auf DOM-Aenderungen - ein
       Breitenwechsel allein ist keine. */
    addEventListener('resize', pflegen);
    addEventListener('orientationchange', pflegen);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


/* ============================================================================
 * SCHRITT-FUEHRUNG im Fenstergitter-Konfigurator           v2.17.0
 * Config:  Fenstergitter version 3.1  (clu4al1wbeiu)
 * Theme:   Version 2.01 / DeinMetallbauer.shop (ID 203215634764)
 * Ort:     assets/custom.js — ⚠️ NICHT mehr der letzte Block: seit dem
 *          07.08.2026 folgt dahinter "Aufmaß-Skizze folgt der
 *          Befestigungsart". Zum Austauschen also herausschneiden
 *          (Substring mit Laenge), nicht anhaengen.
 * Stand:   07.08.2026
 *
 * WAS ES TUT — sechs Dinge, die die App nicht liefert:
 *   1. Beim Laden ist nur Schritt 1 offen, der Rest zu.
 *   2. AKKORDEON: Es ist immer nur ein Schritt offen. Wer einen anderen
 *      antippt, schliesst damit den vorherigen. Zuklappen bleibt moeglich.
 *   3. Der gewaehlte Wert steht in der Kopfzeile, damit ein zugeklappter
 *      Schritt trotzdem etwas aussagt: "1. Befestigungsart / In der Laibung".
 *   4. SCHRITTLEISTE unter der Preisuebersicht: "Schritt 2 von 5", eine
 *      Punktekette zum Anspringen und ein Weiter-Knopf.
 *   5. Auf dem Handy sitzt die Leiste am Ende der Optionsliste, also direkt
 *      ueber dem Kaufknopf — dort, wo die Preisuebersicht ausgeblendet ist.
 *   6. "AB"-PREIS: Solange die Maße fehlen, steht vor Produktpreis, Sticky-
 *      Preis und Gesamtsumme ein "ab". Seit die Maßfelder leer starten
 *      (App-Stand 06.08.2026) zeigt LPO dort 280,00 EUR — das ist der reine
 *      Variantenpreis. Er ist kein Fantasiewert: Die Preisformel lautet
 *      grundpreis + faktor * (area - 90000), das Mindestmaß ist 300 x 300 mm
 *      = genau 90.000 mm². 280,00 EUR ist also exakt der Preis des kleinsten
 *      bestellbaren Gitters — niemand kommt darunter, "ab" stimmt wortwoertlich.
 *
 * NEU IN 2.3.0 (06.08.2026)
 *   a) FEHLER BEHOBEN: getippte Maße liessen "ab" und den Hinweis stehen.
 *      preisHinweis() haing nur am Klick-Weg (80/400ms). Wer die Maße
 *      eintippt, loest nur 'input' aus — und dort lief die Pruefung nicht mit.
 *      Folge im Laden: Der Kunde traegt 1000 x 500 ein, der Preis steht
 *      vollstaendig da, darueber aber weiter "ab €300,31" und darunter
 *      "bitte tragen Sie Ihre Maße ein". Weggeklickt hat sich das erst, wenn
 *      er zufaellig noch irgendwo in den Konfigurator geklickt hat. Am
 *      06.08.2026 im Vorschau-Theme nachgestellt: nach reinem 'input' blieben
 *      der Hinweis und fuenf .mo-ab-preis stehen, nach einem Klick auf "+"
 *      waren beide weg. preisHinweis() laeuft jetzt auch in aufAenderung().
 *   b) PLATZHALTER "B×H = bitte Maß unten eintragen" in der Kopfzeile,
 *      solange ein Pflichtfeld des Schritts leer ist — siehe werteSchreiben().
 *   c) HAKEN SCHON BEIM AUFKLAPPEN, nicht erst beim Verlassen — siehe den
 *      Klick-Weg in start().
 *   d) HAKEN AUCH BEI EINEM KLICK AUF DIE SCHON GEWAEHLTE KACHEL. Ein Klick
 *      auf einen bereits gesetzten Radiobutton feuert KEIN change — wer auf
 *      das vorausgewaehlte "Feuerverzinkt" tippt, bestaetigt seine Wahl also
 *      fuer die Seite unsichtbar. Ohne Haken sieht das aus, als ginge der
 *      Klick ins Leere. Der allgemeine Klick-Weg merkt sich den Schritt jetzt
 *      genauso wie aufAenderung().
 *
 * WARUM DER HAKEN "DU WARST HIER" BEDEUTET UND NICHT "HAT EINEN WERT"
 * Jeder Schritt ausser den Maßen ist vorbelegt (Aussenwand, Spitze 1,
 * feuerverzinkt, ohne Befestigungsmittel; die Maße starten seit dem
 * 06.08.2026 leer). Haengt der Haken an :has(input:checked), stehen ab
 * der ersten Sekunde fuenf Haken da und die Leiste meldet sofort "vollstaendig"
 * — ein Fortschritt, der beim Laden schon voll ist, sagt nichts aus.
 * Deshalb setzt dieses Skript die Klasse .mo-besucht, sobald der Kunde einen
 * Schritt verlaesst oder darin etwas aendert. Das CSS in assets/custom.css
 * (Abschnitte 25 und 26) haengt den Haken weiterhin an :has(input:checked) und
 * .mo-erledigt — deshalb neutralisiert der Stilblock unten beides fuer noch
 * nicht besuchte Schritte. Er muss dazu SPEZIFISCHER sein als das Theme-CSS:
 * dessen Regel ist (1,4,2), unsere mit dem zusaetzlichen [data-option] (1,5,1).
 * b schlaegt c, also gewinnt sie. Nebeneffekt, der so gewollt ist: Der Kunde
 * geht durch alle Schritte und sieht dabei die Aufpreis-Optionen.
 *
 * OFFENER PUNKT: PREISUEBERSICHT AUF DEM HANDY
 * Sie sitzt im Theme in .product__below-media — und der Container traegt
 * small-hide. Unter 750px ist die komplette Preisaufschluesselung damit
 * ausgeblendet: kein Posten, kein Gesamtpreis, nur die Endsumme oben. Bei
 * Aufpreisen wie dem Montageset (38,50 EUR) sieht der Kunde auf dem Handy
 * nicht, wofuer er zahlt. Behoben gehoert das im Block
 * "Preisuebersicht unter das Bild holen" — der ist fuer den Platz dieses
 * Elements zustaendig und haelt ihn per MutationObserver. Von hier aus
 * dagegen zu schieben ergibt nur ein Zucken zwischen zwei Skripten.
 *
 * WARUM DIE MAßE AM KLICK HAENGEN UND NICHT AN 'input'
 * Die +/- Tasten setzen input.value per JavaScript. Eine programmatische
 * Zuweisung feuert **weder change noch input** — beide Ereignisse gibt es nur
 * bei echter Eingabe. Ein input-Listener greift hier also prinzipiell nicht;
 * v2.0.0 hatte genau diesen Denkfehler und die Kopfzeile blieb auf 1000
 * stehen, waehrend im Feld schon 1002 stand. Seit 2.0.1 zieht ein
 * Klick-Listener die Werte nach (80ms und 400ms, weil die App asynchron
 * nachrechnet). 'input' bleibt zusaetzlich dran — fuer getippte Werte.
 *
 * WARUM IM THEME UND NICHT IM DESIGN-JS DER APP
 * Das Design-JS liesse sich nur komplett neu hochladen (33.000 Zeichen in
 * einem einzigen Parameter). Siehe Memory "ablauf-code-ins-theme-einhaengen".
 *
 * NEU IN 2.6.0 (07.08.2026) — DIE LEISTE KLEBT, UND SIE TRAEGT DEN WARENKORB
 * Stefans Beobachtung: "durch den Konfigurator sehe ich oben den Warenkorb
 * nicht wenn ich runterscrolle". Gemessen am 07.08.2026 (Fenster 1440x900):
 * Der Konfigurator ist 1548 px lang, der Kunde scrollt also fast zwei
 * Bildschirmhoehen. Der Header steht auf "beim Hochscrollen einblenden" und
 * ist dabei weg — mit ihm Menue, Suche und das Warenkorbsymbol. Was
 * stattdessen erscheint, ist product-sticky-form: Bild, Titel, Preis, Kaufknopf
 * — und kein einziger Weg zum Warenkorb.
 *
 * Statt einer dritten Leiste bekommt die vorhandene zwei Zustaende:
 *   Im Fluss  — unveraendert dort, wo sie seit 2.4.0 steht.
 *   Geklebt   — sobald ihr Platz oben aus dem Bild scrollt: Desktop unter dem
 *               Header, Handy am unteren Rand, ueber die volle Breite, mit
 *               Warenkorbsymbol und Stueckzahl.
 * Sobald der Kaufknopf ins Bild kommt, loest sie sich wieder — ab da ist der
 * Kunde am Ziel und die Theme-Kaufleiste uebernimmt.
 *
 * KEIN SCROLL-LISTENER. Ausgeloest wird ueber zwei IntersectionObserver
 * (Platzhalter oben, Kaufknopf unten) und einen MutationObserver auf die
 * Klassen des Headers. Alle drei feuern nur bei echten Zustandswechseln.
 * Das ist Absicht: Der Theme-Block ProductStickyForm macht das Gegenteil und
 * schreibt bei JEDEM Scroll-Tick innerHTML von Bild, Preis und Titel neu —
 * das Bild mit zwoelf srcset-Groessen. Dagegen steht der Bremsblock unten.
 *
 * ⚠️ Der Platzhalter haelt die Hoehe der Leiste, sobald sie aus dem Fluss geht.
 * Ohne ihn springt der Inhalt im Moment des Klebens um die Leistenhoehe nach
 * oben — und weil damit auch der Platzhalter mitspringt, kippt der Observer
 * sofort zurueck: ein Flackern, das sich selbst antreibt.
 *
 * ⚠️ Der Warenkorbknopf klickt den Kopf-Knopf durch statt selbst zu
 * navigieren. Das Theme hat einen cart-drawer; ein eigenes href="/cart" wuerde
 * die Seite verlassen, waehrend der Header die Schublade oeffnet. Das href
 * bleibt trotzdem stehen — als Rueckfallebene, falls der Kopf-Knopf fehlt.
 *
 * NEU IN 2.12.0 (07.08.2026) — DIE LEISTE IST WIRKLICH WEG, SOLANGE SIE WEG SEIN SOLL
 * Stefan mit zwei Bildern: "diese Leiste soll erst kommen wenn wir anfangen zu
 * konfigurieren. Leiste doppelt" und "der Weiter-Knopf beisst sich mit In den
 * Warenkorb legen". Drei Beobachtungen, eine Ursache.
 *
 * Seit 2.10.0 wartet die Leiste auf `begonnen`, seit 2.11.0 haengt sie im
 * .header-wrapper. Ungeklebt wird sie per transform:translateY(-100%)
 * weggeschoben — und landet dabei nicht hinter dem Kopf, sondern auf ihm:
 * top:100% ist dessen Unterkante, minus die eigene Hoehe steht sie mittendrin.
 * Gemessen (Fenster 2266 breit, Seite ganz oben): Leiste 25-82 bzw. 61-118,
 * Kopf 0-83 bzw. 37-120, opacity 1, visibility visible, z-index 3, weisser
 * Grund. Sie hat Logo, Menue und Suche zugedeckt, ohne dass mo-fix gesetzt war.
 *
 * Daraus folgten die beiden anderen Punkte von selbst:
 *   - "doppelt": Die Theme-Kaufleiste weicht nur ueber html.mo-leiste-fix.
 *     Ungeklebt gibt es diese Klasse nicht, also standen Schrittleiste und
 *     product-sticky-form gleichzeitig an derselben Kante.
 *   - "Weiter beisst sich": Die beiden Knoepfe der beiden Leisten sassen
 *     dadurch rechts unmittelbar uebereinander.
 *
 * Der transform allein kann das nicht loesen — er verschiebt, er versteckt
 * nicht. Jetzt tragen opacity und visibility den Zustand. Bewusst NICHT
 * display:none: klebeZustand() misst die Hoehe der Leiste, um daraus
 * --mo-leiste-unten zu rechnen, und ein ausgeblendetes Element meldet 0.
 *
 * ZWEITER TEIL VON 2.12.0 — PLATZ FUER DIE KLEBENDE BILDSPALTE
 * Seit Abschnitt 37 in custom.css klebt die linke Produktspalte als ein Block,
 * mit `top: var(--mo-klebe-oben, 100px)`. 100px sind Kopf plus Luft; unsere
 * Leiste reicht bis 148, ihre oberen rund 48px lagen dahinter. klebeZustand()
 * setzt diese Variable jetzt mit — auf denselben gemessenen Wert wie
 * --mo-leiste-unten — und raeumt beide beim Loesen wieder ab. Das CSS des
 * Nachbarn bleibt unangefasst; der Abstand folgt der Leiste, statt auf einer
 * geratenen Zahl zu stehen.
 *
 * NEU IN 2.13.0 (07.08.2026) — ZWEI ANMERKUNGEN VON ALINA
 * 1. "Hier fehlt der Hacken bei Schritt 5." Er fehlte nicht — er war orange
 *    auf orange. Ein Punkt, auf dem der Kunde steht UND den er erledigt hat,
 *    traegt mo-fertig (oranger Grund) und mo-hier (orange Schrift); letztere
 *    steht spaeter im Stylesheet und gewinnt bei gleicher Spezifitaet.
 *    Behoben mit einer Regel auf beide Klassen zusammen — (0,3,0).
 * 2. "Wenn alles erledigt wurde: Zum Warenkorb hinzufuegen = Farbe orange."
 *    Vorher stand dort "✓ Bereit" in Gruen und DEAKTIVIERT: Der Kunde ist
 *    fertig, die Leiste bestaetigt das — und der einzige Knopf im Bild ist in
 *    genau diesem Moment tot. Jetzt gilt der Kaufmodus in beiden Faellen,
 *    unterhalb des Kaufknopfes oder sobald alle Schritte erledigt sind: voll
 *    orange, beschriftet wie der Hauptknopf, und er loest ihn auch aus.
 *    Bewusst derselbe Wortlaut wie am Hauptknopf ("In den Warenkorb legen")
 *    statt einer zweiten Formulierung fuer dieselbe Handlung.
 *
 * RUECKBAU: diesen Block loeschen. Die Klappfelder verhalten sich dann wieder
 * so, wie die App sie ausliefert (alle offen, kein Wert in der Kopfzeile),
 * und die Preisuebersicht ist auf dem Handy wieder unsichtbar.
 * ============================================================================ */
(function () {
  'use strict';
  if (!window.MO_LPO_AKTIV) return;  /* LPO aus: Block ruht - siehe LPO-SCHALTER oben (26.09.2026) */

  var CFG      = 'clu4al1wbeiu';
  var WERT_CLS = 'mo-schritt-wert';
  var BESUCHT  = 'mo-besucht';
  var LEER_CLS = 'mo-leer';
  var LEER_TXT = 'bitte Maß unten eintragen';
  /* ⚠️ 14.08.2026 — ZWEITER PLATZHALTER, weil nicht jeder leere Schritt ein
     Maß ist. Von Stefan im Screenshot gefunden: Der Schritt "Lochstein –
     Wandaufbau" (drei Kacheln, KEINE vorbelegt) trug in der Kopfzeile
     "bitte Maß unten eintragen" — dort gibt es kein Maß, sondern eine Auswahl.
     Der Kommentar bei werteSchreiben() nahm bis heute an, es treffe "in der
     Praxis nur die Maße, den einzigen Schritt ohne Vorbelegung". Das gilt fuer
     das Fenstergitter; sobald ein Montageset gewaehlt wird, kommt die
     Wandaufbau-Untergruppe dazu, und die ist ebenfalls required ohne
     Vorauswahl. Gemessen am Balkon: Schritt_Masse hat ein Maßfeld, der Schritt
     "Lochstein" hat drei Kacheln und keins. */
  var LEER_TXT_WAHL = 'bitte unten auswählen';
  var gefuehrt = false;   // die Erstfuehrung darf nur einmal laufen
  var leiste, txtEl, punkteEl, weiterEl, preisEl, heim = null;
  /* 2.6.0 — geklebte Fassung */
  var platz = null, fuehler = null, korbEl = null, zahlEl = null;
  /* ⚙️ Warenkorbsymbol in der Leiste — siehe Begruendung bei leisteBauen().
     Auf true steht es wieder da. */
  var KORB_IN_LEISTE = false;
  var obenRaus = false, vorbei = false, klebt = false, begonnen = false;

  /* Die Leiste kommt erst, wenn der Kunde wirklich anfaengt (2.10.0, Stefans
     Idee vom 07.08.2026). Bis dahin bleibt oben alles, wie das Theme es
     vorsieht: Kopf, Menue, Suche und der Brotkruemelpfad. Wer nur schaut,
     soll den Shop sehen; wer konfiguriert, bekommt das Werkzeug.
     Als Anfang zaehlt jede echte Handlung im Konfigurator — ein Klick auf
     eine Kopfzeile oder Kachel, eine Eingabe, der Weiter-Knopf. NICHT die
     Erstfuehrung, die Schritt 1 von selbst aufklappt: die ist programmatisch
     und laeuft ueber keinen dieser Wege. */
  function anfangen(ev) {
    /* ⚠️ NUR echte Handlungen zaehlen. LPO feuert beim Aufbau selbst
       change-Ereignisse — die Vorauswahl "Auf der Außenwand" etwa wird
       programmatisch gesetzt. Ohne diese Pruefung stand die Leiste sofort da,
       obwohl der Kunde nichts angefasst hatte (07.08.2026 im Laden gesehen).
       `isTrusted` ist genau die Grenze: true nur bei Ereignissen, die der
       Browser aus einer echten Eingabe erzeugt hat. */
    if (ev && ev.isTrusted === false) return;
    if (begonnen) return;
    begonnen = true;
    klebeZustand();
  }

  var HAKEN = "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='4' stroke-linecap='round' stroke-linejoin='round'><polyline points='20 6 9 17 4 12'/></svg>\")";

  /* ---- Stil ------------------------------------------------------------
     Zwei Teile: die Leiste selbst und die Neutralisierung des Hakens.
     Der Weiter-Knopf ist bewusst NICHT orange gefuellt — direkt darunter
     sitzt "In den Warenkorb legen", und zwei volle Orangeflaechen
     uebereinander nehmen sich gegenseitig die Wirkung. */
  function stil() {
    if (document.getElementById('mo-schritt-css')) return;
    var s = document.createElement('style');
    s.id = 'mo-schritt-css';
    s.textContent =
      ':is(#' + CFG + ',.cl-po--wrapper)' + ' .cl-po--options > .cl-po--option[data-option]:not(.' + BESUCHT + ') > .cl-po--collapse::before{background:#f1f2f4 !important;color:#6b7280 !important}' +
      ':is(#' + CFG + ',.cl-po--wrapper)' + ' .cl-po--options > .cl-po--option[data-option]:not(.' + BESUCHT + ') > .cl-po--collapse::after{border-color:#dcdfe3 !important;background:#fff !important}' +
      ':is(#' + CFG + ',.cl-po--wrapper)' + ' .cl-po--options > .cl-po--option[data-option].' + BESUCHT + ' > .cl-po--collapse::before{background:#cb4f0a !important;color:#fff !important}' +
      ':is(#' + CFG + ',.cl-po--wrapper)' + ' .cl-po--options > .cl-po--option[data-option].' + BESUCHT + ' > .cl-po--collapse::after{border-color:#cb4f0a !important;background:#cb4f0a ' + HAKEN + ' center/12px no-repeat !important}' +

      /* Der Rahmen traegt Hintergrund und Polsterung, der innere Behaelter das
         Flex-Layout. Getrennt, weil die geklebte Fassung beides
         unterschiedlich braucht: Hintergrund ueber die volle Fensterbreite,
         Inhalt auf Seitenbreite begrenzt (2.6.1). */
      /* 2.8.0: Die Leiste steht NUR NOCH geklebt. Die Fassung im Fluss unter
         dem Produktbild ist entfallen — sie zeigte dasselbe ein zweites Mal,
         sobald die geklebte durchgehend steht (Stefans Entscheidung vom
         07.08.2026). Deshalb ist sie immer `fixed` und nimmt im Dokument
         keinen Platz mehr ein; ein Platzhalter wird damit ebenfalls
         hinfaellig. Sichtbar wird sie ueber den transform, nicht ueber
         display: so bleibt sie messbar und kann sanft einfahren. */
      /* ⚠️ 2.12.0 — DER VERSTECKTE ZUSTAND VERSTECKTE NICHTS.
         Seit 2.11.0 haengt die Leiste im .header-wrapper und wird ungeklebt
         per transform:translateY(-100%) "weggeschoben". Nur schiebt sie das
         nicht hinter den Kopf, sondern GENAU AUF IHN: top:100% ist dessen
         Unterkante, minus die eigene Hoehe landet sie mitten drin. Gemessen
         am 07.08.2026: Leiste 25-82, Kopf 0-83, opacity 1, visibility
         visible — mit weissem Grund und z-index 3 deckte sie Logo, Menue und
         Suche zu, obwohl mo-fix gar nicht gesetzt war.
         Damit war auch "Leiste doppelt" erklaert: Die Theme-Kaufleiste weicht
         nur ueber html.mo-leiste-fix, und diese Klasse gibt es ungeklebt
         nicht — also standen beide uebereinander.
         Der transform allein reicht hier also nicht. Ein overflow:hidden am
         Kopf waere der andere Weg, wuerde aber die Dropdowns des Menues
         abschneiden. Deshalb visibility + opacity: Das Element bleibt im
         Layout und damit messbar (getBoundingClientRect in klebeZustand()
         braucht seine Hoehe), ist aber weg vom Schirm, aus der
         Tab-Reihenfolge und ohne Maustreffer. */
      '.mo-leiste{position:absolute;left:0;right:0;top:100%;z-index:3;margin:0;padding:10px 4rem;' +
        'background:#fff;border:0;border-bottom:1px solid #e5e7eb;border-radius:0;' +
        'box-shadow:0 2px 10px rgba(0,0,0,.10);' +
        'transform:translateY(-100%);opacity:0;visibility:hidden;pointer-events:none;' +
        'transition:transform .18s ease-out,opacity .18s ease-out,visibility 0s linear .18s}' +
      '.mo-leiste-innen{display:flex;align-items:center;gap:12px;flex-wrap:wrap}' +
      '.mo-leiste.mo-fertig{background:#f7fdf9;border-color:#bbf7d0}' +
      '.mo-leiste-txt{font-size:13px;font-weight:700;color:#111827;white-space:nowrap}' +
      '.mo-punkte{display:flex;align-items:center;flex:1 1 auto;min-width:110px}' +
      '.mo-punkt{flex:0 0 22px;width:22px;height:22px;border-radius:50%;border:2px solid #dcdfe3;background:#fff;color:#9ca3af;font-size:11px;font-weight:700;line-height:1;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;transition:.15s}' +
      '.mo-punkt:hover{border-color:#ea5b0b}' +
      '.mo-punkt.mo-fertig{background:#cb4f0a;border-color:#cb4f0a;color:#fff}' +
      '.mo-punkt.mo-hier{border-color:#cb4f0a;color:#cb4f0a;box-shadow:0 0 0 3px #fdece1}' +
      /* ⚠️ 2.13.0 — DER HAKEN AM AKTUELLEN SCHRITT WAR UNSICHTBAR.
         Alina am 07.08.2026: "Hier fehlt der Hacken bei Schritt 5". Er fehlte
         nicht, er war orange auf orange: Ein Punkt, auf dem der Kunde gerade
         steht UND den er schon erledigt hat, traegt beide Klassen. mo-fertig
         faerbt den Grund orange, mo-hier steht spaeter im Stylesheet und
         gewinnt bei gleicher Spezifitaet die Schriftfarbe — ebenfalls orange.
         Diese Regel ist (0,3,0) und schlaegt beide. */
      '.mo-punkt.mo-fertig.mo-hier{color:#fff}' +
      '.mo-strich{flex:1 1 auto;height:2px;background:#e5e7eb;min-width:6px}' +
      '.mo-strich.mo-fertig{background:#ea5b0b}' +
      '.mo-leiste-preis{margin-left:auto;padding-left:10px;font-size:17px;font-weight:700;color:#111827;white-space:nowrap}' +
      /* Viele Schritte (Tor-Konfigurator: 8-9). Gemessen am 07.08.2026 in der
         600px-Spalte: Bei 9 Punkten belegen Text 106 + Kette 255 + Preis 86 +
         Knopf 87 px, mit Abstaenden 598 von 600 — es passt auf den Punkt
         genau. Ein vierstelliger Preis oder "Schritt 10 von 12" kippt es, und
         dann bricht irgendein Teil irgendwohin um. Deshalb ab sieben
         Schritten bewusst zweizeilig: Kette in eigener Zeile, volle Breite. */
      '.mo-leiste.mo-viele .mo-punkte{flex:1 1 100%;order:9;margin-top:2px}' +
      '.mo-weiter{flex:0 0 auto;padding:10px 18px;border:0;border-radius:8px;background:#fff;color:#cb4f0a;box-shadow:inset 0 0 0 2px #cb4f0a;font-size:14px;font-weight:700;cursor:pointer}' +
      '.mo-weiter:hover{background:#fdece1}' +
      '.mo-weiter[disabled]{background:#fff;color:#16a34a;box-shadow:inset 0 0 0 2px #bbf7d0;cursor:default}' +
      /* Kaufmodus (2.7.0): jetzt darf er voll orange sein. Der Grund, warum er
         es sonst nicht ist — zwei Orangeflaechen uebereinander — faellt hier
         weg: Unterhalb des Kaufknopfes ist dieser laengst aus dem Bild. */
      '.mo-leiste.mo-modus-kaufen .mo-weiter{background:#cb4f0a;color:#fff;box-shadow:none}' +
      '.mo-leiste.mo-modus-kaufen .mo-weiter:hover{background:#b34609}' +
      '.cl-po--option.mo-preis-mobil{margin:14px 0 0 !important}' +
      '.mo-preis-hinweis{display:flex;gap:6px;margin:10px 0 0;padding:8px 10px;' +
        'border-radius:8px;background:#fdece1;color:#9a3d06;' +
        'font-size:12px;line-height:1.35;font-weight:600}' +
      /* Das "ab" ist bewusst ein Pseudoelement: Preis und Summenzeile werden
         von LPO bzw. Vue neu gerendert, ein eingefuegter Knoten waere danach
         weg. In der Summenzeile wuerde er ausserdem zum dritten Flex-Kind und
         die Zeile bricht um — gemessen am 06.08.2026. */
      '.mo-ab-preis::before{content:"ab ";font-weight:500;opacity:.8}' +
      /* Platzhalter (2.3.0). Nur eine Regel: die Warnfarbe, gegen das #6b7280
         aus Abschnitt 25 des Theme-CSS. Das zusaetzliche .mo-leer hebt die
         Spezifitaet von (1,5,1) auf (1,6,1) — !important allein reicht nicht,
         das traegt die Theme-Regel genauso, und bei Gleichstand gewinnt die
         spaeter geladene Datei.
         Das "B×H = "-Praefix aus Abschnitt 31c BLEIBT bewusst stehen: in der
         Kopfzeile steht damit "B×H = bitte Maß unten eintragen" — so von
         Stefan am 06.08.2026 abgenommen.
         2.4.0: Stefans Vorgabe vom 07.08.2026 — gleicher Schriftschnitt wie
         die uebrigen Werte (400 statt 600, Montserrat 13px stimmte schon
         ueberein), dafuer Rot. #c62828 statt #9a3d06: Das Braunorange lag zu
         nah am Akzent #ea5b0b und las sich als Deko statt als Aufforderung.
         Kontrast auf Weiss 5,7:1, also auch bei 13px sicher lesbar. */
      ':is(#' + CFG + ',.cl-po--wrapper)' + ' .cl-po--options > .cl-po--option > .cl-po--collapse .' + WERT_CLS + '.' + LEER_CLS +
        '{color:#c62828 !important;font-weight:400 !important}' +
      '@media(max-width:749px){.mo-weiter{flex:1 1 100%}}' +

      /* ---- Geklebter Zustand (2.6.0) --------------------------------------
         Hintergrund ueber die volle Fensterbreite, Inhalt auf Seitenbreite —
         sonst laeuft die Leiste rechts und links ueber den uebrigen Inhalt
         hinaus, was am 07.08.2026 auf einem breiten Schirm sofort auffiel.
         top wird in topSetzen() gesetzt, nicht hier: wie weit der Header nach
         unten reicht, entscheidet sich erst beim Kleben.

         ⚙️ BREITE EINSTELLEN — eine Zeile in assets/custom.css genuegt:
              .mo-leiste { --mo-leiste-breite: 120rem; }
         Der Standard 152rem sind 1520px: die Seitenbreite (--page-width,
         160rem) minus der beidseitigen 4rem Polsterung von .page-width.
         Damit stehen die Kanten der Leiste genau auf den Kanten des
         Seiteninhalts — auf jedem Schirm, ober- wie unterhalb von 1600px. */
      /* Die Verzoegerung auf visibility faellt hier weg (0s statt 0s .18s):
         Beim Einblenden soll sie sofort sichtbar sein und dann einfahren,
         beim Ausblenden erst nach dem Einfahren verschwinden. */
      '.mo-leiste.mo-fix{transform:translateY(0);opacity:1;visibility:visible;' +
        'pointer-events:auto;' +
        'transition:transform .18s ease-out,opacity .18s ease-out,visibility 0s}' +
      '.mo-leiste.mo-fix .mo-leiste-innen{max-width:var(--mo-leiste-breite,152rem);' +
        'margin:0 auto;width:100%}' +
      /* Der Platzhalter haelt die Hoehe, sonst springt der Inhalt beim Kleben
         nach oben und der Observer kippt sofort zurueck — siehe Kopf.
         ⚠️ display:none waere hier ein stiller Totalausfall: Ein ausgeblendetes
         Element meldet dem IntersectionObserver immer das Rechteck 0/0/0/0.
         Damit ist boundingClientRect.top nie kleiner als 0, obenRaus bleibt
         false und die Leiste klebt NIE. Deshalb bleibt er im Layout und traegt
         nur die Hoehe 0.
         ⚠️ Und genau deshalb braucht der Selektor das [aria-hidden]: base.css
         fuehrt eine Regel `a:empty, ul:empty, div:empty, …{display:none}`. Ein
         leerer Platzhalter faellt darunter, und `div:empty` (0,1,1) schlaegt
         eine einzelne Klasse (0,1,0). Mit dem Attribut steht es 0,2,0 und die
         Sache ist unabhaengig von der Ladereihenfolge entschieden. */
      '.mo-leiste-platz[aria-hidden]{display:block;height:0;margin:0;padding:0;border:0}' +
      /* Der Korb ersetzt den Kopf-Zugang, den es geklebt nicht mehr gibt.
         Im Fluss steht der Header ohnehin sichtbar darueber — dort waere er
         nur eine zweite Tuer zum selben Raum. */
      /* Logo aus (2.11.0): Der Kopf steht direkt darueber und traegt es schon. */
      '.mo-logo{display:none !important}' +
      '.mo-korb{display:none}' +
      /* ⚙️ GROESSE EINSTELLEN — in assets/custom.css:
              .mo-leiste { --mo-korb-symbol: 30px; --mo-korb-knopf: 48px; }
         Der Knopf sollte rund 1,6-mal so gross bleiben wie das Symbol, sonst
         klebt die Stueckzahl am Rand. Mobil bleibt er bei 40px: dort sind von
         355 nutzbaren Pixeln nur 24 frei. */
      '.mo-leiste.mo-fix .mo-korb{display:inline-flex;align-items:center;' +
        'justify-content:center;flex:0 0 auto;' +
        'width:var(--mo-korb-knopf,44px);height:var(--mo-korb-knopf,44px);' +
        'border-radius:8px;color:#111827;text-decoration:none}' +
      '.mo-korb-bild{position:relative;display:inline-flex;flex:0 0 auto}' +
      '.mo-korb:hover{background:#f3f4f6}' +
      /* ⚠️ Das geklonte Symbol traegt fill="none" am <svg>. Im Kopf faerbt es
         die Theme-Regel `.use_custom_clrs .header__icon .icon{fill:#000}` —
         die greift hier nicht, und uebrig bleibt ein unsichtbares Symbol in
         richtiger Groesse. Am 07.08.2026 genau so im Laden gesehen: die
         orange Stueckzahl schwebte allein in der Leiste.
         Das !important ist noetig, weil base.css `.icon{fill:canvastext
         !important}` fuehrt. */
      '.mo-korb svg{width:var(--mo-korb-symbol,27px);height:var(--mo-korb-symbol,27px);display:block}' +
      '.mo-korb svg,.mo-korb svg path{fill:currentColor !important}' +
      '.mo-korb-zahl{position:absolute;top:-6px;right:-8px;min-width:18px;height:18px;' +
        'padding:0 4px;border-radius:9px;background:#cb4f0a;color:#fff;' +
        'font-size:11px;font-weight:700;line-height:18px;text-align:center}' +
      '.mo-korb-zahl:empty{display:none}' +
      /* Solange wir kleben, tritt die Theme-Kaufleiste zurueck: zwei Leisten
         an derselben Kante waeren 114px Bildschirm fuer dieselbe Aussage. */
      'html.mo-leiste-fix product-sticky-form{display:none !important}' +
      /* ---- Die Leiste ERSETZT den Kopf (2.9.0) -----------------------------
         Stefans Entscheidung vom 07.08.2026. Vorher stritten beide um dieselbe
         Kante: Kopf bei 37-120 mit z-index 3, Leiste bei 0-65 mit z-index 4 —
         die Leiste legte sich ueber ihn. Der Versuch, sie per JavaScript
         darunter zu setzen, scheiterte daran, dass die Kopfposition nur im
         Moment des Klebens gemessen wurde und danach wanderte.
         Jetzt weicht der Kopf, solange die Leiste steht. Sie traegt Logo und
         Warenkorb, also geht kein Weg verloren.
         ⚠️ `transform`, NICHT `display:none`: Der Kopf ist `sticky` und liegt
         damit im Fluss — ihn auszublenden wuerde die Seite um seine Hoehe
         nach oben reissen. Verschoben behaelt er seinen Platz. */
      /* 2.11.0: Der Kopf bleibt stehen. Die Leiste sitzt jetzt unter ihm statt
         an seiner Stelle — Menue, Suche und Konto bleiben also erreichbar.
         Was er dafuer braucht: einen Stapelkontext ueber dem Seiteninhalt,
         damit die herausragende Leiste nicht hinter Abschnitten verschwindet. */
      'html.mo-leiste-fix #shopify-section-header{z-index:4}' +
      /* ⚠️ HIER STAND EINE REGEL, DIE NICHT GREIFT — nicht wieder einbauen.
         Die klebende linke Spalte kommt aus Abschnitt 37 in custom.css:
           .product:has(#clu4al1wbeiu):not(:has(.product__below-media .mo-leiste))
             .product__media-wrapper { position:sticky !important; top:100px !important }
         Das ist (1,4,0) mit !important. Ein eigener Selektor kommt da nur mit
         nachgebautem :has()/:not() heran — Wettruesten in fremdem Code.
         Stattdessen stellt klebeZustand() die Variable --mo-leiste-unten
         bereit (Kopfhoehe + Leistenhoehe + 8). Wer Abschnitt 37 pflegt, kann
         dort `top: var(--mo-leiste-unten, 100px)` schreiben und der Wert folgt
         der Leiste von selbst. Solange das nicht geschehen ist, liegen die
         oberen rund 83px der klebenden Spalte hinter der Leiste. */
      /* Der Weiter-Knopf springt per scrollIntoView zum naechsten Schritt.
         Solange die Leiste klebt, landet dessen Kopfzeile sonst genau DAHINTER
         — der Kunde drueckt Weiter und sieht den Schritt nicht, den er gerade
         angesprungen hat. Der Abstand haelt ihn frei: oben Kopf 83 + Leiste 65
         + Luft, mobil unten die Leistenhoehe. */
      'html.mo-leiste-fix .cl-po--options > .cl-po--option{scroll-margin-top:160px}' +
      /* Handy: an den unteren Rand, in Daumenreichweite. "Schritt 2 von 5"
         faellt weg — die Punktekette sagt dasselbe und bei 375px ist der
         Platz auf 124px fuer die Kette gerechnet. Der Weiter-Knopf verliert
         hier sein flex:1 1 100% aus der Regel darueber, sonst waere die
         geklebte Leiste zweizeilig und damit doppelt so hoch. */
      '@media(max-width:749px){' +
        /* Am Handy bleibt sie am unteren Bildschirmrand — dort ist der Daumen.
           `fixed` statt `absolute`: Sie loest sich damit aus dem Kopfbereich,
           in dem sie haengt, und richtet sich am Fenster aus. Das geht nur,
           solange kein Vorfahr ein `transform` traegt; der Kopf hat keines. */
        '.mo-leiste{position:fixed;top:auto !important;bottom:0;border-bottom:0;' +
          'border-top:1px solid #e5e7eb;box-shadow:0 -2px 10px rgba(0,0,0,.12);' +
          'padding:8px 12px;transform:translateY(100%);z-index:5}' +
        '.mo-leiste.mo-fix{transform:translateY(0)}' +
        /* ⚠️ Der Abstand gehoert seit 2.6.1 an den inneren Behaelter. Er ist
           der Flex-Container; ein gap an .mo-leiste ist wirkungslos. Genau das
           hat die Leiste bei 375px in die zweite Zeile gekippt: 12 statt 8
           Pixel Abstand, und die Kette drueckte den Knopf um. */
        '.mo-leiste.mo-fix .mo-leiste-innen{gap:8px}' +
        '.mo-leiste.mo-fix .mo-leiste-txt{display:none}' +
        '.mo-leiste.mo-fix .mo-weiter{flex:0 0 auto;padding:9px 14px}' +
        /* flex-basis 80px statt auto: Mit auto zieht die Punktekette ihre
           max-content-Breite als Ausgangswert heran und erzwingt den Umbruch,
           bevor sie schrumpfen darf. Mit fester Basis schrumpft sie zuerst und
           waechst danach in den freien Platz. */
        '.mo-leiste.mo-fix .mo-punkte,.mo-leiste.mo-fix.mo-viele .mo-punkte' +
          '{flex:1 1 80px;order:0;margin-top:0;min-width:80px}' +
        '.mo-leiste.mo-fix .mo-leiste-preis{padding-left:0}' +
        /* Bei 375px war die geklebte Leiste zweizeilig und 99px hoch — ein
           Achtel des Bildschirms, und sie verdeckt genau das, was der Kunde
           gerade ausfuellt. Gemessen am 07.08.2026: Kette 202 + Preis 93 +
           Korb 40 + Knopf 79 = 414 auf 351 nutzbare Pixel.
           Deshalb hier kleinere Punkte, schmalere Striche und ein kompakterer
           Knopf: 106 + 82 + 40 + 72 + 24 Abstaende + 20 Polsterung = 344.
           Rund 30px Luft, die auch ein vierstelliger Preis nicht aufbraucht. */
        '.mo-leiste.mo-fix{padding:8px 10px}' +
        '.mo-leiste.mo-fix .mo-punkt{flex:0 0 18px;width:18px;height:18px;font-size:10px}' +
        '.mo-leiste.mo-fix .mo-strich{min-width:4px}' +
        '.mo-leiste.mo-fix .mo-leiste-preis{font-size:15px}' +
        '.mo-leiste.mo-fix .mo-weiter{padding:8px 12px}' +
        /* Am Handy bleibt der Knopf bei 40px, das Symbol waechst nur auf 24 —
           von 355 nutzbaren Pixeln sind hier nur rund 24 frei. */
        'html.mo-leiste-fix .cl-po--options > .cl-po--option{scroll-margin-top:16px;scroll-margin-bottom:70px}' +
        /* Im Kaufmodus bleibt die Schrittkette stehen (Stefans Vorgabe vom
           07.08.2026) — sie sagt dem Kunden auch beim Kaufen noch, dass alle
           Angaben vollstaendig sind. Auf 375px passt das nur zweizeilig:
           Kette 106 + Preis 83 + Korb 40 + Abstaende 16 + Polsterung 20 = 265,
           fuer "In den Warenkorb" braeuchte es weitere 216. Also bekommt der
           Kaufknopf eine eigene Zeile ueber die volle Breite — am unteren
           Bildrand ist das ohnehin die bequemere Trefferflaeche. */
        '.mo-leiste.mo-fix.mo-modus-kaufen .mo-weiter{flex:1 1 100%;order:9;margin-top:6px}' +
        '.mo-leiste.mo-fix .mo-korb{width:40px;height:40px;padding:0;box-shadow:none}' +
        '.mo-korb svg{width:24px;height:24px}}';
    document.head.appendChild(s);
  }

  function wurzel() { return document.querySelector(':is(#' + CFG + ',.cl-po--wrapper)'); }

  function schritte() {
    var w = wurzel();
    if (!w) return [];
    var liste = w.querySelectorAll('.cl-po--options > .cl-po--option');
    var raus = [];
    for (var i = 0; i < liste.length; i++) {
      var kopf = liste[i].querySelector(':scope > .cl-po--collapse');
      if (kopf && liste[i].offsetParent !== null) raus.push({ knoten: liste[i], kopf: kopf });
    }
    return raus;
  }

  /* Der gewaehlte Wert — in dieser Reihenfolge, weil keine Quelle alle
     Optionstypen abdeckt:

     1. Maße: die beiden sichtbaren Felder heissen properties[_Maße_x] und
        _y und sind type="text", nicht "number". Zusammengesetzt ergibt das
        "1000 × 500 mm". Das versteckte Feld der App wuerde hier
        "Befestigungsabstand=1000 mm × Höhe=500 mm" liefern — korrekt, aber
        zu technisch fuer eine Kopfzeile.
     2. Die gewaehlte Kachel. ACHTUNG: Spitzenform und Oberflaeche haben
        KEIN .cl-po--swatch-text — bei ihnen ist imgText ausgeschaltet, der
        Text steht nur in .visually-hidden fuer Screenreader. Ohne diesen
        Fallback bleiben genau diese beiden Schritte leer.
     3. Notnagel: das versteckte properties-Feld, das jede Option mitfuehrt
        und das auch im Warenkorb landet. */
  function wertVon(knoten) {
    var x = knoten.querySelector('input[name$="_x]"]');
    var y = knoten.querySelector('input[name$="_y]"]');
    /* ⚠️ EIN Mass oder ZWEI — und warum die Sichtbarkeit zaehlt.
       Eine dimension-Option rendert IMMER beide Felder, auch auf onlyX; das
       zweite wird nur per CSS ausgeblendet und behaelt seinen Wert. Die alte
       Bedingung `x.value && y.value` hat den deshalb mitgelesen: der Handlauf
       trug am 12.08.2026 die App-Vorgaben 1000/1000 und schrieb "1000 × 1000
       mm" in die Kopfzeile — fuer ein Produkt mit einem einzigen Laengenmass.
       Schlimmer noch: der Wert war nie leer, also blieben der Hinweis "bitte
       Maß unten eintragen", die Warnfarbe und der "ab"-Preis aus, und der
       Schritt trug seinen Haken schon vor der ersten Eingabe.
       `offsetParent === null` ist derselbe Sichtbarkeitstest wie in schritte();
       das `max-height:0` zugeklappter Panels stoert ihn nicht, weil dort kein
       display:none steht. Fenstergitter (zwei sichtbare Felder) bleibt bei
       "600 × 900 mm", Balkon, Stange und Handlauf bekommen "1500 mm". */
    if (x && x.value) {
      var yFeld = y && y.closest('.cl-po--dimension-item');
      if (y && y.value && yFeld && yFeld.offsetParent !== null) {
        return x.value + ' × ' + y.value + ' mm';
      }
      /* ⚠️ 14.08.2026 — ERWEITERUNGSPUNKT FUER GRUPPENEIGENE DATEIEN.
         Stefans Entscheidung vom 14.08.2026: produktspezifisches Wissen gehoert
         NICHT in diese Sammeldatei, sondern in eine eigene Datei je Gruppe
         (Vorbild assets/handlauf.js). Diese Datei bleibt damit frei von
         Konfigurator-Sonderfaellen und muss beim naechsten Ausbau nicht
         angefasst werden — jeder Upload hier ist ein Risiko fuer alle anderen
         Bloecke.
         Anlass war der Franzoesische Balkon: dort ist "Maße" auf onlyX
         gestellt und die Hoehe eine EIGENE Kacheloption, die der Zweig
         darueber nie findet. In der Kopfzeile stand "B×H = 2000 mm", waehrend
         darunter "Höhe: 1000 mm" gewaehlt war (von Stefan im Screenshot
         markiert). Die Loesung dafuer steht jetzt in assets/balkon.js.
         VERTRAG: Eine Gruppendatei haengt eine Funktion in
         window.MO_MASS_ZUSATZ. Sie bekommt (knoten, xWert) und gibt entweder
         einen fertigen Text zurueck oder etwas Falsches, wenn sie nicht
         zustaendig ist. Wirft sie, wird das geschluckt — eine kaputte
         Gruppendatei darf die Schrittfuehrung aller anderen nicht anhalten. */
      if (typeof window.MO_MASS_ZUSATZ === 'function') {
        try {
          var zusatz = window.MO_MASS_ZUSATZ(knoten, x.value);
          if (zusatz) return zusatz;
        } catch (e) { /* Gruppendatei defekt — Rueckfall auf das reine Mass */ }
      }
      return x.value + ' mm';
    }

    var inp = knoten.querySelector('.cl-po--swatch-item input:checked');
    if (inp) {
      var it   = inp.closest('.cl-po--swatch-item');
      var text = it.querySelector('.cl-po--swatch-text') || it.querySelector('.visually-hidden');
      if (text && text.textContent.trim()) return text.textContent.trim();
    }

    var versteckt = knoten.querySelector('input[type="hidden"][name^="properties["]');
    return versteckt && versteckt.value ? versteckt.value.trim() : '';
  }

  function offen(s)     { return s.kopf.classList.contains('cl-po--open'); }
  function aufmachen(s) { s.kopf.classList.add('cl-po--open'); }
  function zumachen(s)  { s.kopf.classList.remove('cl-po--open'); }

  /* Angesehen zu haben genuegt NICHT, wenn der Schritt ein leeres Pflichtfeld
     enthaelt. Sonst traegt Schritt 2 einen Haken, waehrend die Maßfelder leer
     sind — und "Alle Angaben vollstaendig" waere schlicht gelogen.
     Deshalb zwei getrennte Dinge: der Merker data-mo-gesehen haelt fest, dass
     der Kunde da war, die Klasse .mo-besucht (an der das CSS den Haken
     festmacht) kommt erst, wenn beides zutrifft. */
  function gesehen(s)   { return s.knoten.getAttribute('data-mo-gesehen') === '1'; }
  function merken(s)    { if (s) s.knoten.setAttribute('data-mo-gesehen', '1'); }
  /* 2.15.4 — Radiogruppen richtig pruefen.
     DER FEHLER, den Stefan am 08.08.2026 gefunden hat: Diese Funktion fragte
     ausschliesslich .value ab. Bei einem Radiobutton ist .value aber IMMER
     gesetzt (der Wert der Option), voellig unabhaengig davon, ob er angehakt
     ist. Eine Radiogruppe ohne jede Auswahl galt damit als ausgefuellt.

     Aufgefallen ist es am Montageset: Schritt "Lochstein" traegt zwei Gruppen -
     den Wandaufbau (drei Kacheln, eine vorbelegt) und die Befestigung
     ("Lochstein ungedaemmt", EINE Option, required, aber ohne Vorbelegung).
     Der Schritt bekam seinen Haken und "Alle Angaben vollstaendig" stand da,
     obwohl das Montageset nicht gewaehlt war. Bei allen anderen Schritten fiel
     es nicht auf, weil dort ueberall eine Vorauswahl existiert.

     Radios werden deshalb nach NAME gruppiert: jede Gruppe braucht mindestens
     ein checked. Checkboxen gleich mitbehandelt - dort ist .value ebenso immer
     gesetzt, es ist derselbe Fehler.

     Nur [required] wird geprueft, wie vorher auch: was die App als freiwillig
     ausliefert, soll den Haken nicht blockieren. */
  function ausgefuellt(s) {
    var pflicht = s.knoten.querySelectorAll('input[required], select[required], textarea[required]');
    var gruppen = {}, n;
    for (var i = 0; i < pflicht.length; i++) {
      var el = pflicht[i];
      if (el.type === 'radio') {
        if (!el.name) continue;
        if (!(el.name in gruppen)) gruppen[el.name] = false;
        if (el.checked) gruppen[el.name] = true;
        continue;
      }
      if (el.type === 'checkbox') { if (!el.checked) return false; continue; }
      if (!String(el.value || '').trim()) return false;
    }
    for (n in gruppen) { if (!gruppen[n]) return false; }
    return true;
  }
  function besucht(s)   { return gesehen(s) && ausgefuellt(s); }

  /* Rollendes Fenster (2.15.2). Stefans Vorgabe vom 08.08.2026:

       "Befestigungsabstand, wenn Kunde da im Feld ist, Maße oeffnen, aber nicht
        sofort Befestigungsart schliessen. Befestigungsart erst schliessen, wenn
        Kunde bei Maße ist und bearbeitet - in dem Zug dann den naechsten Schritt
        oeffnen, in dem Fall Farbe."

     Also drei Dinge auf einmal, bezogen auf den Schritt, in dem der Kunde
     GERADE arbeitet:
       - er selbst bleibt offen
       - der naechste geht auf   (er sieht, was kommt)
       - der vorherige geht zu   (der ist erledigt)

     Beispiel: Kachel in Schritt 1 gewaehlt -> Maße geht auf, Befestigungsart
     bleibt offen (es gibt keinen vorherigen). Sobald er dann im Maßfeld tippt
     oder +/- drueckt -> Farbe geht auf, Befestigungsart geht zu, Maße bleibt
     offen.

     WARUM NICHT MEHR nurDieser(): das liess genau EINEN Schritt offen. Beim
     Tippen in die Maße klappte der eigene Schritt damit zu und die Eingabe war
     nicht mehr erreichbar. Genau deshalb brauchte 2.15.1 eine 1,5-Sekunden-Uhr
     als Krücke - die entfaellt jetzt vollstaendig, weil der bearbeitete Schritt
     offen bleibt. Aus demselben Grund faellt auch die ausgefuellt()-Pruefung
     weg: es ist unschaedlich, wenn die Farbe schon beim ersten Zeichen aufgeht.

     Kein scrollIntoView: der Kunde steht im Maßfeld, ein Sprung wuerde ihn
     genau da wegreissen.

     Mehrfachaufrufe sind folgenlos - aufmachen() und zumachen() setzen nur eine
     Klasse. Der Klick-Weg ruft zweimal (80/400 ms), das Tippen bei jedem
     Zeichen; das Ergebnis ist jedes Mal dasselbe.

     merken() am vorherigen Schritt: er gilt als angesehen, sonst fehlte ihm in
     der Schrittleiste der Haken, obwohl der Kunde ihn hinter sich hat.

     Ausgeblendete Schritte fallen automatisch heraus, weil schritte() per
     offsetParent filtert - die Spitzenform bei hat_spitzen=false also auch. */
  /* MOBIL WIRD NICHT MEHR AUTOMATISCH AUF- UND ZUGEKLAPPT (v2.16.0, 20.08.2026)

     Stefan: "denke befestigungsmittel mobil nicht aufklappen lassen? das
     springt immer sobald man eine Farbe auswaehlt springt befestigungs auf."

     WAS WIRKLICH SPRINGT: nicht der Schritt, der AUFgeht - der steht unter dem
     Finger und schiebt nur Inhalt nach unten weg. Es ist der VORHERIGE, der
     ZUgeht. Der steht OBERHALB; sein Inhalt faellt aus dem Fluss, alles
     darunter rutscht um dessen Hoehe hoch, und der Kunde steht auf einmal im
     uebernaechsten Schritt. Genau das zeigt Stefans Screenshot vom 20.08.:
     Farbe getippt, Ansicht steht im Befestigungsmittel.

     KEIN SCROLL-AUSGLEICH. Der Weg ist im Block AUFMASSBILD schon einmal
     gegangen und wieder ausgebaut worden (v2.0.0): window.scrollTo ersetzt den
     Sprung nur durch einen zweiten, Stefan sah ihn weiterhin. Hier wird
     deshalb die Ursache entfernt statt sie auszugleichen.

     merken() bleibt in JEDEM Fall stehen - sonst fehlt dem verlassenen Schritt
     der Haken in der Schrittleiste.

     AM RECHNER unveraendert: dort sitzt der Konfigurator in einer eigenen
     Spalte, der Sprung faellt nicht auf, und Stefans Vorgabe vom 08.08.2026
     (rollendes Fenster) gilt dort weiter.

     WEITER KOMMT DER KUNDE MOBIL TROTZDEM: ueber den "Weiter"-Knopf in der
     klebenden Leiste und ueber die Schrittkoepfe. Beide laufen ueber
     nurDieser() und scrollen bewusst zum Ziel - dort ist die Bewegung gewollt,
     weil der Kunde sie selbst ausgeloest hat.

     749px ist derselbe Wert wie an den uebrigen Stellen dieses Blocks (Kurzform
     des Weiter-Knopfes, zweizeilige Leiste). */
  function mobilSchmal() { return window.matchMedia('(max-width: 749px)').matches; }
  function weiter(s) {
    if (!s) return;
    var alle = schritte();
    for (var i = 0; i < alle.length; i++) {
      if (alle[i].knoten === s.knoten) {
        if (i - 1 >= 0) merken(alle[i - 1]);
        if (mobilSchmal()) return;        /* mobil den Fluss NICHT anfassen */
        if (i + 1 < alle.length) aufmachen(alle[i + 1]);
        if (i - 1 >= 0) zumachen(alle[i - 1]);
        return;
      }
    }
  }

  /* Titel ohne den angehaengten Wert — der steckt im eigenen <span>. */
  function titelVon(s) {
    var k = s.kopf.childNodes[0];
    return ((k && k.textContent) || s.kopf.textContent || '').trim();
  }

  /* Den Wert in die Kopfzeile schreiben. Der Knoten wird einmal angelegt und
     danach nur noch im Text gepflegt — Neuanlegen bei jedem Takt wuerde die
     Textauswahl des Kunden zerreissen.

     Die Klasse mo-erledigt bleibt erhalten: das CSS braucht sie an anderer
     Stelle, und die Maße haben keine Radiobuttons. Fuer den Haken ist sie
     seit v2.0.0 nicht mehr massgeblich — das ist .mo-besucht. */
  function werteSchreiben() {
    var alle = schritte(), geaendert = false;
    for (var i = 0; i < alle.length; i++) {
      var s = alle[i];
      var span = s.kopf.querySelector('.' + WERT_CLS);
      if (!span) {
        span = document.createElement('span');
        span.className = WERT_CLS;
        s.kopf.appendChild(span);
        geaendert = true;
      }
      /* Steht nichts da, steht auch nichts unter der Ueberschrift — und ein
         zugeklappter Schritt ohne Zeile sieht aus wie einer, in dem es nichts
         zu tun gibt. Genau so ging es bisher den Maßen, dem einzigen Schritt
         ohne Vorbelegung. Deshalb der Platzhalter (2.3.0).
         NUR bei fehlender PFLICHTangabe: die Spitzenform laesst sich abwaehlen
         (toggle=true in der App), ein leerer Wert ist dort erlaubt und soll
         nicht mahnen. In der Praxis trifft es damit nur die Maße — den
         einzigen Schritt ohne Vorbelegung; deshalb darf der Text sie auch
         beim Namen nennen. Die Klasse LEER_CLS traegt die Warnfarbe, siehe
         stil(); das "B×H = " aus Abschnitt 31c bleibt davor stehen. */
      var wert    = wertVon(s.knoten);
      var leer    = wert === '' && !ausgefuellt(s);
      /* Welcher Platzhalter — siehe LEER_TXT_WAHL oben. Entschieden wird am
         DOM, nicht am Optionsnamen: "Schritt_Masse" heisst beim Handlauf
         genauso und traegt trotzdem ein Maßfeld, waehrend Untergruppen wie
         "Lochstein" oder "Vollstein/Beton" je nach Config anders heissen. Ein
         sichtbares _x-Feld ist das verlaessliche Merkmal. */
      var anzeige = leer
        ? (s.knoten.querySelector('input[name$="_x]"]') ? LEER_TXT : LEER_TXT_WAHL)
        : wert;
      if (span.textContent !== anzeige) { span.textContent = anzeige; geaendert = true; }
      if (span.classList.contains(LEER_CLS) !== leer) {
        span.classList.toggle(LEER_CLS, leer);
        geaendert = true;
      }
      var fertig = wert !== '';
      if (s.knoten.classList.contains('mo-erledigt') !== fertig) {
        s.knoten.classList.toggle('mo-erledigt', fertig);
        geaendert = true;
      }
      /* Der Haken haengt am Zusammenspiel aus gesehen UND ausgefuellt —
         siehe besucht(). Die Klasse wird hier gepflegt, nicht in merken(),
         damit sie wieder verschwindet, wenn jemand ein Pflichtfeld leert. */
      var hakenAn = besucht(s);
      if (s.knoten.classList.contains(BESUCHT) !== hakenAn) {
        s.knoten.classList.toggle(BESUCHT, hakenAn);
        geaendert = true;
      }
    }
    return geaendert;
  }

  /* ---- Hinweis, solange ein Pflichtfeld leer ist -----------------------
     Gemessen am 06.08.2026: Sind die Maßfelder leer, zeigt die Preisuebersicht
     280,00 EUR statt 300,31 EUR — den Grundpreis OHNE Maßzuschlag. Ein Kunde
     haelt das fuer den Endpreis und sieht ihn beim Ausfuellen steigen. Solange
     also Pflichtangaben fehlen, sagt eine Zeile in der Preisuebersicht klar,
     dass die Summe noch nicht vollstaendig ist. */
  /* Nur der Produktpreis und der Preis am Sticky-Kaufknopf duerfen ein "ab"
     tragen. Ein Filter auf Sichtbarkeit reicht dafuer NICHT: Weiter unten
     stehen die empfohlenen Produkte, deren .price-item--regular beim Scrollen
     sichtbar werden und sonst ebenfalls ein "ab" bekaemen. */
  function preiseAb(an) {
    var z = [].slice.call(document.querySelectorAll('.price-item--regular'))
      .filter(function (e) {
        return e.closest('.product__info-container') ||
               e.closest('[class*="product-sticky"]');
      });
    var g = document.querySelector('.cl-po--price-summary-total .cl-po--price-summary-value');
    if (g) z.push(g);
    for (var i = 0; i < z.length; i++) z[i].classList.toggle('mo-ab-preis', an);
  }

  /* Platzhalter in den Maßfeldern.
     Der Optionstyp "dimension" kennt in LPO KEINEN placeholder-Parameter —
     geprueft am 07.08.2026 mit draft_learnOption. Ein dort gesetzter Wert
     wird stillschweigend verworfen. Seit die Felder leer starten, braucht der
     Kunde aber einen Anhalt, welche Groessen ueberhaupt gehen; die Grenzen
     stehen sonst nur in der Fehlermeldung nach dem Fehlversuch. */
  /* Massbereich aus der Tabelle in MO_KONFIG (anderer Block, deshalb ueber
     window). Faellt sie aus, bleibt es beim Gitter-Bereich. */
  function moBereich() {
    var kf = window.MO_KONFIG || {};
    var wr = document.querySelector('.cl-po--wrapper');
    var wt = wr && wr.closest('[id]');
    return (wt && kf[wt.id] && kf[wt.id].bereich) || '300 – 2200';
  }

  /* Schwester von moBereich() fuer das Mindestmass im "ab"-Hinweis.
     ⚠️ Bewusst hier noch einmal ausgeschrieben statt moKonfig() aus dem Block
     der Preisuebersicht zu rufen: custom.js besteht aus acht getrennten IIFE,
     ein Zugriff ueber Blockgrenzen wirft ReferenceError und legt den ganzen
     Block still. Am 11.08.2026 genau so passiert. Gemeinsam ist beiden nur
     window.MO_KONFIG. Kein Eintrag heisst: leerer Rueckgabewert, der Aufrufer
     laesst die Massangabe dann weg. */
  function moMindest() {
    var kf = window.MO_KONFIG || {};
    var wr = document.querySelector('.cl-po--wrapper');
    var wt = wr && wr.closest('[id]');
    return (wt && kf[wt.id] && kf[wt.id].mindest) || '';
  }

  function massePlatzhalter() {
    var w = wurzel(); if (!w) return;
    /* 11.08.2026: zusaetzlich .cl-po--dimension-item — der Handlauf nennt sein
       Massfeld "Länge", nicht "Maße", und wurde vom Selektor nie erfasst.
       wurzel() haelt die Suche ohnehin im Konfigurator. */
    var f = w.querySelectorAll('[data-option="Maße"] input[type="number"], ' +
                               'input[name="properties[_Maße_x]"], ' +
                               'input[name="properties[_Maße_y]"], ' +
                               '.cl-po--dimension-item input[type="text"]');
    for (var i = 0; i < f.length; i++) {
      if (f[i].placeholder) continue;
      /* 11.08.2026: Der Bereich kommt aus MO_KONFIG. Vorher stand hier fest
         der Gitter-Bereich auf jeder Seite — auf Balkon und Stange also die
         falschen Grenzen. Die Felder selbst tragen kein min/max, gemessen am
         11.08.2026 (beide null), deshalb die Tabelle.
         ⚠ Der Bereich steht ein zweites Mal in custom.css, Abschnitt 60, als
         Hinweistext unter dem Feld. Wer hier aendert, aendert dort mit. */
      f[i].placeholder = moBereich();
    }
  }

  function preisHinweis() {
    massePlatzhalter();
    var alle = schritte(), fehlt = false;
    for (var i = 0; i < alle.length; i++) if (!ausgefuellt(alle[i])) { fehlt = true; break; }

    /* Zuerst das "ab" — es haengt nicht an der Preisuebersicht und muss auch
       auf dem Handy gesetzt werden, wo die Uebersicht ausgeblendet ist. */
    preiseAb(fehlt);

    /* Den Preis in der Leiste aus der Summenzeile spiegeln. Das "ab" kommt
       ueber dieselbe Klasse wie ueberall sonst, damit beide Anzeigen nie
       auseinanderlaufen koennen. */
    if (preisEl) {
      var g = document.querySelector('.cl-po--price-summary-total .cl-po--price-summary-value');
      if (g) {
        var neu = g.textContent.trim();
        if (preisEl.textContent !== neu) preisEl.textContent = neu;
        preisEl.classList.toggle('mo-ab-preis', fehlt);
      }
    }

    var ps = document.querySelector('.cl-po--price-summary');
    if (!ps) return;
    var h = document.getElementById('mo-preis-hinweis');
    if (!fehlt) { if (h && h.parentNode) h.parentNode.removeChild(h); return; }
    if (!h) {
      h = document.createElement('div');
      h.id = 'mo-preis-hinweis';
      h.className = 'mo-preis-hinweis';
      /* ⚠️ 12.08.2026: Das Mindestmass kommt aus MO_KONFIG. Vorher stand hier
         fest "300 × 300 mm" — das Fenstergitter-Mass, auf der Handlaufseite
         also glatt falsch (dort gilt 100 mm Länge). Faellt der Eintrag weg,
         entfaellt die Massangabe und der Satz bleibt trotzdem richtig. */
      var mindest = moMindest();
      h.textContent = mindest
        ? 'Preis für das Mindestmaß ' + mindest + ' — bitte tragen Sie Ihr Maß ein.'
        : 'Bitte tragen Sie Ihr Maß ein.';
      ps.appendChild(h);
    } else if (h.parentNode !== ps) {
      ps.appendChild(h);
    }
  }

  /* ---- Beobachter statt Zeitgeber (2.5.0) -------------------------------
     ZWEI FEHLER, die Stefan am 07.08.2026 gefunden hat, haben dieselbe Wurzel:
     Der Takt in start() laeuft nur, bis dreimal nichts mehr passiert ist,
     spaetestens 15 Sekunden. Danach zieht nichts mehr nach.

     a) DER PREIS IN DER LEISTE BLIEB STEHEN, wenn der Kunde nur die Maße
        tippt. aufAenderung() ruft preisHinweis() nach 60ms — da hat LPO noch
        nicht fertig gerechnet, in der Summenzeile steht der alte Wert. Der
        Klick-Weg fasst zweimal nach (80/400ms) und traf deshalb zufaellig.
        Live gesehen: Leiste 280,00 EUR, Aufschluesselung darunter 349,85 EUR.
     b) DIE LEISTE RUTSCHTE unter den Kaufknopf. mo_uebersicht_unter_bild.js
        haengt die Preisuebersicht per eigenem Observer um; passiert das nach
        unserem einhaengen(), bleibt die Leiste an der alten Stelle stehen.

     Noch mehr Zeitgeber waeren geraten. Der Beobachter reagiert stattdessen
     darauf, dass die App den Wert wirklich geaendert oder das Element wirklich
     verschoben hat — egal wie lange sie dafuer braucht. */
  var beobachtetZiel = null, imBeobachter = false;
  function beobachten() {
    var ps = document.querySelector('.cl-po--price-summary');
    if (!ps) return;
    /* Den STABILEN Behaelter beobachten, nicht die Uebersicht selbst: Wird sie
       umgehaengt, wuerde ein Beobachter auf ihr die Bewegung nicht bemerken. */
    var ziel = ps.closest('.product__below-media') ||
               ps.closest('.cl-po--options') || ps.parentNode;
    if (!ziel || ziel === beobachtetZiel) return;
    beobachtetZiel = ziel;
    new MutationObserver(function () {
      if (imBeobachter) return;          // wir aendern selbst im Ziel
      imBeobachter = true;
      setTimeout(function () {
        einhaengen();
        preisHinweis();
        imBeobachter = false;
      }, 0);
    }).observe(ziel, { childList: true, subtree: true, characterData: true });
  }

  /* ---- Warenkorb in der geklebten Leiste (2.6.0) -----------------------
     Das Sinnbild wird aus dem Kopf geklont statt neu gezeichnet: So bleibt es
     dasselbe Symbol, auch wenn Stefan es im Theme einmal austauscht. */
  function korbBauen() {
    korbEl = document.createElement('a');
    korbEl.className = 'mo-korb';
    korbEl.href = '/cart';
    korbEl.setAttribute('aria-label', 'Warenkorb');
    var quelle = document.getElementById('cart-icon-bubble');
    var bild = quelle ? quelle.querySelector('svg') : null;
    /* Symbol und Stueckzahl stecken in einer eigenen Huelle (2.6.3), damit die
       Blase am Symbol haengt und nicht am Rand des Knopfes — sonst rutscht sie
       ans Ende der Beschriftung, sobald der Knopf breiter wird. */
    var huelle = document.createElement('span');
    huelle.className = 'mo-korb-bild';
    if (bild) huelle.appendChild(bild.cloneNode(true));
    else huelle.textContent = '🛒';
    zahlEl = document.createElement('span');
    zahlEl.className = 'mo-korb-zahl';
    huelle.appendChild(zahlEl);
    korbEl.appendChild(huelle);
    /* Beschriftung (2.6.3, Stefans Vorgabe vom 07.08.2026). Bewusst
       "Warenkorb" und nicht "In den Warenkorb legen": Dieser Knopf legt nichts
       hinein, er oeffnet, was schon drin liegt. Am Handy blendet die
       Media-Query ihn aus — dort sind von 355 nutzbaren Pixeln nur rund 24
       frei, und die Schrittkette ist die wichtigere Auskunft. */
    /* Ohne Beschriftung (2.11.0): Mit "Warenkorb" war der Knopf 151 statt
       40px breit, und im Kaufmodus schob sich "In den Warenkorb legen"
       darueber — am 07.08.2026 im Laden gesehen. Das Sinnbild mit Stueckzahl
       ist die gelaeufige Form und kostet ein Viertel des Platzes. */
    /* Durchklicken statt navigieren — das Theme hat eine cart-drawer, und die
       soll sich hier genauso oeffnen wie oben. Fehlt der Kopf-Knopf, bleibt
       das href stehen und fuehrt regulaer auf /cart. */
    korbEl.addEventListener('click', function (e) {
      var knopf = document.getElementById('cart-icon-bubble');
      if (!knopf) return;
      e.preventDefault();
      knopf.click();
    });
    korbZahl();
    if (quelle) {
      new MutationObserver(korbZahl).observe(quelle,
        { childList: true, subtree: true, characterData: true });
    }
  }

  function korbZahl() {
    if (!zahlEl) return;
    var b = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
    var n = b ? (b.textContent || '').trim() : '';
    /* Leerer Text heisst per CSS :empty auch keine Blase — Dawn rendert die
       Blase bei leerem Warenkorb gar nicht erst. */
    zahlEl.textContent = (n && n !== '0') ? n : '';
  }

  /* ---- Kleben (2.6.0) ---------------------------------------------------
     Zwei IntersectionObserver und ein MutationObserver, kein Scroll-Listener.
     Oben:  der Platzhalter. Verlaesst er das Bild NACH OBEN, geht die Leiste
            aus dem Fluss. Die Pruefung auf boundingClientRect.top < 0 ist
            noetig, weil ein Element auch unten aus dem Bild fallen kann —
            beim Hochscrollen zum Seitenanfang etwa.
     Unten: der Kaufknopf. Ist er im Bild, ist der Kunde am Ziel; dann loesen
            wir und ueberlassen das Feld der Theme-Kaufleiste. */
  var obenBeob = null, untenBeob = null, zielKnoten = null, kopfBeob = null;

  /* Seit 2.9.0 leer: Die Leiste sitzt immer bei top:0, weil der Kopf weicht.
     Das Nachrechnen der Kopfunterkante ist damit hinfaellig — und es war die
     Stelle, an der die Leiste im Kopf steckenblieb. Die Funktion bleibt als
     Aufrufpunkt bestehen, damit die Beobachter unveraendert weiterlaufen. */
  function topSetzen() {}

  function klebeZustand() {
    if (!leiste || !platz || !platz.parentNode) return;
    /* 2.7.0: Die Leiste bleibt, sobald sie einmal klebt — bis zum Seitenende.
       Vorher hing das zusaetzlich daran, ob der Kaufknopf gerade im Bild ist.
       Das war ein Denkfehler: "gerade sichtbar" gilt nur fuer einen einzigen
       Fensterausschnitt. Am 07.08.2026 gemessen (1440x900): Die Leiste
       verschwand zwischen Scrollposition 1305 und 2158 und kam danach fuer
       4022 Pixel zurueck — ein Loch mitten in der Seite. Was der Kaufknopf
       jetzt noch steuert, ist die Beschriftung, nicht die Sichtbarkeit. */
    var soll = obenRaus && begonnen;
    if (soll === klebt) { if (klebt) topSetzen(); return; }
    klebt = soll;
    if (klebt) {
      /* Seit 2.8.0 haelt der Platzhalter keine Hoehe mehr: Die Leiste steht
         dauerhaft ausserhalb des Flusses, es gibt also keinen Platz zu
         reservieren. Er bleibt als Marker fuer die Pruefung stehen. */
      platz.classList.add('mo-aktiv');
      leiste.classList.add('mo-fix');
      /* Die linke Spalte klebt seit Abschnitt 37 in custom.css bei top:100px.
         Unsere Leiste haengt darueber und reicht weiter herunter — ohne diesen
         Wert lagen ihre oberen 83px dahinter (07.08.2026 gemessen). Gerechnet
         aus Kopfhoehe + Leistenhoehe + 8px Luft, damit er der Leiste folgt,
         statt eine feste Zahl zu raten. Gesetzt wird eine Variable, nicht die
         fremde Regel: So bleibt Abschnitt 37 unangetastet. */
      var kopfEl = document.querySelector('#shopify-section-header .header-wrapper');
      var hoehe = Math.round(leiste.getBoundingClientRect().height) || 65;
      var kopfH = kopfEl ? Math.round(kopfEl.getBoundingClientRect().height) : 83;
      var unten = (kopfH + hoehe + 8) + 'px';
      document.documentElement.style.setProperty('--mo-leiste-unten', unten);
      /* 2.12.0 — DER NAME, DEN ABSCHNITT 37 WIRKLICH LIEST.
         Der Abschnitt "Produktbild klebt mit" in custom.css setzt die linke
         Spalte auf `top: var(--mo-klebe-oben, 100px)` und rechnet ihre
         max-height mit derselben Variablen. 100px sind Kopf (83) plus Luft —
         die geklebte Leiste reicht aber bis 148, ihre oberen rund 48px lagen
         dahinter. Das Briefing der Nachbarsitzung schlaegt dafuer eine feste
         Zeile `--mo-klebe-oben: 160px` im CSS vor; hier steht stattdessen der
         gemessene Wert, damit er der Leiste folgt, statt eine Zahl zu raten
         (mobil ist sie 57 hoch, ab sieben Schritten zweizeilig).
         Gesetzt am <html>, von wo .product sie erbt — Abschnitt 37 selbst
         bleibt unangetastet, es gibt also nichts abzustimmen. */
      document.documentElement.style.setProperty('--mo-klebe-oben', unten);
      document.documentElement.classList.add('mo-leiste-fix');
      topSetzen();
    } else {
      leiste.classList.remove('mo-fix');
      leiste.style.top = '';
      platz.classList.remove('mo-aktiv');
      platz.style.height = '';
      platz.style.marginTop = '';
      platz.style.marginBottom = '';
      document.documentElement.classList.remove('mo-leiste-fix');
      /* Beide Variablen wieder abraeumen (2.12.0). Blieben sie stehen, hielte
         die klebende Bildspalte auch dann 156px Abstand nach oben frei, wenn
         gar keine Leiste mehr da ist — sichtbar als Loch unter dem Kopf. */
      document.documentElement.style.removeProperty('--mo-leiste-unten');
      document.documentElement.style.removeProperty('--mo-klebe-oben');
    }
  }

  function kleben() {
    if (!platz || !platz.parentNode || !fuehler || !fuehler.parentNode) return;
    if (!obenBeob) {
      obenBeob = new IntersectionObserver(function (e) {
        var i = e[0];
        obenRaus = !i.isIntersecting && i.boundingClientRect.top < 0;
        klebeZustand();
      }, { threshold: 0 });
      obenBeob.observe(fuehler);

      var k = document.getElementById('shopify-section-header');
      if (k && !kopfBeob) {
        kopfBeob = new MutationObserver(topSetzen);
        kopfBeob.observe(k, { attributes: true, attributeFilter: ['class'] });
      }
      /* Beim Drehen des Geraets aendert sich die Hoehe der Leiste. Einmal
         loesen und neu kleben ist ehrlicher, als eine geratene Hoehe
         weiterzutragen — Resize ist selten genug dafuer. */
      window.addEventListener('resize', function () {
        if (!klebt) return;
        klebt = false;
        leiste.classList.remove('mo-fix');
        leiste.style.top = '';
        platz.classList.remove('mo-aktiv');
        platz.style.height = '';
        platz.style.marginTop = '';
        platz.style.marginBottom = '';
        document.documentElement.classList.remove('mo-leiste-fix');
        document.documentElement.style.removeProperty('--mo-leiste-unten');
        document.documentElement.style.removeProperty('--mo-klebe-oben');
        klebeZustand();
      });
    }
    var ziel = document.querySelector('.main-product__template .product-form__submit') ||
               document.querySelector('.product-form__submit');
    if (ziel && ziel !== zielKnoten) {
      zielKnoten = ziel;
      if (untenBeob) untenBeob.disconnect();
      untenBeob = new IntersectionObserver(function (e) {
        /* "vorbei" heisst: der Kaufknopf ist nach OBEN aus dem Bild gewandert,
           der Kunde ist also daran vorbei. Die Pruefung auf top < 0 ist der
           Unterschied zu "gerade nicht sichtbar" — solange er noch unter dem
           Bildrand wartet, ist er nicht vorbei. */
        var i = e[0];
        vorbei = !i.isIntersecting && i.boundingClientRect.top < 0;
        knopfSetzen();
      }, { threshold: 0 });
      untenBeob.observe(ziel);
    }
  }

  /* ---- Leiste ---------------------------------------------------------- */
  function leisteBauen() {
    if (leiste) return;
    leiste   = document.createElement('div');
    txtEl    = document.createElement('span');
    punkteEl = document.createElement('div');
    weiterEl = document.createElement('button');
    leiste.className   = 'mo-leiste';
    txtEl.className    = 'mo-leiste-txt';
    punkteEl.className = 'mo-punkte';
    weiterEl.className = 'mo-weiter';
    weiterEl.type      = 'button';
    /* Der Gesamtpreis in der Leiste (2.4.0). Er steht sonst nur in der
       Aufschluesselung darunter — wer oben am Bild konfiguriert, sieht ihn
       dort nicht. Gespiegelt wird die Summenzeile, nicht neu gerechnet:
       Preise gehoeren in die Preisformel der App, nie ins Design-JS. */
    preisEl = document.createElement('span');
    preisEl.className = 'mo-leiste-preis';
    /* Platzhalter und Warenkorb (2.6.0). Der Platzhalter ist zugleich der
       Fuehler des oberen Observers: Er steht immer unmittelbar vor der Leiste,
       hat im Fluss die Hoehe 0 und uebernimmt beim Kleben ihre Hoehe. */
    platz = document.createElement('div');
    platz.className = 'mo-leiste-platz';
    platz.setAttribute('aria-hidden', 'true');
    /* Der Fuehler loest das Kleben aus und ist NICHT der Platzhalter (2.6.2).
       Auf dem Handy sitzt die Leiste am Ende der Optionsliste — ihr eigener
       Platzhalter kommt dort erst ins Spiel, wenn der Kunde schon fast am
       Kaufknopf ist. Genau deshalb war die Leiste mobil nie zu sehen. Der
       Fuehler haengt stattdessen am Anfang der Optionsliste: Die Leiste klebt,
       sobald der Kunde in den Konfigurator eintaucht — auf beiden Geraeten. */
    fuehler = document.createElement('div');
    fuehler.className = 'mo-leiste-platz mo-leiste-fuehler';
    fuehler.setAttribute('aria-hidden', 'true');
    /* ⚠️ 2.14.0 — DER WARENKORB IN DER LEISTE IST ENTFALLEN.
       Er kam in v2.6.0 hinein, weil die Leiste damals den Kopf ERSETZTE und
       Stefan sonst keinen Weg zum Warenkorb mehr hatte ("durch den
       Konfigurator sehe ich oben den Warenkorb nicht wenn ich runterscrolle").
       Seit v2.11.0 bleibt der Kopf stehen und traegt sein eigenes Symbol —
       damit standen zwei Warenkoerbe uebereinander. Stefan am 07.08.2026:
       raus damit; wenn alles erledigt ist, kommt ohnehin der orange
       "In den Warenkorb legen"-Knopf (Alinas Anmerkung, seit v2.13.0).
       Auf KORB_IN_LEISTE = true steht er wieder da. Der Bauteil-Code bleibt
       erhalten, wird aber nur dann ausgefuehrt: So faellt auch der
       MutationObserver auf die Warenkorbzahl weg, den er sonst dauerhaft
       haelt. */
    if (KORB_IN_LEISTE) korbBauen();
    /* Innerer Behaelter (2.6.1): traegt das Flex-Layout, damit die geklebte
       Fassung ihn auf Seitenbreite begrenzen kann, waehrend der weisse Grund
       ueber die volle Fensterbreite laeuft. zeichnen() greift die Teile ueber
       Variablen ab, nicht ueber die Baumstruktur — der Behaelter aendert dort
       also nichts. */
    var innen = document.createElement('div');
    innen.className = 'mo-leiste-innen';
    /* Logo (2.9.0): Die Leiste ersetzt den Kopf, also braucht sie dessen
       Rueckweg. Geklont statt nachgebaut — so bleibt es dasselbe Zeichen,
       auch wenn Stefan es im Theme austauscht. Am Handy blendet die
       Media-Query es aus, dort zaehlt jeder Pixel. */
    var kopfLogo = document.querySelector('.header__heading-logo, .header__heading img, .header__heading-link img');
    if (kopfLogo) {
      var logoLink = document.createElement('a');
      logoLink.className = 'mo-logo';
      logoLink.href = '/';
      logoLink.setAttribute('aria-label', 'Zur Startseite');
      logoLink.appendChild(kopfLogo.cloneNode(true));
      innen.appendChild(logoLink);
    }
    innen.appendChild(txtEl);
    innen.appendChild(punkteEl);
    innen.appendChild(preisEl);
    if (korbEl) innen.appendChild(korbEl);
    innen.appendChild(weiterEl);
    leiste.appendChild(innen);
    weiterEl.addEventListener('click', function (e) {
      /* ⚠️ Die Leiste steht im Produktformular (action="/cart/add"). type=
         "button" haelt einen Submit zwar ab, aber hier haengt eine Kaufstrecke
         dran — ein einziger Weg, auf dem der Knopf doch absendet, schickt den
         Kunden auf eine Fehlerseite statt zum naechsten Schritt. Deshalb
         zusaetzlich abgeraeumt. */
      e.preventDefault();
      /* Unterhalb des Kaufknopfes kauft der Knopf, statt weiterzufuehren. Er
         loest dazu den echten Kaufknopf aus — nicht das Formular direkt, damit
         LPO seine Pruefungen behaelt (fehlende Maße etwa).
         2.13.0: Dasselbe gilt, sobald alle Schritte erledigt sind — sonst
         steht der Kunde vor einem Knopf, der aussieht wie "kaufen" und
         stattdessen weiterblaettert. */
      if (vorbei || allesFertig()) {
        var haupt = document.querySelector('.main-product__template .product-form__submit') ||
                    document.querySelector('.product-form__submit');
        if (haupt) haupt.click();
        return;
      }
      var alle = schritte();
      var hier = -1;
      for (var i = 0; i < alle.length; i++) if (offen(alle[i])) { hier = i; break; }
      if (hier >= 0) merken(alle[hier]);
      /* 20.08.2026: unfertigen Schritt nicht stumm verlassen - hinzeigen statt
         weiterblaettern. Siehe Kopf bei hinweisen(). */
      if (hier >= 0 && !ausgefuellt(alle[hier])) { hinweisen(alle[hier]); zeichnen(); return; }
      var ziel = null;
      for (var j = (hier < 0 ? 0 : hier + 1); j < alle.length; j++) { ziel = alle[j]; break; }
      if (!ziel) for (var k = 0; k < alle.length; k++) if (!besucht(alle[k])) { ziel = alle[k]; break; }
      if (ziel) nurDieser(ziel, true);
      zeichnen();
    });
  }

  /* Akkordeon-Kern: genau einer offen. */
  /* Akkordeon-Kern: genau einer offen.

     DER SPRUNG BEIM KOPFKLICK (20.08.2026, v2.16.1). Stefan: "wenn Maße
     ausgeklappt dann Farbe auswählen da springt er."

     Ursache: Beim Umklappen faellt der vorher offene Schritt zusammen. Steht
     er OBERHALB des angetippten - Maße vor Farbe - verschwinden auf einen
     Schlag 825 px aus dem Fluss, und alles darunter rutscht um diesen Betrag
     hoch. Gemessen bei 375 x 812: der angetippte Kopf sprang von top 500 auf
     -243, also 743 px aus dem Bild heraus.

     🔴 WARUM ES NUR AUF DEM IPHONE AUFTRAT: Chrome und Firefox gleichen so
     etwas von selbst aus (CSS Scroll Anchoring), SAFARI NICHT. Am Rechner ist
     der Fehler deshalb unsichtbar. Nachgestellt wird er mit
     `overflow-anchor: none` auf allen Elementen - erst dann zeigt auch Chrome
     die 743 px.

     Das alte `scrollIntoView({block:'nearest', behavior:'smooth'})` hat daran
     NICHTS geaendert, an derselben Messung nachgewiesen:
       - `nearest` scrollt nur, wenn das Ziel ausserhalb liegt. Zur Aufrufzeit,
         direkt nach dem Klassenwechsel, haelt der Browser es noch fuer
         sichtbar - er hat den Umbruch noch nicht angewandt.
       - `smooth` haengt an base.css und wurde hier schon einmal zum
         Blindgaenger (siehe der Kommentar am Fertigungs-Knopf weiter unten).

     JETZT: nach dem Umklappen wird die Lage des angetippten Kopfes GEMESSEN -
     der Aufruf von getBoundingClientRect erzwingt dabei den Umbruch, die Werte
     sind also die neuen - und nur dann gescrollt, wenn er aus dem brauchbaren
     Bereich gefallen ist: hinter das, was oben klebt, oder unter 75 % der
     Fensterhoehe. Dann kommt er mit `instant` sauber unter die klebenden
     Leisten.

     ⚠ Bewusst NICHT bei jedem Klick scrollen. Steht der Kopf noch gut, bleibt
     die Seite stehen - am Rechner (wo der Browser selbst ankert) aendert sich
     damit nichts am gewohnten Verhalten. */
  function nurDieser(ziel, scrollen) {
    var alle = schritte();
    /* ⚠ VOR dem Umklappen aufrufen - ankerHalten merkt sich die JETZIGE Lage
       und haelt sie fest, waehrend darueber ein Schritt zusammenfaellt.

       NUR wenn nicht ohnehin gescrollt wird: `scrollen` heisst "fuehre den
       Kunden zum Ziel" (Weiter-Knopf, Schrittpunkte in der Leiste) - dort ist
       Bewegung gewollt, und beides zugleich wuerde gegeneinander arbeiten.

       🔴 DER FEHLER IM ERSTEN ANLAUF (v2.16.1/2.16.2): Der Anker hing im
       scrollen-Zweig. Der KOPFKLICK ruft aber `nurDieser(schritt, false)` -
       genau Stefans Weg ("wenn Maße ausgeklappt dann Farbe auswählen"). Der
       Anker lief damit nie. Nachgewiesen, indem `window.scrollBy`
       mitgeschrieben wurde: null Aufrufe, Sprung trotzdem 743 px. */
    if (ziel && !scrollen) ankerHalten(ziel.kopf);
    /* ⭐ MOBIL WIRD NICHTS MEHR ZUGEKLAPPT (v2.17.0, Stefans Entscheidung).
       "jegliches springen verhindern ... sonst nicht mehr zuklappen mobil?"

       Das ist die Wurzel, nicht das Symptom: Ein Schritt, der zusammenfaellt,
       nimmt seine Hoehe aus dem Fluss. Steht er OBERHALB, rutscht alles
       darunter nach - und genau das ist der Sprung. Wo nichts mehr zugeht,
       kann auch nichts mehr rutschen, unabhaengig von Reihenfolge, Hoehe und
       Browser.

       Der Haken wird trotzdem gesetzt (merken), sonst fehlt er in der
       Schrittleiste.

       AM RECHNER bleibt das Akkordeon wie gehabt - dort steht der Konfigurator
       in einer eigenen Spalte, Stefans Vorgabe vom 08.08.2026 gilt weiter.

       Der Kunde kann mobil weiterhin selbst zuklappen, indem er einen offenen
       Kopf antippt - das macht die App. Fuer diesen Fall bleibt ankerHalten()
       oben als Netz stehen. */
    var zuklappen = !mobilSchmal();
    for (var i = 0; i < alle.length; i++) {
      if (alle[i] === ziel || alle[i].knoten === ziel.knoten) aufmachen(alle[i]);
      else if (offen(alle[i])) { merken(alle[i]); if (zuklappen) zumachen(alle[i]); }
      else if (zuklappen) zumachen(alle[i]);
    }
    if (scrollen && ziel) ziel.kopf.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  /* Haelt ein Element waehrend der Klapp-Animation an seiner Bildschirmposition.

     ⚠ WARUM NICHT EINMALIG MESSEN UND KORRIGIEREN: Das Auf- und Zuklappen ist
     eine CSS-Transition der App (`.cl-po--collapse` traegt `0.4s`,
     `.cl-po--option` sogar `transition: all`). Direkt nach dem Klassenwechsel
     steht die ALTE Hoehe noch da - am 20.08. Schritt fuer Schritt gemessen,
     Maße-Schritt beim Zuklappen:

         t=0 ms   825 px   Kopf top 500
         t=60     807      483
         t=120    809      485
         t=250     82     -243   <- erst hier faellt es
         t=400     82     -243

     Ein synchroner Ausgleich im Klick-Handler greift deshalb ins Leere: er
     misst 825 und findet nichts zu tun. Genau daran ist der erste Anlauf
     (v2.16.1) gescheitert - nachgewiesen, indem `window.scrollTo`
     mitgeschrieben wurde: **null Aufrufe**, Sprung trotzdem 743 px.

     Deshalb wird ueber die Dauer der Animation nachgefuehrt. Sichtbar ist das
     nicht: der Anker steht still, waehrend sich darueber etwas schliesst -
     genau das, was Chrome von sich aus macht (CSS Scroll Anchoring) und was
     SAFARI NICHT KANN. Darum trat der Sprung nur auf dem iPhone auf.

     Kein `smooth` - Pflicht, siehe der Kommentar am Fertigungs-Knopf.

     Der Kunde behaelt das Kommando: die erste eigene Geste (Wischen, Rad,
     Taste) bricht das Nachfuehren ab. Und es laeuft ueber `setTimeout`, nicht
     ueber requestAnimationFrame - rAF wird auf mobilen Geraeten gedrosselt,
     und beides zusammen zu planen liesse die Aufrufe verdoppeln. */
  function ankerHalten(el) {
    if (!el || !el.getBoundingClientRect) return;
    var soll = el.getBoundingClientRect().top;
    var ende = Date.now() + 600;          /* 0,4 s Animation plus Reserve */
    var aus  = false;
    function stopp() { aus = true; }
    ['touchstart', 'wheel', 'keydown'].forEach(function (n) {
      addEventListener(n, stopp, { once: true, passive: true });
    });
    (function schritt() {
      if (aus) return;
      var d = el.getBoundingClientRect().top - soll;
      if (d) window.scrollBy({ top: d, behavior: 'instant' });
      if (Date.now() < ende) setTimeout(schritt, 16);
      else ['touchstart', 'wheel', 'keydown'].forEach(function (n) {
        removeEventListener(n, stopp);
      });
    })();
  }

  function zeichnen() {
    if (!leiste) return;
    var alle = schritte();
    if (!alle.length) return;
    var hier = -1;
    for (var i = 0; i < alle.length; i++) if (offen(alle[i])) { hier = i; break; }
    if (hier < 0) for (var j = 0; j < alle.length; j++) if (!besucht(alle[j])) { hier = j; break; }

    /* Ab sieben Schritten zweizeilig — siehe Begruendung am CSS oben. */
    leiste.classList.toggle('mo-viele', alle.length > 6);

    punkteEl.innerHTML = '';
    for (var k = 0; k < alle.length; k++) {
      if (k) {
        var l = document.createElement('span');
        l.className = 'mo-strich' + (besucht(alle[k - 1]) ? ' mo-fertig' : '');
        punkteEl.appendChild(l);
      }
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mo-punkt' + (besucht(alle[k]) ? ' mo-fertig' : '') + (k === hier ? ' mo-hier' : '');
      /* Haken auch am AKTUELLEN Schritt (2.15.3). Vorher stand hier zusaetzlich
         "&& k !== hier", der gerade offene Punkt zeigte also seine Nummer statt
         des Hakens - bei "Alle Angaben vollstaendig" blieb einer ohne Haken
         stehen, obwohl er erledigt war. Von Stefan am 08.08.2026 gemeldet.
         Die Position geht dadurch nicht verloren: .mo-hier traegt ohnehin einen
         eigenen Ring (box-shadow 0 0 0 3px #fdece1), der Punkt ist also auch mit
         Haken als "hier" erkennbar. */
      b.textContent = besucht(alle[k]) ? '✓' : (k + 1);
      b.title = titelVon(alle[k]);
      (function (ziel) {
        b.addEventListener('click', function () { nurDieser(ziel, true); zeichnen(); });
      })(alle[k]);
      punkteEl.appendChild(b);
    }

    var fehlen = 0;
    for (var m = 0; m < alle.length; m++) if (!besucht(alle[m])) fehlen++;
    if (fehlen === 0) {
      leiste.classList.add('mo-fertig');
      txtEl.textContent  = 'Alle Angaben vollständig';
    } else {
      leiste.classList.remove('mo-fertig');
      txtEl.textContent  = 'Schritt ' + (hier < 0 ? 1 : hier + 1) + ' von ' + alle.length;
    }
    knopfSetzen();
  }

  /* ---- Beschriftung des Knopfes (2.7.0) --------------------------------
     Die Leiste steht jetzt durchgehend, also muss der Knopf sagen, was an
     DIESER Stelle der Seite dran ist. Oberhalb des Kaufknopfes fuehrt er durch
     die Schritte, unterhalb kauft er — dort ist "Weiter" sinnlos, und der
     Kunde soll von den FAQ oder den Bewertungen aus bestellen koennen, ohne
     wieder hochzuscrollen. */
  /* Alle sichtbaren Schritte erledigt? (2.13.0)
     Zaehlt nur, was auch zu sehen ist — eine ausgeblendete Gruppe wie
     Spitzenform bei Gittern ohne Spitzen faellt ueber schritte() ohnehin
     heraus. */
  function allesFertig() {
    var alle = schritte();
    if (!alle.length) return false;
    for (var i = 0; i < alle.length; i++) if (!besucht(alle[i])) return false;
    return true;
  }

  /* ---- RUECKMELDUNG AM UNFERTIGEN SCHRITT (20.08.2026, 19:30) ----------
     Gemessen am selben Tag: Steht der Maszschritt offen und sind die Felder
     leer, schluckt "Weiter" den Klick STUMM - keine Meldung, kein Rahmen, kein
     Fokuswechsel, keine Klassenaenderung. Der Kunde kann nicht unterscheiden,
     ob der Knopf kaputt ist oder ihm eine Angabe fehlt.

     Zwei Teile, bewusst ohne neues Textfeld:
       1. Der Knopf BENENNT vorher, was fehlt ("Maße eintragen ›").
       2. Der Klick ZEIGT HIN - farbiger Rahmen am leeren Feld, 2,6 Sekunden.

     ⚠️ KEIN eingefuegter Hinweistext. Ein zusaetzlicher Absatz im Fluss macht
     den Schritt hoeher und schiebt alles darunter - genau der Sprung, der am
     20.08. aus dem Aufmaszblock ausgebaut wurde. Der Rahmen kostet 0 px.

     ⚠️ FOKUS NUR MIT FEINEM ZEIGER. focus() oeffnet auf dem Handy die Tastatur,
     und die schiebt auf iOS die halbe Seite. Auf Touchgeraeten bleibt es beim
     Rahmen. */
  var hinweisUhr = null;

  function istMassSchritt(s) {
    return !!(s && s.knoten.querySelector('.cl-po--dimension-container'));
  }

  function fehltText(s) {
    var kurz = window.matchMedia('(max-width: 749px)').matches;
    if (istMassSchritt(s)) return kurz ? 'Maße ›' : 'Maße eintragen ›';
    var name = String(s.knoten.getAttribute('data-option') || '').replace(/^Schritt_/, '');
    if (name === 'Masse') name = 'Maße';
    if (!name) return 'Weiter ›';
    return kurz ? (name + ' ›') : (name + ' wählen ›');
  }

  function hinweisen(s) {
    if (!s) return;
    var ziel = s.knoten.querySelector('.cl-po--dimension-container input') ||
               s.knoten.querySelector('input[required], select[required], textarea[required]');
    s.knoten.classList.add('mo-fehlt');

    /* ⚠️ DIE MARKIERUNG WIRD INLINE GESETZT, NICHT PER KLASSE ALLEIN.
       Am 20.08. gemessen: Das Design-Profil der App setzt an genau diesen
       Feldern `border` mit !important
       (`.cl-po--option[data-option="Maße"] .cl-po--dimension-item input`).
       Unsere Regel in Abschnitt 78 traegt zwar ID-Gewicht, kam am Handy aber
       trotzdem nicht an - Rahmen blieb grau, box-shadow blieb leer. Statt im
       fremden Code aufzuruesten wird der Stil direkt am Element gesetzt und
       nach Ablauf wieder entfernt. Die Klasse bleibt fuer den Ring an der
       Kopfzeile (Abschnitt 78) zustaendig. */
    var felder = s.knoten.querySelectorAll('.cl-po--dimension-container input, input[required], select[required], textarea[required]');
    var gesetzt = [];
    for (var i = 0; i < felder.length; i++) {
      var f = felder[i];
      if (String(f.value || '').trim()) continue;      /* nur die LEEREN */
      f.style.setProperty('border-color', '#cb4f0a', 'important');
      f.style.setProperty('box-shadow', '0 0 0 3px #fdece1', 'important');
      gesetzt.push(f);
    }

    if (hinweisUhr) clearTimeout(hinweisUhr);
    hinweisUhr = setTimeout(function () {
      s.knoten.classList.remove('mo-fehlt');
      for (var j = 0; j < gesetzt.length; j++) {
        gesetzt[j].style.removeProperty('border-color');
        gesetzt[j].style.removeProperty('box-shadow');
      }
    }, 2600);
    if (!ziel) return;
    var r = ziel.getBoundingClientRect();
    /* Nur holen, wenn es wirklich auszerhalb steht - und ohne Animation. */
    if (r.top < 90 || r.bottom > window.innerHeight - 90) {
      try { ziel.scrollIntoView({ block: 'center', behavior: 'instant' }); }
      catch (e) { ziel.scrollIntoView(); }
    }
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      try { ziel.focus({ preventScroll: true }); } catch (e) { /* egal */ }
    }
  }

  function knopfSetzen() {
    if (!weiterEl || !leiste) return;
    /* ⚠️ 2.13.0 — "✓ Bereit" WAR EINE SACKGASSE.
       Alina am 07.08.2026: "Wenn alles erledigt wurde: Zum Warenkorb
       hinzufuegen = Farbe orange". Vorher stand dort ein gruener, DEAKTIVIERTER
       Knopf: Der Kunde hat alles ausgefuellt, die Leiste sagt "Bereit" — und
       genau in dem Moment ist der einzige Knopf tot. Der Weg zum Kauf lag
       ausserhalb des Bildes, unten am Konfigurator.
       Jetzt gilt der Kaufmodus in beiden Faellen: unterhalb des Kaufknopfes
       (vorbei) ODER sobald alle Schritte erledigt sind. */
    var kaufen = vorbei || allesFertig();
    leiste.classList.toggle('mo-modus-kaufen', kaufen);
    if (kaufen) {
      /* Mobil der kuerzere Text: "In den Warenkorb legen" braucht rund 175px,
         und auf 375px sind nach Preis und Korb keine 175 mehr frei. */
      weiterEl.textContent = window.matchMedia('(max-width: 749px)').matches
        ? 'In den Warenkorb' : 'In den Warenkorb legen';
      weiterEl.disabled = false;
      return;
    }
    /* Benennt den offenen Schritt, solange er unfertig ist. */
    var alle = schritte(), auf = null;
    for (var i = 0; i < alle.length; i++) if (offen(alle[i])) { auf = alle[i]; break; }
    weiterEl.textContent = (auf && !ausgefuellt(auf)) ? fehltText(auf) : 'Weiter ›';
    weiterEl.disabled = false;
  }

  /* ---- Platz der Leiste ------------------------------------------------
     Desktop: direkt unter die Preisuebersicht, so wie Stefan es wollte.
     Handy:   ans Ende der Optionsliste, also ueber den Kaufknopf.

     WARUM DIE LEISTE DER PREISUEBERSICHT NUR FOLGT UND SIE NICHT SELBST
     VERSCHIEBT: Fuer die Preisuebersicht ist der Block
     "Preisuebersicht unter das Bild holen" (mo_uebersicht_unter_bild.js)
     zustaendig. Der haengt an einem MutationObserver und holt sie zurueck,
     sobald sie jemand woanders hinstellt — zwei Skripte am selben Element
     ergeben ein Zucken oder eine Endlosschleife. Auf dem Handy ist ihr
     Behaelter ohnehin per small-hide ausgeblendet; dass die Aufschluesselung
     dort komplett fehlt, ist ein eigener Punkt und gehoert in jenen Block. */
  function einhaengen() {
    var w = wurzel();
    if (!w || !leiste) return;
    var optionen = w.querySelector('.cl-po--options');

    /* 2.11.0: Die Leiste haengt IM Kopfbereich, als dessen letztes Kind —
       Stefans Vorgabe vom 07.08.2026: "unter dem Hauptmenue anzeigen".
       Der Trick daran: `#shopify-section-header` wird beim Scrollen selbst
       `position: sticky`. Ein Kind mit `position:absolute; top:100%` sitzt
       damit IMMER unmittelbar unter ihm und klebt automatisch mit — ohne die
       Kopfunterkante nachzurechnen. Genau dieses Nachrechnen war die Stelle,
       an der die Leiste vorher im Kopf steckenblieb.
       Weil sie absolut positioniert ist, waechst der Kopf dabei nicht: Der
       Seiteninhalt darunter bleibt stehen, wo er ist. */
    /* ⚠️ NICHT an #shopify-section-header, sondern an den .header-wrapper
       darin: `top:100%` bezieht sich auf den naechsten POSITIONIERTEN
       Vorfahren. Die Section selbst ist ungescrollt `static` — die Leiste
       landete damit bei 835 statt bei 119. Der Wrapper (das <sticky-header>)
       ist `position: relative` und damit der richtige Bezug. `position` an der
       Section selbst zu setzen verbietet sich: Das Theme schaltet sie beim
       Scrollen auf `sticky`, und unsere Regel waere spezifischer. */
    var kopfBereich = document.querySelector('#shopify-section-header .header-wrapper') ||
                      document.querySelector('#shopify-section-header sticky-header') ||
                      document.getElementById('shopify-section-header') || document.body;
    if (leiste.parentNode !== kopfBereich) kopfBereich.appendChild(leiste);
    if (platz.parentNode !== document.body) document.body.appendChild(platz);
    /* Der Fuehler sitzt IMMER am Anfang der Optionsliste — auf beiden Geraeten.
       Nicht vor der Leiste: Am Desktop steht die Leiste ohnehin oberhalb des
       Konfigurators, es macht also keinen Unterschied; mobil steht sie an
       dessen Ende, und dort waere sie als Ausloeser wertlos. Eine Verzweigung
       nach Bildschirmbreite waere zwei Wege fuer dasselbe Ergebnis.
       Er wird nur umgehaengt, nie neu erzeugt — der Observer beobachtet
       durchgehend dasselbe Element. */
    if (fuehler && optionen && optionen.firstElementChild !== fuehler) {
      optionen.insertBefore(fuehler, optionen.firstChild);
    }
    kleben();
  }

  /* Erstfuehrung: nur Schritt 1 offen. Frueher war es der erste Schritt ohne
     Auswahl — den gibt es bei durchgehender Vorbelegung nicht. */
  function erstfuehrung() {
    var alle = schritte();
    if (alle.length < 2) return false;   // noch nicht fertig aufgebaut
    for (var i = 0; i < alle.length; i++) {
      if (i === 0) aufmachen(alle[i]); else zumachen(alle[i]);
    }
    return true;
  }

  function start() {
    stil();
    leisteBauen();
    var ruhig = 0;

    var takt = setInterval(function () {
      var etwasGetan = werteSchreiben();
      if (!gefuehrt && erstfuehrung()) gefuehrt = true;
      beobachten();          // haengt sich ein, sobald die Uebersicht da ist
      einhaengen();
      zeichnen();
      preisHinweis();
      ruhig = etwasGetan ? 0 : ruhig + 1;
      if (ruhig >= 3 && gefuehrt) clearInterval(takt);
    }, 300);
    setTimeout(function () { clearInterval(takt); }, 15000);

    /* Klick auf eine Kopfzeile: die App klappt selbst um, wir schliessen
       danach die uebrigen. 30ms, weil die Klasse erst im App-Handler faellt. */
    document.addEventListener('click', function (e) {
      var w = wurzel();
      if (!w) return;
      var kopf = e.target.closest ? e.target.closest('.cl-po--collapse') : null;
      if (!kopf || !w.contains(kopf)) return;
      anfangen(e);   // Kopfzeile angetippt = der Kunde ist eingestiegen
      setTimeout(function () {
        var alle = schritte();
        for (var i = 0; i < alle.length; i++) {
          if (alle[i].kopf === kopf) {
            /* Angesehen ist der Schritt in BEIDEN Faellen (2.3.0): aufgeklappt
               hat der Kunde ihn vor sich, zugeklappt hat er ihn hinter sich.
               Vorher kam der Haken erst beim Verlassen — man arbeitete einen
               Schritt ab und sah dafuer nichts.
               Der Haken bleibt trotzdem ehrlich: er haengt an besucht() =
               gesehen UND ausgefuellt. Bei den Maßen erscheint er also erst
               mit Werten, nicht schon beim Aufklappen. Und die Erstfuehrung
               beim Laden klappt Schritt 1 selbst auf, ohne ueber diesen
               Klick-Weg zu laufen — beim Seitenaufruf steht damit weiterhin
               kein einziger Haken da. */
            merken(alle[i]);
            if (offen(alle[i])) nurDieser(alle[i], false);
            break;
          }
        }
        zeichnen();
      }, 30);
    }, true);

    /* Jeder andere Klick im Konfigurator: Werte nachziehen.
       DER GRUND — und der Fehler, den v2.0.0 noch hatte: Die +/- Tasten an
       den Maßfeldern setzen input.value per JavaScript. Eine programmatische
       Zuweisung feuert WEDER change NOCH input; beide Ereignisse gibt es nur
       bei echter Eingabe durch den Kunden. Ein input-Listener greift hier also
       prinzipiell nicht, egal wie frueh er haengt. Am 06.08.2026 live
       nachgemessen: Feld 1002, Kopfzeile weiterhin 1000.
       Zweimal nachfassen, weil die App den Preis asynchron nachrechnet. */
    document.addEventListener('click', function (e) {
      var w = wurzel();
      if (!w || !w.contains(e.target)) return;
      anfangen(e);   // Kachel, +/- Taste, Farbe — alles ein Anfang
      var ziel = e.target;
      function nachziehen() {
        werteSchreiben();
        /* Der Klick selbst zaehlt als "angesehen" (2.3.0d). Der Grund steht im
           Kopf: ein Klick auf die BEREITS gewaehlte Kachel feuert kein change,
           aufAenderung() bleibt stumm, und der Schritt bliebe ohne Haken —
           obwohl der Kunde gerade seine Wahl bestaetigt hat. Genau das sah
           nach einem Konfigurator aus, der nicht reagiert.
           Ehrlich bleibt es trotzdem: besucht() verlangt zusaetzlich
           ausgefuellt(), die Maße bekommen ihren Haken also weiterhin erst
           mit Werten. */
        var alle = schritte(), quelle = null;
        for (var i = 0; i < alle.length; i++) {
          if (alle[i].knoten.contains(ziel)) { merken(alle[i]); quelle = alle[i]; break; }
        }
        /* Auf Kachel UND Maßfeld/+- gleich reagieren (2.15.2) - beides ist
           "der Kunde arbeitet in diesem Schritt".

           Dieser Weg ist zusaetzlich zu 'change' noetig, und zwar zweimal:
           - Ein Klick auf die BEREITS gewaehlte Kachel feuert kein change
             (siehe Kommentar oben). Das ist hier der Regelfall, weil "Auf der
             Außenwand" vorbelegt ist und der Kunde sie nur bestaetigt.
           - Die +/- Tasten setzen input.value per JavaScript und feuern WEDER
             change NOCH input. Ohne diesen Zweig reagieren sie gar nicht.

           Bewusst eng gefasst: nur Kachel oder Maßfeld. Ein Klick irgendwo sonst
           im Konfigurator - etwa auf eine Kopfzeile - darf nicht weiterschalten,
           denn dort navigiert der Kunde selbst. */
        if (quelle && ziel.closest
            && (ziel.closest('.cl-po--swatch-item') || ziel.closest('.cl-po--dimension-item'))) {
          weiter(quelle);
        }
        zeichnen();
        preisHinweis();
      }
      setTimeout(nachziehen, 80);
      setTimeout(nachziehen, 400);
    }, true);

    /* Auswahl des Kunden. 'input' muss mit: die +/- Tasten an den Maßfeldern
       setzen den Wert per JavaScript und feuern kein change. */
    function aufAenderung(e) {
      var w = wurzel();
      if (!w || !w.contains(e.target)) return;
      anfangen(e);   // getippte Maße zaehlen genauso
      setTimeout(function () {
        werteSchreiben();
        var alle = schritte(), quelle = null;
        for (var i = 0; i < alle.length; i++) {
          if (alle[i].knoten.contains(e.target)) { merken(alle[i]); quelle = alle[i]; break; }
        }
        /* Getipptes Maß und Radiowechsel gleich behandeln (2.15.2): beides ist
           "der Kunde bearbeitet diesen Schritt". 'input' darf jetzt mit, weil
           der bearbeitete Schritt offen BLEIBT - es kann ihm also nichts mehr
           unter den Fingern wegklappen. Genau das war in 2.15.1 der Grund fuer
           die 1,5-Sekunden-Uhr. */
        weiter(quelle);
        zeichnen();
        /* Muss mit (2.3.0): Wer die Maße TIPPT, loest nur 'input' aus. Ohne
           diesen Aufruf blieben "ab" und der Hinweis "bitte tragen Sie Ihre
           Maße ein" stehen, obwohl beide Felder gefuellt sind — bis der Kunde
           zufaellig noch irgendwo in den Konfigurator klickt. Der Klick-Weg
           weiter oben ruft preisHinweis() schon lange auf, der Tipp-Weg nicht. */
        preisHinweis();
      }, 60);
    }
    document.addEventListener('change', aufAenderung, true);
    document.addEventListener('input',  aufAenderung, true);

    window.addEventListener('resize', einhaengen);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ============================================================================
 * KAUFLEISTE: SCHREIBBREMSE                                            v1.0.0
 * Theme:  Version 2.01 / DeinMetallbauer.shop (ID 203215634764)
 * Stand:  07.08.2026
 *
 * WAS ES TUT
 * Das Custom Element ProductStickyForm (inline in sections/main-product.liquid)
 * haengt einen Scroll-Listener an document und schreibt darin bei JEDEM
 * Scroll-Ereignis drei Mal innerHTML neu:
 *
 *     document.querySelector(".product-sticky-image").innerHTML = productImg.innerHTML,
 *     document.querySelector(".product-sticky-price").innerHTML = productPrice.innerHTML,
 *     document.querySelector(".product-sticky-title").innerHTML = ...
 *
 * Ohne Drosselung, ohne Vergleich. Das Bild traegt zwoelf srcset-Groessen; bei
 * jedem Tick wird der Teilbaum verworfen, neu geparst und die Bildauswahl neu
 * berechnet. Titel und Bild aendern sich dabei nie, der Preis nur, wenn der
 * Kunde etwas am Konfigurator dreht.
 *
 * Diese Bremse legt auf genau diese drei Knoten einen eigenen innerHTML-Setter,
 * der gleiche Werte verwirft. Der Preis kommt weiterhin durch — nur eben
 * einmal statt sechzig Mal je Sekunde.
 *
 * WARUM NICHT IN DER VENDOR-DATEI
 * sections/main-product.liquid ist 158 KB Fremdcode. Ein eigener Setter auf
 * drei Knoten ist zurueckbaubar und ueberlebt jede Theme-Aenderung; ein Patch
 * mitten im Fremdcode nicht.
 *
 * ⚠️ Der Setter haengt an der INSTANZ, nicht am Prototyp. Wuerde man
 * Element.prototype anfassen, laege die Bremse auf jedem Element im Dokument.
 *
 * RUECKBAU: diesen Block loeschen. Die Kaufleiste schreibt dann wieder bei
 * jedem Scroll-Tick neu — sichtbar wird das nur als Ruckeln auf dem Handy.
 * ============================================================================ */
(function () {
  'use strict';

  var ZIELE = ['.product-sticky-image', '.product-sticky-price', '.product-sticky-title'];

  function bremsen() {
    if (!document.querySelector('product-sticky-form')) return true;  // andere Seite
    var desc = Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML');
    if (!desc || !desc.set || !desc.get) return true;                 // nichts zu holen
    var fertig = 0;
    for (var i = 0; i < ZIELE.length; i++) {
      var el = document.querySelector(ZIELE[i]);
      if (!el) continue;
      if (el.getAttribute('data-mo-gebremst') === '1') { fertig++; continue; }
      el.setAttribute('data-mo-gebremst', '1');
      (function (knoten) {
        var letzter = desc.get.call(knoten);
        Object.defineProperty(knoten, 'innerHTML', {
          configurable: true,
          get: function () { return desc.get.call(this); },
          set: function (wert) {
            if (wert === letzter) return;
            letzter = wert;
            desc.set.call(this, wert);
          }
        });
      })(el);
      fertig++;
    }
    return fertig === ZIELE.length;
  }

  function los() {
    if (bremsen()) return;
    /* Die drei Knoten stehen statisch im HTML, sind also normalerweise sofort
       da. Der Takt ist nur die Rueckfallebene, falls das Theme sie einmal
       nachreicht — und er stoppt von selbst. */
    var versuche = 0;
    var takt = setInterval(function () {
      if (bremsen() || ++versuche > 20) clearInterval(takt);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', los);
  } else {
    los();
  }
})();
/* ============================================================================
 * SPITZENFORM AUSBLENDEN, WENN DAS PRODUKT KEINE HAT      v1.0.0
 * Config:  Fenstergitter version 3.1  (clu4al1wbeiu)
 * Theme:   Version 2.01 / DeinMetallbauer.shop (ID 203215634764)
 * Ort:     assets/custom.js, ans Ende angehaengt
 * Stand:   07.08.2026
 *
 * WAS ES TUT
 * Nicht jedes Gitter hat Zierspitzen. Das Produkt-Metafeld
 * custom.hat_spitzen (Typ true/false) sagt es; das Theme gibt den Wert am
 * Metafeld-Traeger als data-hat-spitzen aus. Steht dort "false", verschwinden
 * drei Dinge:
 *   1. die Schrittgruppe  Schritt_Spitzenform
 *   2. die Option         Spitzenform
 *   3. die Zeile "Spitzenform: …" in der Preisuebersicht
 *
 * VORGESCHICHTE
 * Es gab das schon einmal — in der LPO-Config clndy4dw2wz4
 * (applySpitzenformVisibility, siehe Backup vom 03.08.2026). Mit dem Wechsel
 * auf die Config clu4al1wbeiu ist es verlorengegangen: Am 07.08.2026 stand
 * "Spitzenform" im Konfigurator, obwohl hat_spitzen am Testprodukt auf false
 * steht. Jetzt liegt es im Theme statt im Design-JS der App — dort ueberlebt
 * es den naechsten Config-Wechsel.
 *
 * ⚠️ DREI ZUSTAENDE, NICHT ZWEI
 * data-hat-spitzen kennt "false", "true" und "unbekannt" (Metafeld gar nicht
 * gesetzt). Ausgeblendet wird NUR bei "false". Das ist Absicht und die
 * Lehre aus dem Audit vom 31.07.2026: Ein leeres Metafeld ist keine Aussage,
 * und ein faelschlich verstecktes Pflichtfeld faellt niemandem auf, bis ein
 * Kunde das falsche Gitter bekommt.
 *
 * ⚠️ AUSBLENDEN GENUEGT NICHT — DIE FELDER MUESSEN DEAKTIVIERT WERDEN
 * Stefan am 07.08.2026: "Spitze ist bei den Fenstergittern ohne nicht relevant
 * und komplett nicht vorhanden." Ein per display:none verstecktes Feld wird
 * trotzdem abgeschickt; "Spitzenform: Spitze 1" stuende weiter im Warenkorb
 * und auf der Bestellung.
 *
 * Der naheliegende Weg — Radio auf checked=false — haelt NICHT: LPO stellt die
 * Vorauswahl im selben Wimpernschlag wieder her (gemessen). Was haelt, ist
 * `disabled`: Ein deaktiviertes Feld wird vom Browser nie uebermittelt, und
 * LPO setzt es beim Neurendern nicht zurueck. Gegenprobe ueber FormData des
 * Kaufformulars: properties[Spitzenform] war danach nicht mehr enthalten,
 * auch nicht nach einem Klick in einer anderen Option.
 *
 * ⚠️ ES GIBT ZWEI FORMULARE MIT action="/cart/add"
 * Das erste (.installment) enthaelt nur `id` — wer dort nachsieht, kommt zu
 * dem Schluss, LPO wuerde die Optionen per JavaScript nachreichen, und sucht
 * an der falschen Stelle weiter. Die echten Felder stehen im zweiten.
 *
 * ⚠️ WARUM KEIN REINES CSS
 * Die Optionen liessen sich ueber [data-option] treffen, die Zeile in der
 * Preisuebersicht aber nicht: Sie traegt keine eigene Kennung, nur den Text
 * "Spitzenform:". CSS kann nicht nach Text auswaehlen.
 *
 * WAS VON ALLEIN MITGEHT
 * Die Schrittleiste zaehlt ueber offsetParent !== null. Eine ausgeblendete
 * Gruppe faellt damit aus der Zaehlung: Aus "Schritt 1 von 5" wird "von 4",
 * ohne dass hier etwas zu tun waere.
 *
 * RUECKBAU: diesen Block loeschen. Dann ist Spitzenform wieder auf jedem
 * Produkt sichtbar, auch auf denen ohne Spitzen.
 * ============================================================================ */
(function () {
  'use strict';
  if (!window.MO_LPO_AKTIV) return;  /* LPO aus: Block ruht - siehe LPO-SCHALTER oben (26.09.2026) */

  var CFG    = 'clu4al1wbeiu';
  var ZIELE  = ['Schritt_Spitzenform', 'Spitzenform'];
  var LABEL  = /^\s*spitzenform/i;
  var WEG    = 'mo-ohne-spitzen';
  var ohne   = null;   // null = noch nicht ermittelt

  function ohneSpitzen() {
    if (ohne !== null) return ohne;
    var t = document.querySelector('[data-mo-metafelder]');
    ohne = !!t && t.getAttribute('data-hat-spitzen') === 'false';
    return ohne;
  }

  function stil() {
    if (document.getElementById('mo-spitzen-css')) return;
    var s = document.createElement('style');
    s.id = 'mo-spitzen-css';
    /* Ein eigener Klassenname statt style.display: So bleibt sichtbar, WARUM
       etwas weg ist, und ein Blick in die Entwicklerwerkzeuge genuegt. */
    s.textContent = '.' + WEG + '{display:none !important}';
    document.head.appendChild(s);
  }

  function anwenden() {
    if (!ohneSpitzen()) return;
    var w = document.querySelector(':is(#' + CFG + ',.cl-po--wrapper)');
    if (!w) return;

    for (var i = 0; i < ZIELE.length; i++) {
      var el = w.querySelector('.cl-po--option[data-option="' + ZIELE[i] + '"]');
      if (el && !el.classList.contains(WEG)) el.classList.add(WEG);
    }

    /* Und jetzt der Teil, auf den es ankommt: Die Felder abschalten, damit
       nichts uebermittelt wird. `disabled` statt Abwaehlen — siehe Kopf. */
    var felder = w.querySelectorAll(
      'input[name="properties[Spitzenform]"], select[name="properties[Spitzenform]"]');
    for (var k = 0; k < felder.length; k++) {
      if (!felder[k].disabled) felder[k].disabled = true;
    }

    /* Die Preisuebersicht wird von LPO neu aufgebaut, sobald sich etwas
       aendert — deshalb bei jedem Durchlauf erneut suchen statt einmal zu
       merken. */
    var labels = document.querySelectorAll('.cl-po--price-summary-label');
    for (var j = 0; j < labels.length; j++) {
      if (!LABEL.test(labels[j].textContent || '')) continue;
      var zeile = labels[j].closest('.cl-po--price-summary-row') ||
                  labels[j].parentElement;
      if (zeile && !zeile.classList.contains(WEG)) zeile.classList.add(WEG);
    }
  }

  function los() {
    /* Auf Produkten MIT Spitzen passiert hier gar nichts — kein Stil, kein
       Beobachter. Der Block kostet dort einen Attributzugriff und ist fertig. */
    if (!ohneSpitzen()) return;
    stil();
    anwenden();
    /* LPO rendert Optionen und Preisuebersicht mehrfach nach. Ein Beobachter
       faengt jede Neufassung ab; ein Zeitgeber wuerde entweder zu frueh
       aufhoeren oder ewig laufen. Gedrosselt ueber ein Flag, damit ein Schwall
       von Mutationen nur einen Durchlauf ausloest. */
    var geplant = false;
    var mo = new MutationObserver(function () {
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(function () { geplant = false; anwenden(); });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', los);
  } else {
    los();
  }
})();

/* ============================================================================
 * BILDZOOM auf dem Produktbild                            v2.0.0
 * Theme:   Version 2.01 / DeinMetallbauer.shop (ID 203215634764)
 * Ort:     assets/custom.js, ans Ende angehaengt
 * Stand:   07.08.2026
 *
 * WAS ES TUT
 * Faehrt die Maus ueber das Hauptbild, erscheint darin ein Auswahlrahmen, und
 * daneben ein Fenster mit genau diesem Ausschnitt in voller Aufloesung. Die
 * Quelldateien sind 2000 x 2000 px, angezeigt werden 276-435 — die Aufloesung
 * war bisher nur ueber die Lightbox zu sehen.
 *
 * ⚠️ WARUM v2.0.0 DIE ERSTE FASSUNG ERSETZT
 * v1.0.0 legte den vergroesserten Ausschnitt INS Bild (Innen-Zoom). Auf dem
 * Schirm ergab das eine fast weisse Flaeche: Bei 2,5-facher Vergroesserung
 * fuellt an vielen Stellen nur die weisse Hauswand den Rahmen, und der Kunde
 * sieht statt Details ein leeres Bild. Stefan am 07.08.2026: "so koennen wir
 * das nicht lassen. so wie im Theme 1.07.1 stelle ich mir das vor."
 *
 * HERKUNFT: THEME 1.07.1
 * Dort steckt die Funktion als Custom Element <media-zoom> in
 * assets/media-gallery.js, das CSS in assets/section-main-product.css. 2.01
 * hat eine andere Theme-Basis (Theme ONE v4) und rendert dieses Element nicht,
 * deshalb ist die Logik hier nachgebaut statt kopiert — Bauart, Maße und
 * Bedienung sind dieselben:
 *   - Auswahlrahmen 150 x 150 px, folgt der Maus, an den Bildkanten begrenzt
 *   - Vorschaufenster so gross wie das Bild + 25 px
 *   - Zoomfaktor ergibt sich aus Bildbreite / Rahmenbreite (bei 435 px: 2,9x)
 *
 * ⚙️ EIN- UND AUSSCHALTEN — im Theme-Editor
 * Abschnitt "Produktinformationen" → Bildzoom. Das Theme gibt die Einstellung
 * am Metafeld-Traeger als data-zoom aus; steht dort "aus", tut dieser Block
 * gar nichts: kein Stylesheet, kein Fenster, kein Listener.
 * Dort stellbar sind ausserdem die Rahmengroesse und auf welcher Seite das
 * Fenster erscheint.
 *
 * ⚠️ DAS FENSTER LIEGT UEBER DEM KONFIGURATOR
 * Rechts neben dem Bild sitzt die Optionsspalte. Das ist Absicht und in 1.07.1
 * genauso: Wer zoomt, schaut auf das Bild, nicht auf die Optionen — und beim
 * Verlassen ist das Fenster sofort wieder weg. Ein Fenster daneben ZU legen
 * ginge nur, wenn man die Seite dafuer breiter macht.
 *
 * ⚠️ NUR WO ES EINEN ZEIGER GIBT
 * Auf Touchgeraeten gibt es kein "darueberfahren"; ein Fingertipp wuerde den
 * Zoom einschalten und er bliebe stehen. Geprueft wird
 * (hover: hover) and (pointer: fine) — sonst passiert nichts, und der Tipp
 * oeffnet weiterhin die Lightbox.
 *
 * ⚠️ DER KLICK MUSS DURCHGEHEN
 * Rahmen und Fenster tragen pointer-events:none. Sonst faengt der Rahmen den
 * Klick ab und die Lightbox des Themes waere tot.
 *
 * RUECKBAU: diesen Block loeschen. Zum voruebergehenden Abschalten genuegt die
 * Einstellung im Theme-Editor.
 * ============================================================================ */
(function () {
  'use strict';

  /* 25.09.2026: war 1600. Shopify liefert hoechstens die Originalbreite — die
     tatsaechliche Aufloesung liest faktorSetzen() nach dem Laden aus naturalWidth. */
  var BREITE   = 3000;   // Bildbreite, die von Shopify hoechstens geholt wird
  var RAHMEN   = 150;    // Kantenlaenge des Auswahlrahmens, wie in 1.07.1
  var LUFT     = 25;     // Fenster ist um so viel groesser als das Bild
  var rahmenEl = null, fensterEl = null, grossBild = null, aktiv = null;
  /* ⚠️ Das letzte Zeigerereignis wird gemerkt, weil das grosse Bild erst
     nachlaedt. Ohne diesen Nachzug steht der Ausschnitt beim ERSTEN
     Ueberfahren auf der linken oberen Ecke, bis die Maus sich wieder bewegt —
     gemessen am 07.08.2026: transform war leer, obwohl Rahmen und Fenster
     schon standen. 1.07.1 loest es genauso. */
  var letztesEv = null;

  function einstellung(name, vorgabe) {
    var t = document.querySelector('[data-mo-metafelder]');
    var v = t && t.getAttribute(name);
    return (v === null || v === undefined || v === '') ? vorgabe : v;
  }

  function an() {
    /* Vorgabe "an": Fehlt das Attribut (aeltere Templates), soll der Zoom
       laufen — abgeschaltet wird bewusst, nicht durch Vergessen. */
    return einstellung('data-zoom', 'an') !== 'aus' &&
           window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function stil() {
    if (document.getElementById('mo-zoom-css')) return;
    var s = document.createElement('style');
    s.id = 'mo-zoom-css';
    s.textContent =
      /* Der Rahmen sitzt im Bild und zeigt, welcher Ausschnitt drueben steht.
         Fadenkreuz-Zeiger wie in 1.07.1 — er sagt "hier laesst sich zielen". */
      '.mo-zoom-feld{cursor:crosshair}' +
      '.mo-zoom-rahmen{position:absolute;top:0;left:0;z-index:3;display:none;' +
        'pointer-events:none;box-shadow:inset 0 0 0 1px #ea5b0b;' +
        'background:rgba(234,91,11,.075)}' +
      '.mo-zoom-fenster{position:fixed;z-index:6;display:none;overflow:hidden;' +
        'pointer-events:none;background:#fff;border:1px solid #e5e7eb;' +
        'border-radius:10px;box-shadow:0 10px 30px rgba(17,24,39,.18)}' +
      '.mo-zoom-fenster img{position:absolute;max-width:none;max-height:none;' +
        'object-fit:contain}' +
      /* Ohne Zeiger nie sichtbar — auch dann nicht, wenn ein Touchgeraet ein
         Mausereignis simuliert. */
      '@media (hover:none),(pointer:coarse){' +
        '.mo-zoom-rahmen,.mo-zoom-fenster{display:none !important}}';
    document.head.appendChild(s);
  }

  /* Aus …?v=123&width=713 wird …?v=123&width=1600. */
  function grossAdresse(img) {
    if (img.tagName === 'CANVAS') return vorschauAdresse(img);
    var u = img.currentSrc || img.src || '';
    if (!u) return '';
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&]width=)\d+/, '$1' + BREITE);
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + BREITE;
  }

  /* ⭐ 19.08.2026 — DIE LUPE AUF DEM VORSCHAU-SLIDE
     Der Vorschau-Slide traegt ein <canvas>. Frueher kehrte starten() dort
     zurueck, weil ein Canvas keine nachladbare Quelle hat. Das stimmt seit den
     Farbserien nicht mehr: Die App holt fuer die gewaehlte Auswahl ein
     Produktbild (…_x1200.jpg), und dieselbe Datei gibt es in _x1600 — das ist
     die scharfe Vorlage. Gemessen am 19.08.: Canvas intern nur 712 px bei
     356 px Anzeige, eine Lupe darauf waere matschig; das Produktbild hat 1600.

     🔴 Der Abgleich mit der GEWAEHLTEN Farbe ist Pflicht. Fehlt eine Datei
     (bei FG 02 gibt es kein Aussenwand_Feuerverzinkt), laedt die App gar
     nichts nach — ohne die Pruefung zeigte die Lupe dann die zuvor gewaehlte
     Farbe weiter. In dem Fall lieber der Canvas-Inhalt selbst. */
  function vorschauAdresse(cv) {
    var wahl = document.querySelector('[data-option="Oberfläche"] input:checked');
    var wert = (wahl && wahl.value ? wahl.value : '').replace(/[\s\/-]+/g, '_').toLowerCase();
    var e = performance.getEntriesByType ? performance.getEntriesByType('resource') : [];
    for (var i = e.length - 1; i >= 0; i--) {
      var n = (e[i].name || '').split('?')[0];
      if (!/\/(Aussenwand|Laibung)_[^\/]+_x\d+\.(jpe?g|png|webp)$/i.test(n)) continue;
      if (wert && n.toLowerCase().indexOf('_' + wert + '_') === -1) continue;
      return n.replace(/_x\d+\.(jpe?g|png|webp)$/i, '_x' + BREITE + '.$1');
    }
    /* Rueckfall: zeigt garantiert das, was der Kunde sieht — nur weicher. */
    try { return cv.toDataURL(); } catch (x) { return ''; }
  }

  function bauen() {
    if (!rahmenEl) {
      rahmenEl = document.createElement('div');
      rahmenEl.className = 'mo-zoom-rahmen';
      rahmenEl.setAttribute('aria-hidden', 'true');
    }
    if (!fensterEl) {
      fensterEl = document.createElement('div');
      fensterEl.className = 'mo-zoom-fenster';
      fensterEl.setAttribute('aria-hidden', 'true');
      document.body.appendChild(fensterEl);
    }
  }

  function rahmenMass() {
    var v = parseInt(einstellung('data-zoom-rahmen', RAHMEN), 10);
    return (v && v >= 60 && v <= 400) ? v : RAHMEN;
  }

  /* ⭐ 25.09.2026 — NICHT WEITER VERGROESSERN, ALS DAS BILD HERGIBT.
     Stefan: „mit der Luppe ist das bild sehr sehr unscharf und verpixelt". Gemessen
     bei 1920 x 1080, Skalierung 125 %: Galeriebild 720 px, Rahmen 150 → Faktor 4,8,
     das Lupenbild stand 3.576 px breit — aus einer 1500er (Balkon) bzw. 1600er
     (Fenstergitter) Quelle: 0,34 Bildpunkte je Geraetepunkt, dreifach hochgerechnet.
     Der Faktor ergibt sich weiter aus Bild- und Rahmenbreite (Rahmen 150, Bild 435
     → 2,9x), wird aber so gedeckelt, dass ~0,9 Bildpunkte auf einen Geraetepunkt
     kommen — mindestens 1,5x, sonst lohnt die Lupe nicht. Der Rahmen waechst dann
     mit (er zeigt ja, was im Fenster steht). Vor dem Laden gilt 1600 als Schaetzung,
     nach dem Laden die echte Breite (onload). Kleine Galerien bleiben wie bisher. */
  function faktorSetzen(img, seite) {
    var r = rahmenMass();
    /* Bei einem sehr kleinen Bild waere ein 150er Rahmen groesser als das Bild
       selbst — dann bleibt nichts zu zielen. Auf die halbe Bildbreite deckeln. */
    r = Math.min(r, Math.round(img.offsetWidth / 2));
    var faktor = img.offsetWidth / r;
    var quelle = (grossBild && grossBild.naturalWidth) || 1600;
    var fmax = quelle / (seite * (window.devicePixelRatio || 1) * 0.9);
    if (faktor > fmax) {
      faktor = Math.max(1.5, fmax);
      r = Math.round(img.offsetWidth / faktor);
    }
    rahmenEl.dataset.mass = r;
    rahmenEl.style.width = r + 'px';
    rahmenEl.style.height = r + 'px';
    if (grossBild) {
      grossBild.style.width = (seite * faktor) + 'px';
      grossBild.style.height = (seite * faktor) + 'px';
    }
  }

  function starten(feld) {
    /* 'img, canvas': Der Vorschau-Slide traegt ein Canvas — siehe
       vorschauAdresse(). Alles andere gilt fuer beide gleich, ein Canvas hat
       ebenso offsetWidth und getBoundingClientRect. */
    var img = feld.querySelector('img, canvas');
    if (!img || !img.offsetWidth) return;
    bauen();
    aktiv = feld;
    feld.classList.add('mo-zoom-feld');

    if (rahmenEl.parentNode !== feld) feld.appendChild(rahmenEl);

    var seite = img.offsetWidth + LUFT;
    fensterEl.style.width = seite + 'px';
    fensterEl.style.height = seite + 'px';

    var adresse = grossAdresse(img);
    if (!grossBild || grossBild.getAttribute('src') !== adresse) {
      grossBild = new Image();
      grossBild.onload = function () {
        /* Erst jetzt ist die echte Aufloesung bekannt — Faktor nachziehen, dann
           den zuletzt bekannten Zeigerstand. */
        var im = aktiv && aktiv.querySelector('img, canvas');
        if (im && im.offsetWidth) faktorSetzen(im, im.offsetWidth + LUFT);
        if (aktiv && letztesEv) bewegen(aktiv, letztesEv);
      };
      grossBild.src = adresse;
      fensterEl.innerHTML = '';
      fensterEl.appendChild(grossBild);
    }
    faktorSetzen(img, seite);

    rahmenEl.style.display = 'block';
    fensterEl.style.display = 'block';
  }

  function bewegen(feld, ev) {
    if (aktiv !== feld || !rahmenEl || rahmenEl.style.display === 'none') return;
    letztesEv = ev;
    var img = feld.querySelector('img, canvas');
    if (!img) return;
    var b = img.getBoundingClientRect();
    if (!b.width || !b.height) return;
    var r = parseInt(rahmenEl.dataset.mass, 10) || RAHMEN;

    /* Der Rahmen folgt der Maus, bleibt aber vollstaendig im Bild — sonst
       zeigt das Fenster einen Ausschnitt, den es gar nicht gibt. */
    var x = Math.min(Math.max(ev.clientX - b.left - r / 2, 0), b.width - r);
    var y = Math.min(Math.max(ev.clientY - b.top - r / 2, 0), b.height - r);
    rahmenEl.style.left = Math.round(x) + 'px';
    rahmenEl.style.top = Math.round(y) + 'px';

    var seite = img.offsetWidth + LUFT;
    var links = einstellung('data-zoom-seite', 'rechts') === 'links'
      ? b.left - seite - 20
      : b.right + 20;
    /* Am Fensterrand kippt es auf die andere Seite, statt halb draussen zu
       stehen. */
    if (links + seite > window.innerWidth - 8) links = b.left - seite - 20;
    if (links < 8) links = 8;
    var oben = Math.min(Math.max(b.top - 12, 8), window.innerHeight - seite - 8);
    fensterEl.style.left = Math.round(links) + 'px';
    fensterEl.style.top = Math.round(oben) + 'px';

    if (grossBild && grossBild.complete) {
      var fx = (x / b.width) * grossBild.offsetWidth;
      var fy = (y / b.height) * grossBild.offsetHeight;
      grossBild.style.transform = 'translate(' + (-fx) + 'px,' + (-fy) + 'px)';
    }
  }

  function beenden() {
    if (rahmenEl) rahmenEl.style.display = 'none';
    if (fensterEl) fensterEl.style.display = 'none';
    if (aktiv) aktiv.classList.remove('mo-zoom-feld');
    aktiv = null;
  }

  /* Das Bildfeld unter dem Zeiger — oder null.

     ⚠ Zwei Galerien, nicht eine. Ist die Live-Preview der App aktiv, ersetzt
     sie die komplette Theme-Galerie durch ihre eigene (Splide). Dann gibt es
     weder .product__media noch .main-product-slider, und die Lupe blieb
     wirkungslos — am 10.08.2026 auf test2 genau so gemeldet.

     ⭐ Der Vorschau-Slide traegt ein <canvas> statt eines <img>. Bis zum
     19.08.2026 kehrte starten() dort zurueck und die Lupe war auf genau dem
     Bild tot, das der Kunde nach jedem Optionsklick sieht — gemessen an FG 01
     und FG 02, und es betraf ebenso FB, Stangen und Handlauf. Seither holt
     vorschauAdresse() die scharfe Vorlage; siehe dort.

     Die Miniaturen bleiben aussen vor, weil der Selektor nur den Hauptslider
     der App trifft (.cl-po--gallery-main), nicht .cl-po--gallery-thumbnails. */
  function zoomFeld(ev) {
    if (!ev.target || !ev.target.closest) return null;
    var el = ev.target.closest(
      '.product__media, .cl-po--gallery-main .splide__slide');
    if (!el) return null;
    /* Theme-Galerie: nur im Hauptslider, nicht in der Miniaturleiste. */
    if (el.classList.contains('product__media') &&
        !el.closest('.main-product-slider')) return null;
    return el;
  }

  function los() {
    if (!an()) return;
    stil();

    /* Delegiert: Der Slider taeuscht Bilder ein und aus, und die
       Befestigungsart wechselt das Hauptbild. Ein Listener am Dokument
       ueberlebt jede dieser Neufassungen. */
    document.addEventListener('mouseover', function (ev) {
      var feld = zoomFeld(ev);
      if (!feld) return;
      if (aktiv === feld) return;
      starten(feld);
    }, { passive: true });

    document.addEventListener('mousemove', function (ev) {
      if (!aktiv) return;
      var feld = zoomFeld(ev);
      if (feld !== aktiv) return;
      bewegen(feld, ev);
    }, { passive: true });

    document.addEventListener('mouseout', function (ev) {
      if (!aktiv) return;
      var feld = zoomFeld(ev);
      if (feld !== aktiv) return;
      if (ev.relatedTarget && aktiv.contains(ev.relatedTarget)) return;
      beenden();
    }, { passive: true });

    /* Beim Aufziehen der Lightbox und beim Scrollen soll nichts stehenbleiben —
       das Fenster ist `fixed` und wuerde sonst mitwandern. */
    document.addEventListener('click', beenden, { passive: true });
    window.addEventListener('scroll', beenden, { passive: true });
    window.addEventListener('resize', beenden, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', los);
  } else {
    los();
  }
})();


/* ============================================================================
 * GEWAEHLTE OPTIONEN IN DEN WARENKORB NACHTRAGEN            v3.1.0
 * Theme:   Version 2.01 / DeinMetallbauer.shop (ID 203215634764)
 * Ort:     assets/custom.js, ans Ende angehaengt
 * Stand:   11.08.2026
 *
 * v3.1.0  Doppelte Zeilen fallen jetzt ueber den WERT weg, nicht ueber den
 *         Namen. Der alte Filter ("Name gleich Wert") traf von den acht
 *         Befestigungs-Untergruppen nur "Lochstein ungedaemmt"; die anderen
 *         sieben — darunter "Sicherheitsschrauben auswahl" — standen im
 *         Warenkorb doppelt: einmal selbst, einmal als "Montageset".
 * v3.0.0  Zwischenspeicher statt Auslesen beim Absenden. WIRKT (gemessen).
 * v2.0.0  fetch/XHR umschlossen, las das Formular aber erst beim Absenden aus
 *         — zu spaet, siehe TIMING. Wirkungslos.
 * v1.0.0  Hing am `formdata`-Ereignis des Formulars. Wirkungslos, weil die App
 *         das Formular gar nicht abschickt.
 *
 * DAS PROBLEM (Punkt A3)
 * Der Kunde waehlt RAL, zahlt den Aufpreis — und die Farbe steht weder im
 * Warenkorb noch auf der Bestellung. Ebenso fehlt "Befestigung".
 *
 * DIE URSACHE (bewiesen am 08.08.2026, Config 3.0 gegen 3.1)
 * Optionen, die in einer GRUPPE stecken, schreibt die App nicht in die
 * Warenkorb-Eigenschaften. In Config 3.0 lag "Oberflaeche" als EINZIGE in einer
 * Gruppe — und war die einzige, die fehlte. In 3.1 sind alle Optionen in die
 * Schritt_-Gruppen gewandert (fuer die Schrittfuehrung), seitdem fehlen
 * Befestigung und Oberflaeche. "Maße" (dimension) und "Befestigungsmittel"
 * (exclude:true) behandelt die App gesondert und laesst sie durch.
 *
 * ⚠️ Es liegt NICHT am Theme: Config 1.2 (flache Optionen) liefert in BEIDEN
 * Themes alles, Config 3.1 in beiden nichts. Design-JS und CSS beider Configs
 * sind byte-identisch.
 *
 * ⚠️ WARUM NICHT DIE GRUPPEN AUFLOESEN
 * Die Gruppen SIND die Schrittfuehrung — ihre collapse/collapseLabel erzeugen
 * die Klappen. Eine flache Option kann keine Klappe tragen (getestet: params
 * .collapse wird bei Nicht-Gruppen ignoriert). Aufloesen hiesse: keine Schritte
 * und keine Nummern mehr. Bei den Toren waeren das neun Schritte.
 *
 * ⚠️ TIMING — der Grund, warum v2.0.0 nicht wirkte
 * Die App raeumt das Formular VOR dem Absenden ab. Wer die Werte erst im
 * fetch-Hook aus dem DOM liest, findet nichts mehr (gemessen: `ergaenzt: []`
 * bei intaktem Hook). Deshalb werden sie hier LAUFEND mitgeschrieben und beim
 * Absenden nur noch aus dem Speicher ergaenzt.
 *
 * ⚠️ PERFORMANCE (Stefans Vorgabe)
 * Kein Intervall, kein MutationObserver. Nur zwei passive Listener am document
 * (`change` und `click`), beide in der Capture-Phase, plus ein letzter
 * Sammelversuch im fetch-Hook. Das kostet im Leerlauf nichts.
 *
 * WAS ERGAENZT WIRD
 * Nur Eigenschaften, die im Body FEHLEN — die App hat immer Vorrang.
 * `properties[_...]` bleibt unberuehrt (interne Felder), `disabled`-Felder
 * werden uebersprungen (sonst kaeme "Spitzenform" zurueck, das
 * mo_spitzenform.js absichtlich abschaltet).
 *
 * PRUEFEN
 *   fetch('/cart.js').then(r=>r.json()).then(c=>console.log(c.items[0].properties))
 * Erwartet: Oberfläche und Befestigung stehen als sichtbare Eigenschaften da.
 *
 * RUECKBAU: diesen Block loeschen.
 * ============================================================================ */
(function () {
  'use strict';

  var gemerkt = {};

  function formular() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('[name="properties[_cl_options]"]')) return forms[i];
    }
    return null;
  }

  function sammeln() {
    var form = formular();
    if (!form) return;
    var felder = form.querySelectorAll(
      'input[name^="properties["], select[name^="properties["], textarea[name^="properties["]');
    for (var i = 0; i < felder.length; i++) {
      var el = felder[i], name = el.name;
      /* ⚠️ Abgeschaltete Felder fliegen wieder AUS dem Speicher. Nur
         `continue` genuegt nicht: mo_spitzenform.js setzt `disabled` erst ueber
         seinen Beobachter, also NACH unserem ersten Sammellauf. Ohne diese
         Zeile blieb "Spitzenform: Spitze 1" im Speicher haengen und stand
         hinterher im Warenkorb — bei einem Gitter, das gar keine Spitzen hat.
         Von Stefan am 08.08.2026 gefunden. */
      if (el.disabled) { delete gemerkt[name]; continue; }
      if (name.indexOf('properties[_') === 0) continue;
      var wert = null;
      if (el.type === 'radio' || el.type === 'checkbox') {
        if (el.checked) wert = el.value;
      } else if (el.value) {
        wert = el.value;
      }
      if (wert === null || wert === '') continue;

      /* ⚠️ Zeilen wie "Lochstein ungedämmt: Lochstein ungedämmt" weglassen.
         Die Untergruppen des Befestigungsmittels tragen als Optionsnamen genau
         ihren eigenen Wert; ihr Ergebnis steht ohnehin schon in
         "Befestigungsmittel: Montageset Lochstein ungedämmt". Von Stefan am
         08.08.2026 im Warenkorb entdeckt ("Befestigung doppelt").
         Die Regel ist bewusst allgemein: Name gleich Wert heisst, die Zeile
         sagt nichts, was nicht schon dasteht. */
      var blank = name.substring(name.indexOf('[') + 1, name.lastIndexOf(']'));
      if (blank.toLowerCase().trim() === String(wert).toLowerCase().trim()) continue;

      gemerkt[name] = wert;
    }
  }

  /* Die Reihenfolge der Optionen im Konfigurator — Dokumentreihenfolge, also
     genau die Schrittfolge, die der Kunde durchlaufen hat. Gruppen zaehlen
     nicht mit, nur die Optionen selbst tragen ein data-option mit Feldnamen. */
  function reihenfolge() {
    var namen = [], k = document.querySelectorAll('.cl-po--option[data-option]');
    for (var i = 0; i < k.length; i++) {
      var n = k[i].getAttribute('data-option');
      if (n && namen.indexOf(n) === -1) namen.push(n);
    }
    return namen;
  }

  /* Werte vergleichbar machen: Gross-/Kleinschreibung, doppelte Leerzeichen und
     die Luft um den Schraegstrich weg. Ohne das Letzte scheitert der Vergleich an
     "Vollstein /Beton gedämmt" gegen "Vollstein / Beton gedämmt" - beide stehen
     so in Config 3.1, einmal als Optionswert, einmal als Anzeigetext. */
  function norm(s) {
    return String(s == null ? '' : s)
      .toLowerCase().replace(/\s+/g, ' ').replace(/\s*\/\s*/g, '/').trim();
  }

  /* ⚠️ Nachtragen allein genuegt nicht: Angehaengte Eintraege stehen im
     Warenkorb HINTER denen der App — die Bestellung laese sich dann
     "Maße, Befestigungsmittel, Befestigung, Oberflaeche". Deshalb werden alle
     sichtbaren Eigenschaften einmal herausgenommen und in der Schrittfolge
     wieder eingesetzt. Die internen `properties[_...]` bleiben unangetastet,
     sie bestimmen die Reihenfolge im Warenkorb ohnehin nicht. */
  function ergaenzen(fd) {
    sammeln();                         /* letzter Versuch, falls noch intakt */

    var vorhanden = {}, i;
    var schluessel = [];
    fd.forEach(function (wert, name) {
      if (name.indexOf('properties[') === 0 && name.indexOf('properties[_') !== 0) {
        vorhanden[name] = wert;
        if (schluessel.indexOf(name) === -1) schluessel.push(name);
      }
    });
    for (var g in gemerkt) {
      if (gemerkt.hasOwnProperty(g) && !vorhanden.hasOwnProperty(g)) {
        vorhanden[g] = gemerkt[g];
        schluessel.push(g);
      }
    }

    /* ⚠️ "Befestigungsmittel: Montageset Lochstein ungedaemmt" kuerzen.
       Das LPO-Design-JS baut den Wert als "Montageset " + Auswahl und nennt die
       Eigenschaft "Befestigungsmittel" — das Wort steht damit zweimal in einer
       Zeile, und mit 135px Label plus langem Wert war es die einzige Angabe, die
       im Warenkorb zweizeilig umbrach. Als "Montageset: Lochstein ungedämmt"
       passt sie in eine Zeile; erst dadurch laesst sich die Liste auf dem Handy
       ueberhaupt zweispaltig setzen (Abschnitt 48 in custom.css).
       Von Stefan am 08.08.2026 angeordnet ("4. sofort machen").
       Bei Menge > 1 stellt das Design-JS ein "2 × " voran — das bleibt stehen.
       Wurde kein Montageset gewaehlt, heisst der Wert "Ohne Befestigungsmittel";
       dann behaelt die Zeile ihren Namen und der Wert wird auf "Ohne" gekuerzt,
       sonst stuende dort "Befestigungsmittel: Ohne Befestigungsmittel". */
    var altBM = 'properties[Befestigungsmittel]';
    if (vorhanden.hasOwnProperty(altBM)) {
      var wertBM = String(vorhanden[altBM]);
      var mitSet = wertBM.replace(/^(\d+\s*[×x]\s*)?Montageset\s+/i, '$1');
      if (mitSet !== wertBM) {
        var neuBM = 'properties[Montageset]';
        delete vorhanden[altBM];
        vorhanden[neuBM] = mitSet;
        var stelle = schluessel.indexOf(altBM);
        if (stelle !== -1) schluessel[stelle] = neuBM; else schluessel.push(neuBM);
        /* ⚠️ Der alte Schluessel muss HIER aus der Anfrage raus. Weiter unten
           wird nur geloescht, was in `sortiert` steht — und dort landet nur,
           was noch in `vorhanden` ist. Ohne diese Zeile blieb der alte Eintrag
           unberuehrt stehen und der Warenkorb zeigte BEIDE Zeilen:
           "Befestigungsmittel: Montageset Lochstein ungedämmt" UND
           "Montageset: Lochstein ungedämmt". Beim ersten Testkauf gemessen. */
        fd.delete(altBM);
      } else if (/^ohne\b/i.test(wertBM)) {
        vorhanden[altBM] = 'Ohne';
      }
    }

    /* ⚠️ MASSZEILE — Ueberschrift und Einheit. Von Stefan am 12.08.2026 im
       Warenkorb gefunden: beim Handlauf stand dort

           Maße:  1500

       Zwei Fehler in einer Zeile.

       1. DER NAME. Die Option heisst in allen vier Configs intern "Maße" —
          beim Handlauf seit dem 12.08., weil sonst 15 CSS-Regeln und zwei
          JS-Bloecke an ihm vorbeilaufen (sie haengen alle an
          [data-option="Maße"]). Der Kunde sieht am Feld weiterhin "Länge:",
          der Warenkorb zeigte aber den internen Namen. Ein Handlauf hat kein
          zweites Mass; "Maße" ist dort schlicht falsch.

       2. DIE EINHEIT. Bei ZWEI Massen haengt die App "mm" an ("600 × 900 mm"),
          bei EINEM liefert sie die nackte Zahl ("1500"). Am 12.08. ueber
          /cart.js nach einem echten Kaufklick gemessen — im Formular selbst
          steht der Wert noch nicht, siehe die Warnung weiter oben.

       Beides wird hier gerade gezogen statt in der App: der Optionsname MUSS
       "Maße" bleiben, sonst greift das halbe Theme-CSS nicht mehr. Die
       Zuordnung steht in MO_KONFIG (Feld `massName`), damit sie an derselben
       Stelle liegt wie Produktwort und Massbereich.

       Reihenfolge wie beim Montageset daneben: erst umbenennen, dann `fd`
       bereinigen — sonst steht die Zeile zweimal im Warenkorb. */
    var altMasse = 'properties[Maße]';
    if (vorhanden.hasOwnProperty(altMasse)) {
      var wertM = String(vorhanden[altMasse]).trim();
      if (/^\d+([.,]\d+)?$/.test(wertM)) wertM += ' mm';

      var moWrap = document.querySelector('.cl-po--wrapper');
      var moTraeger = moWrap && moWrap.closest('[id]');
      var moKfg = (window.MO_KONFIG || {})[moTraeger && moTraeger.id] || {};

      if (moKfg.massName && moKfg.massName !== 'Maße') {
        var neuMasse = 'properties[' + moKfg.massName + ']';
        delete vorhanden[altMasse];
        vorhanden[neuMasse] = wertM;
        var stelleM = schluessel.indexOf(altMasse);
        if (stelleM !== -1) schluessel[stelleM] = neuMasse; else schluessel.push(neuMasse);
        fd.delete(altMasse);
      } else if (wertM !== vorhanden[altMasse]) {
        vorhanden[altMasse] = wertM;
      }
    }

    /* ⚠️ DIESELBE AUSSAGE ZWEIMAL — die Zeile der Untergruppe streichen.
       Von Stefan am 11.08.2026 im Warenkorb gefunden:
           Sicherheitsschrauben auswahl:  Sicherheitsschraube 85mm
           Montageset:                    Sicherheitsschraube 85mm
       Die untere Zeile baut das Design-JS aus derselben Auswahl ("Montageset " +
       Wert); die obere traegt unser Block nach, weil die Option in einer
       LPO-Gruppe steckt und die App sie sonst verschluckt. Beide sagen dasselbe.

       Der Filter in sammeln() ("Name gleich Wert") faengt das NICHT: Er trifft
       nur "Lochstein ungedämmt", weil dort Optionsname und Wert zufaellig
       uebereinstimmen. Von den acht Untergruppen heissen sieben anders als ihr
       Wert - "Holz auswahl" -> "Holz ungedämmt", "Lochstein gedämmt" -> "Ohne
       Thermische Trennung", "Sicherheitsschrauben auswahl" -> "Sicherheits-
       schraube 85mm". Bei allen sieben stand die Zeile doppelt da.

       Deshalb wird nicht ueber den NAMEN entschieden, sondern ueber den WERT:
       Steht der Wert einer Zeile bereits in der Montageset-Zeile, sagt sie
       nichts Neues. Das gilt fuer jede kuenftige Untergruppe und fuer jeden
       weiteren Konfigurator, ohne dass hier eine Liste gepflegt werden muss.

       Die Montageset-Zeile ist die bessere der beiden: Sie ist kurz, und bei
       Lochstein/Vollstein traegt sie zusaetzlich den Wandaufbau
       ("Lochstein gedämmt – Ohne Thermische Trennung"), der sonst nirgends im
       Warenkorb steht - "Lochstein Außenwand" hat exclude:true.

       ⚠️ fd.delete() muss HIER stehen. Weiter unten wird nur geloescht, was in
       `sortiert` landet, und dort kommt nur an, was noch in `vorhanden` ist -
       dieselbe Falle wie bei der Umbenennung darueber. */
    var mset = 'properties[Montageset]';
    if (vorhanden.hasOwnProperty(mset)) {
      var setWert = norm(vorhanden[mset]);
      for (var k in vorhanden) {
        if (!vorhanden.hasOwnProperty(k) || k === mset) continue;
        var kw = norm(vorhanden[k]);
        if (kw.length < 3 || setWert.indexOf(kw) === -1) continue;
        delete vorhanden[k];
        var w = schluessel.indexOf(k);
        if (w !== -1) schluessel.splice(w, 1);
        fd.delete(k);
      }
    }

    /* sortieren: erst alles, was der Konfigurator kennt, in seiner Reihenfolge */
    var folge = reihenfolge(), sortiert = [];
    for (i = 0; i < folge.length; i++) {
      var s = 'properties[' + folge[i] + ']';
      if (vorhanden.hasOwnProperty(s) && sortiert.indexOf(s) === -1) sortiert.push(s);
    }
    /* Die umbenannte Eigenschaft kennt `reihenfolge()` nicht — sie stand aber
       ohnehin immer am Ende, dort bleibt sie ueber die Schluesselliste. */
    for (i = 0; i < schluessel.length; i++) {
      if (sortiert.indexOf(schluessel[i]) === -1) sortiert.push(schluessel[i]);
    }

    for (i = 0; i < sortiert.length; i++) fd.delete(sortiert[i]);
    for (i = 0; i < sortiert.length; i++) fd.append(sortiert[i], vorhanden[sortiert[i]]);
  }

  function start() {
    sammeln();
    document.addEventListener('change', sammeln, true);
    /* Ein Klick auf eine bereits gewaehlte Kachel feuert kein `change` — und
       genau das ist der Regelfall, weil die App vorbelegt. Kurz warten, damit
       die App ihre Auswahl gesetzt hat. */
    document.addEventListener('click', function () { setTimeout(sammeln, 50); }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* --- die abgehende Kaufanfrage ---------------------------------------- */

  if (typeof window.fetch === 'function') {
    var holen = window.fetch;
    window.fetch = function (eingabe, init) {
      try {
        var url = (typeof eingabe === 'string') ? eingabe : (eingabe && eingabe.url) || '';
        if (url.indexOf('/cart/add') !== -1 && init && typeof FormData !== 'undefined'
            && init.body instanceof FormData) {
          ergaenzen(init.body);
        }
      } catch (e) { /* im Zweifel unveraendert weiterreichen */ }
      return holen.apply(this, arguments);
    };
  }

  var senden = XMLHttpRequest.prototype.send;
  var offen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    this.__moUrl = u;
    return offen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    try {
      if (String(this.__moUrl || '').indexOf('/cart/add') !== -1
          && typeof FormData !== 'undefined' && body instanceof FormData) {
        ergaenzen(body);
      }
    } catch (e) { /* im Zweifel unveraendert weiterreichen */ }
    return senden.apply(this, arguments);
  };
})();

/* ===================================================================
 * Metallbau Odenthal - Laschen-Hinweis ab 1500 mm            v1.0.0
 * AUSGELIEFERT IN: Theme 2.05 (203762991436), 17.08.2026
 *
 * Gitter in Rahmenbauart brauchen ab 1500 mm DREI Befestigungslaschen
 * je Seite statt zwei - also sechs Bohrloecher statt vier. Der Kunde
 * erfaehrt das bisher nirgends und masst sein Fenster aus, ohne zu
 * wissen, wie viele Punkte tragfaehig sein muessen.
 *
 * Geschaltet wird produktweise ueber das Metafeld custom.laschen_ab_1500
 * (boolean), das main-product.liquid als data-laschen-ab-1500 ausgibt.
 * NUR "true" zeigt den Hinweis. Ein fehlendes Metafeld ist keine
 * Aussage - und ein falsch angezeigter Hinweis waere schlimmer als
 * keiner. Dieselbe Regel wie bei data-hat-spitzen.
 *
 * Der Kasten erscheint erst, wenn die Breite die Grenze erreicht, und
 * verschwindet wieder, wenn der Kunde zurueckgeht. Bei kleinen Gittern
 * ist er also nie zu sehen - kein Dauerlaerm, der ueberlesen wird.
 * =================================================================== */
(function () {
  'use strict';
  if (!window.MO_LPO_AKTIV) return;  /* LPO aus: Block ruht - siehe LPO-SCHALTER oben (26.09.2026) */

  /* 🔵 17.08.2026 von 1500 auf 1400 gesenkt (Stefan: "die laschen erst
     ab 1400 mm einblenden?"). Puffer nach unten: Wer 1450 mm baut,
     bekommt die dritte Lasche ebenfalls angeboten. Der Kastentext und
     der Hilfstext der Option nennen den Wert aus dieser Konstante bzw.
     sind in der App auf 1400 nachgezogen - beim Aendern BEIDES anfassen. */
  var GRENZE    = 1400;
  var KASTEN_ID = 'mo-laschen-hinweis';
  var STIL_ID   = 'mo-laschen-hinweis-stil';

  function anzeigen() {
    var t = document.querySelector('[data-mo-metafelder]');
    return !!t && t.getAttribute('data-laschen-ab-1500') === 'true';
  }

  /* Die Option heisst ohne Doppelpunkt "Maße" - am 17.08.2026 an der
     Storefront nachgesehen. Der Doppelpunkt-Selektor bleibt als
     Rueckfall drin, weil andere Configs ihr Label mit ":" fuehren. */
  function massKnoten() {
    return document.querySelector('.cl-po--option[data-option="Maße"]')
        || document.querySelector('.cl-po--option[data-option="Maße:"]');
  }

  /* 🔴 KORRIGIERT AM 17.08.2026 - vorher wurde die BREITE geprueft.
     Stefan an einem Gitter mit 1000 x 1600 mm: "3te Lasche wo?" - der
     Hinweis blieb aus, obwohl 1600 ueber der Grenze liegt.
     Die Laschen sitzen links und rechts UEBEREINANDER; wie viele je
     Seite noetig sind, haengt deshalb an der HOEHE, nicht an der
     Breite. (Stefan bestaetigt am 17.08.2026.)

     Das Feld ist type="text", nicht "number" - es kann "1600",
     "1600 mm" oder Leerzeichen enthalten, deshalb alles ausser Ziffern
     weg. */
  function hoeheAus(knoten) {
    var y = knoten.querySelector('input[name$="_y]"]');
    if (y && String(y.value).trim() !== '') {
      var n = parseInt(String(y.value).replace(/[^\d]/g, ''), 10);
      if (!isNaN(n)) return n;
    }
    /* Konfiguratoren auf onlyX (Balkon, Stange) haben kein y-Feld -
       dort ist die Hoehe eine eigene Kacheloption. */
    var hoehe = document.querySelector('.cl-po--option[data-option^="Höhe"]');
    if (hoehe) {
      var gew = hoehe.querySelector('input:checked');
      if (gew) {
        var m = parseInt(String(gew.value).replace(/[^\d]/g, ''), 10);
        if (!isNaN(m)) return m;
      }
    }
    return null;
  }

  function stilEinmal() {
    if (document.getElementById(STIL_ID)) return;
    var s = document.createElement('style');
    s.id = STIL_ID;
    s.textContent =
        '#' + KASTEN_ID + '{margin:12px 0 4px;padding:10px 12px;'
      + 'background:rgba(192,57,43,.08);border-left:3px solid #c0392b;'
      + 'border-radius:4px;font-size:14px;line-height:1.45;color:#7f231a;}'
      + '#' + KASTEN_ID + ' strong{color:#c0392b;}'
      + '#' + KASTEN_ID + ' p{margin:0;}'
      + '#' + KASTEN_ID + ' p + p{margin-top:6px;}'
      /* .cl-po--panel steht auf overflow:hidden - ohne Umbruch waere
         ein langer Text dort wirklich abgeschnitten. */
      + '#' + KASTEN_ID + '{overflow-wrap:break-word;}'
      + '@media screen and (max-width:749px){#' + KASTEN_ID + '{font-size:13px;}}';
    document.head.appendChild(s);
  }

  /* 🔴 DIE AUFMASS-SKIZZE STEHT ABSOLUT (span.cl-po--info) und nimmt
     keinen Platz im Fluss ein - ein Kasten voller Breite laeuft unter
     ihr durch. Am 17.08.2026 gemessen: Kasten bis x 1372, Skizze ab
     x 1085 - 287 px verdeckt. Stefan: "ist der text abgeschnitten?"
     Er ist NICHT abgeschnitten, er liegt hinter dem Bild.

     ⚠️ Dieselbe Funktion steckt im Block "Maß-Empfehlung" weiter unten.
     Die beiden Kaesten sind getrennte IIFEs und koennen sich nichts
     teilen - wer die eine aendert, muss die andere mitaendern. */
  function randRechts(knoten, kasten) {
    var skizze = knoten.querySelector('.cl-po--info');
    if (!skizze || getComputedStyle(skizze).position !== 'absolute') {
      kasten.style.marginRight = '';
      return;
    }
    var s = skizze.getBoundingClientRect();
    var k = knoten.getBoundingClientRect();
    var z = kasten.getBoundingClientRect();
    /* Nur bei senkrechter Ueberschneidung - sonst verschenkt der Rand
       unnoetig Breite. */
    if (!(s.bottom > z.top && s.top < z.bottom) || s.width <= 0) {
      kasten.style.marginRight = '';
      return;
    }
    kasten.style.marginRight = Math.max(0, Math.round(k.right - s.left) + 12) + 'px';
  }

  /* Seit 17.08.2026 gibt es dazu eine echte Option im Konfigurator
     ("Laschen", zwei Werte, 3 vorausgewaehlt). Sie ist nur sinnvoll,
     wo die dritte Lasche ueberhaupt zur Debatte steht - sonst blendet
     sie diese Funktion aus. */
  function laschenOption() {
    return document.querySelector('.cl-po--option[data-option^="Laschen"]');
  }

  function optionSchalten(an) {
    var o = laschenOption();
    if (!o) return;
    o.style.display = an ? '' : 'none';
    /* ⚠️ display:none allein genuegt NICHT - der Wert ginge trotzdem in
       den Warenkorb. Nur disabled haelt, auch nach dem Neurendern der
       App ([[lpo-option-wirklich-entfernen]]). */
    o.querySelectorAll('input, select').forEach(function (el) { el.disabled = !an; });
  }

  function pruefen() {
    if (!anzeigen()) { optionSchalten(false); return; }

    var knoten = massKnoten();
    if (!knoten) return;

    var hoehe = hoeheAus(knoten);
    var kasten = document.getElementById(KASTEN_ID);

    if (hoehe === null || hoehe < GRENZE) {
      if (kasten) kasten.hidden = true;
      optionSchalten(false);
      return;
    }

    optionSchalten(true);

    stilEinmal();

    /* Die App baut ihre Optionen neu auf. Steht der Kasten danach nicht
       mehr in der Maß-Option, wird er dort neu eingehaengt statt
       verwaist stehen zu bleiben. */
    if (kasten && kasten.parentElement !== knoten) {
      kasten.parentElement.removeChild(kasten);
      kasten = null;
    }

    if (!kasten) {
      kasten = document.createElement('div');
      kasten.id = KASTEN_ID;
      kasten.setAttribute('role', 'note');
      /* Der Kasten erscheint erst beim Tippen. Ohne aria-live bekommt
         ein Screenreader-Nutzer davon nichts mit. */
      kasten.setAttribute('aria-live', 'polite');
      kasten.innerHTML =
          '<p><strong>Ab ' + GRENZE + ' mm Höhe: drei Laschen je Seite.</strong></p>'
        + '<p>Bei dieser Höhe erhält Ihr Gitter <strong>drei '
        + 'Befestigungslaschen pro Seite</strong> statt zwei — die dritte sitzt '
        + 'mittig zwischen den beiden anderen. Das sind sechs Bohrlöcher; bitte '
        + 'achten Sie darauf, dass alle sechs Punkte in tragfähigem Mauerwerk '
        + 'liegen.</p>';
      knoten.appendChild(kasten);
    }

    kasten.hidden = false;
    randRechts(knoten, kasten);
  }

  /* start() laeuft zweimal - einmal sofort, einmal als Nachzuegler.
     Ohne diese beiden Merker haengen Listener und Beobachter doppelt,
     und jede Eingabe loest pruefen() zweifach aus. Getrennt gefuehrt,
     weil der Wrapper beim ersten Lauf noch fehlen kann: die Listener
     stehen dann schon, der Beobachter kommt im zweiten Lauf dazu. */
  var listenerStehen   = false;
  var beobachterSteht  = false;

  function start() {
    /* 🔴 KORRIGIERT AM 17.08.2026 - hier stand "if (!anzeigen()) return;".
       Damit lief bei Produkten OHNE das Metafeld gar nichts, und die
       Option "Laschen" blieb sichtbar, statt ausgeblendet zu werden.
       Aufgefallen am Edelstahl-Gitter (laschen_ab_1500 = false): Die
       Auswahl stand dort ohne eingetragenes Maß mitten im Schritt.
       pruefen() muss IMMER laufen - es blendet aus, wenn nichts
       anzuzeigen ist. Abgebrochen wird nur, wenn es die Option auf
       dieser Seite gar nicht gibt. */
    if (!laschenOption() && !anzeigen()) return;

    pruefen();

    if (!listenerStehen) {
      listenerStehen = true;
      /* Tippen loest kein change aus, erst das Verlassen des Feldes -
         deshalb beide Ereignisse, und in der Capture-Phase, weil die
         App eigene Handler mitbringt. */
      document.addEventListener('input', function (e) {
        if (e.target && e.target.closest && e.target.closest('.cl-po--option')) pruefen();
      }, true);
      document.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('.cl-po--option')) pruefen();
      }, true);
      window.addEventListener('option:changed', pruefen);
    }

    /* Rendert die App die Optionen neu, faellt der Kasten heraus und
       kaeme ohne Beobachter nicht wieder. Der Merker verhindert, dass
       das eigene Einhaengen den Beobachter erneut ausloest. */
    if (!beobachterSteht) {
      var wrap = document.querySelector('.cl-po--wrapper');
      if (wrap && window.MutationObserver) {
        beobachterSteht = true;
        var laeuft = false;
        new MutationObserver(function () {
          if (laeuft) return;
          laeuft = true;
          setTimeout(function () { laeuft = false; pruefen(); }, 0);
        }).observe(wrap, { childList: true, subtree: true });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Die App haengt ihre Optionen spaeter ein als DOMContentLoaded -
     derselbe Nachzuegler-Check, den die Schrittfuehrung schon macht. */
  setTimeout(start, 600);

  /* 🔴 Und der Warte-Beobachter, weil 600 ms nicht reichen, wenn die
     App langsamer rendert - dieselbe Falle wie bei Galerie-Lightbox
     und Maß-Empfehlung. Ohne ihn bliebe die Option sichtbar, weil
     start() zu frueh nichts findet und danach niemand mehr prueft. */
  if (window.MutationObserver) {
    var warteBeob = new MutationObserver(function () {
      if (!laschenOption() && !anzeigen()) return;
      start();
      if (beobachterSteht) warteBeob.disconnect();
    });
    warteBeob.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { warteBeob.disconnect(); }, 15000);
  }

  /* ===================================================================
   * Die Laschenwahl in den Warenkorb nachtragen
   *
   * 🔴 DER BEFUND vom 17.08.2026: Das LPO-Design-JS raeumt beim
   * Absenden ALLE properties[...] weg und schreibt eine selbst gebaute
   * Liste zurueck (buildCleanCartRows). Optionen, die in einer
   * .cl-po--group liegen, faltet es dabei in eine Sammelzeile -
   * gedacht fuer die Montageset-Untergruppen. "Laschen" liegt in
   * Schritt_Masse und fiel deshalb heraus.
   *
   * Gemessen: form.elements kennt properties[Laschen] mit dem
   * angehakten Wert, FormData(form) enthaelt ihn NICHT.
   *
   * ⚠️ NICHT im Design-JS reparieren - das ist minifiziert und wird je
   * Config gepflegt. Stattdessen hier nachtragen: Der Handler laeuft
   * NACH dem der App (spaeter gebunden = spaeter aufgerufen) und setzt
   * den Wert erneut.
   * =================================================================== */
  var WK_MARKER = 'moLaschenWkBound';

  function laschenWert() {
    var o = document.querySelector('.cl-po--option[data-option^="Laschen"]');
    /* Ausgeblendet oder deaktiviert = nicht bestellrelevant. */
    if (!o || o.offsetParent === null) return null;
    var gew = o.querySelector('input:checked');
    if (!gew || gew.disabled) return null;
    return gew.value || null;
  }

  function wkBinden() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
      if (f.dataset[WK_MARKER] === 'true') return;
      f.dataset[WK_MARKER] = 'true';
      f.addEventListener('formdata', function (e) {
        var wert = laschenWert();
        if (!wert) return;
        try {
          e.formData.delete('properties[Laschen]');
          e.formData.append('properties[Laschen]', wert);
        } catch (x) { /* aeltere Browser ohne formdata-Event */ }
      });
    });
  }

  /* Erst binden, wenn die App ihre eigenen Handler gesetzt hat -
     sonst laeuft unserer zuerst und wird danach wieder ueberschrieben. */
  setTimeout(wkBinden, 1500);
  window.addEventListener('option:changed', function () { setTimeout(wkBinden, 200); });
})();

/* ===================================================================
 * Metallbau Odenthal - Vollbild fuer die LPO-Galerie          v1.0.0
 * AUSGELIEFERT IN: Theme 2.05 (203762991436), 17.08.2026
 *
 * DER FEHLER, den Stefan am 17.08.2026 gemeldet hat: Ein Klick auf das
 * Produktbild oeffnete kein Vollbild.
 *
 * URSACHE, an /products/fenstergitter-29 gemessen: Die Vorschau-Galerie
 * der LPO-App ersetzt die Theme-Galerie VOLLSTAENDIG. Im DOM stehen
 * danach 0 x .product__media-list, 0 x modal-opener, 0 x
 * product-media-modal, 0 x media-zoom - an ihrer Stelle eine
 * Splide-Galerie (.cl-po--gallery-main). Es gab also nichts mehr, was
 * ein Vollbild oeffnen konnte; die App bringt selbst keins mit.
 *
 * ⚠️ Der Bildlupen-Block weiter oben laesst den Klick absichtlich durch
 * ("DER KLICK MUSS DURCHGEHEN"), damit die Theme-Lightbox ihn bekommt.
 * Diese Annahme trifft auf Konfigurator-Seiten nicht zu. Deshalb faengt
 * ihn jetzt dieser Block - aber NUR dort, wo die Theme-Lightbox
 * tatsaechlich fehlt. Auf normalen Produktseiten (Montagesets) bleibt
 * alles beim Theme.
 *
 * Der Canvas-Slide - die Live-Vorschau des Konfigurators - kommt mit ins
 * Vollbild. Gemessen: toDataURL().length rund 1,7 Mio, also ein voll
 * gezeichnetes Bild, das der Kunde bisher nur in 438 px sah.
 * =================================================================== */
(function () {
  'use strict';
  if (!window.MO_LPO_AKTIV) return;  /* LPO aus: Block ruht - siehe LPO-SCHALTER oben (26.09.2026) */

  var BREITE      = 1600;   // wie im Bildlupen-Block: Shopify liefert bis 2000
  var LIGHTBOX_ID = 'mo-galerie-lightbox';
  var STIL_ID     = 'mo-galerie-lightbox-stil';

  var bilder = [], zeiger = 0, kasten = null, bildEl = null, zaehlerEl = null;

  function galerieDa() { return !!document.querySelector('.cl-po--gallery-main'); }

  /* 🔴 GEPRUEFT AM 17.08.2026 - der naheliegende Test ist der falsche.
     Nicht das Modal abfragen, sondern seinen AUSLOESER:
       Konfiguratorseite: product-modal 1, modal-opener 0, media-toggle 0
       Montageset:        product-modal 1, modal-opener 5, media-toggle 5
     Das Theme rendert das Modal also auf BEIDEN Seiten (mit 3 Bildern
     darin) - die App entfernt nur den Knopf, der es aufmacht. Ein Test
     auf 'product-modal' waere damit ueberall wahr und dieser Block nie
     zustaendig. Und 'product-media-modal' gibt es gar nicht: in Theme ONE
     heisst das Element product-modal, der alte Name kostete eine Messung. */
  function themeAusloeserDa() {
    return !!document.querySelector('.product__media-toggle')
        || !!document.querySelector('modal-opener.product__modal-opener--image');
  }

  /* Zustaendig nur dort, wo die App die Galerie uebernommen hat UND kein
     Theme-Auslöser mehr existiert. Auf normalen Produktseiten bleibt
     damit alles beim Theme. */
  function zustaendig() { return galerieDa() && !themeAusloeserDa(); }

  /* Shopify haengt die Anzeigebreite als _1000x an. Fuer das Vollbild
     wird sie hochgesetzt; das Original ist 2000 x 2000. */
  function hoheAufloesung(src) {
    if (!src) return src;
    return src.replace(/_(\d+)x(?=\.(?:png|jpe?g|webp|gif)(?:\?|$))/i, '_' + BREITE + 'x');
  }

  /* Reihenfolge = Reihenfolge der Slides, damit das Blaettern im Vollbild
     dem entspricht, was der Kunde in der Galerie sieht. */
  /* 🔴 19.08.2026 — WARUM NICHT NUR `src` GELESEN WIRD
     Splide laedt die Galeriebilder verzoegert: Ein noch nicht sichtbares Bild
     hat KEIN src, sondern traegt seine Adresse in `data-splide-lazy` und steht
     auf display:none. Gemessen an FG 02 direkt nach dem Seitenaufruf: von
     sieben Slides hatten nur zwei ein src, vier lagen lazy.

     Fuer die Lightbox hatte das zwei Folgen:
     1. Sie kannte nur 3 der 7 Bilder ("3 / 3" im Zaehler).
     2. Der angeklickte Index stimmte nicht mehr mit der Liste ueberein - das
        Vollbild zeigte den Nachbarn. Stefans Meldung: "oeffnet hier das
        Aufmassbild, eins dahinter."

     Beides faellt weg, sobald die Lazy-Adresse mitgelesen wird. */
  function bildQuelle(img) {
    if (!img) return '';
    return img.getAttribute('src') || img.getAttribute('data-splide-lazy') || '';
  }

  /* ⭐ Die EINE Bedingung, nach der ein Slide in die Lightbox kommt.
     Sie wird an ZWEI Stellen gebraucht - beim Sammeln der Bilder und beim
     Ermitteln des angeklickten Index. Standen die beiden auseinander, zeigte
     das Vollbild den Nachbarn. Deshalb hier gebuendelt: Wer die Regel
     aendert, aendert sie zwangslaeufig fuer beide. */
  function zaehltMit(slide) {
    return !!(bildQuelle(slide.querySelector('img')) || slide.querySelector('canvas'));
  }

  function sammeln() {
    var liste = [];
    var slides = document.querySelectorAll('.cl-po--gallery-main .splide__slide');
    for (var i = 0; i < slides.length; i++) {
      /* Splide klont Slides fuer den Endlos-Lauf. Klone tragen
         is-clone und wuerden jedes Bild doppelt einreihen. */
      if (slides[i].classList.contains('is-clone')) continue;
      if (!zaehltMit(slides[i])) continue;
      var img = slides[i].querySelector('img');
      var can = slides[i].querySelector('canvas');
      var quelle = bildQuelle(img);
      if (quelle) {
        liste.push({ typ: 'bild', quelle: hoheAufloesung(quelle),
                     text: img.getAttribute('alt') || '' });
      } else if (can) {
        liste.push({ typ: 'canvas', knoten: can, text: 'Ihre Konfiguration' });
      }
    }
    return liste;
  }

  function stilEinmal() {
    if (document.getElementById(STIL_ID)) return;
    var s = document.createElement('style');
    s.id = STIL_ID;
    s.textContent =
        '.cl-po--gallery-main .splide__slide img,'
      + '.cl-po--gallery-main .splide__slide canvas{cursor:zoom-in}'
      + '#' + LIGHTBOX_ID + '{position:fixed;inset:0;z-index:9999;display:none;'
      + 'align-items:center;justify-content:center;background:rgba(17,17,17,.92);}'
      + '#' + LIGHTBOX_ID + '.mo-auf{display:flex}'
      + '#' + LIGHTBOX_ID + ' img{max-width:92vw;max-height:88vh;'
      + 'object-fit:contain;cursor:zoom-out}'
      /* 44 x 44 Klickflaeche - WCAG 2.5.8, wie beim Maß-Tooltip */
      + '#' + LIGHTBOX_ID + ' button{position:absolute;width:44px;height:44px;'
      + 'display:flex;align-items:center;justify-content:center;background:none;'
      + 'border:0;padding:0;color:#fff;font-size:30px;line-height:1;'
      + 'cursor:pointer;opacity:.75}'
      + '#' + LIGHTBOX_ID + ' button:hover,#' + LIGHTBOX_ID + ' button:focus-visible{opacity:1}'
      + '#' + LIGHTBOX_ID + ' .mo-zu{top:8px;right:12px;font-size:38px}'
      + '#' + LIGHTBOX_ID + ' .mo-vor{left:12px;top:50%;margin-top:-22px}'
      + '#' + LIGHTBOX_ID + ' .mo-nach{right:12px;top:50%;margin-top:-22px}'
      + '#' + LIGHTBOX_ID + ' .mo-zaehler{position:absolute;bottom:14px;left:0;right:0;'
      + 'text-align:center;color:#fff;font-size:14px;opacity:.8;pointer-events:none}'
      + '@media screen and (max-width:749px){#' + LIGHTBOX_ID + ' img{max-width:96vw}'
      + '#' + LIGHTBOX_ID + ' .mo-vor{left:2px}#' + LIGHTBOX_ID + ' .mo-nach{right:2px}}';
    document.head.appendChild(s);
  }

  function zeigen(i) {
    if (!bilder.length) return;
    zeiger = (i + bilder.length) % bilder.length;
    var b = bilder[zeiger];
    /* Das Canvas wird ERST HIER ausgelesen, nicht beim Sammeln: der
       Datenstring ist rund 1,7 MB, und er soll den aktuellen
       Konfigurationsstand zeigen, nicht den von vor dem Klick. */
    bildEl.setAttribute('src', b.typ === 'canvas' ? b.knoten.toDataURL('image/png') : b.quelle);
    bildEl.setAttribute('alt', b.text);
    if (zaehlerEl) zaehlerEl.textContent = (zeiger + 1) + ' / ' + bilder.length;
  }

  function bauen() {
    if (kasten) return;
    stilEinmal();
    kasten = document.createElement('div');
    kasten.id = LIGHTBOX_ID;
    kasten.setAttribute('role', 'dialog');
    kasten.setAttribute('aria-modal', 'true');
    kasten.setAttribute('aria-label', 'Bild in Vollansicht');
    kasten.innerHTML =
        '<button type="button" class="mo-zu" aria-label="Schließen">&times;</button>'
      + '<button type="button" class="mo-vor" aria-label="Vorheriges Bild">&#8249;</button>'
      + '<img src="" alt="">'
      + '<button type="button" class="mo-nach" aria-label="Nächstes Bild">&#8250;</button>'
      + '<span class="mo-zaehler"></span>';
    document.body.appendChild(kasten);

    bildEl    = kasten.querySelector('img');
    zaehlerEl = kasten.querySelector('.mo-zaehler');

    kasten.querySelector('.mo-zu').addEventListener('click', zu);
    kasten.querySelector('.mo-vor').addEventListener('click', function (e) {
      e.stopPropagation(); zeigen(zeiger - 1);
    });
    kasten.querySelector('.mo-nach').addEventListener('click', function (e) {
      e.stopPropagation(); zeigen(zeiger + 1);
    });
    /* Klick auf den Hintergrund ODER auf das Bild schliesst - das Bild
       traegt cursor:zoom-out, also ist es auch so angekuendigt. */
    kasten.addEventListener('click', function (e) {
      if (e.target === kasten || e.target === bildEl) zu();
    });
  }

  function auf(startIndex) {
    bilder = sammeln();
    if (!bilder.length) return;
    bauen();
    zeigen(startIndex);
    kasten.classList.add('mo-auf');
    document.documentElement.style.overflow = 'hidden';
    var zuKnopf = kasten.querySelector('.mo-zu');
    if (zuKnopf) zuKnopf.focus();
    /* Die Hover-Lupe wuerde sonst unter der Lightbox stehenbleiben,
       weil ihr mouseleave nicht mehr feuert. */
    var lupe = document.querySelectorAll('.mo-zoom-rahmen, .mo-zoom-fenster');
    for (var i = 0; i < lupe.length; i++) lupe[i].style.display = 'none';
    /* Nur ein Bild? Dann sind Pfeile und Zaehler Ballast. */
    var mehrere = bilder.length > 1 ? '' : 'none';
    kasten.querySelector('.mo-vor').style.display  = mehrere;
    kasten.querySelector('.mo-nach').style.display = mehrere;
    kasten.querySelector('.mo-zaehler').style.display = mehrere;
  }

  function zu() {
    if (!kasten) return;
    kasten.classList.remove('mo-auf');
    document.documentElement.style.overflow = '';
    /* Der 1,7-MB-Datenstring des Canvas soll nicht im Speicher bleiben. */
    if (bildEl) bildEl.removeAttribute('src');
  }

  function offen() { return !!kasten && kasten.classList.contains('mo-auf'); }

  /* start() laeuft zweimal - sofort und als Nachzuegler. Ohne diesen
     Merker haengen beide Listener doppelt, und jeder Klick oeffnet die
     Lightbox zweimal (das zweite auf() setzt den Zeiger zurueck). */
  var listenerStehen = false;

  function start() {
    if (!zustaendig()) return;
    stilEinmal();
    if (listenerStehen) return;
    listenerStehen = true;

    /* Delegiert am Dokument, weil Splide seine Slides neu aufbaut und
       direkt gebundene Listener dabei verlorengehen. */
    document.addEventListener('click', function (e) {
      if (offen()) return;
      var ziel = e.target;
      if (!ziel || !ziel.closest) return;
      /* Die Pfeile der Galerie sollen weiter blaettern, nicht zoomen. */
      if (ziel.closest('.splide__arrow')) return;
      /* Nur die Hauptbuehne, nicht die Miniaturen: ein Klick auf eine
         Miniatur soll wie bisher den Hauptslide wechseln. */
      var slide = ziel.closest('.cl-po--gallery-main .splide__slide');
      if (!slide) return;
      if (!ziel.closest('img') && !ziel.closest('canvas')) return;
      if (!zustaendig()) return;

      e.preventDefault();
      e.stopPropagation();

      /* Startbild: die Position des angeklickten Slides unter den
         Nicht-Klonen - sonst oeffnet das Vollbild beim geklonten Slide
         das falsche Bild. */
      var alle = document.querySelectorAll('.cl-po--gallery-main .splide__slide');
      var index = 0, n = 0;
      for (var i = 0; i < alle.length; i++) {
        if (alle[i].classList.contains('is-clone')) continue;
        if (alle[i] === slide) { index = n; break; }
        /* 🔴 19.08.2026 — hier stand ein blankes n++, und genau das war der
           Fehler: Diese Zaehlung muss DIESELBE Bedingung benutzen wie
           sammeln(). Dort faellt ein Slide heraus, dessen Bild noch kein
           src-Attribut hat (Lazy Loading) - mitgezaehlt wurde er trotzdem.
           Ab dem ersten solchen Slide war alles um eins verschoben, und das
           Vollbild zeigte den Nachbarn. Stefans Meldung: "wenn ich auf das
           Bild in der Galerie druecke ... oeffnet hier das Aufmassbild, eins
           dahinter." Tritt nur auf, solange nicht alle Bilder geladen sind -
           also genau dann, wenn ein Kunde zuerst klickt. */
        if (zaehltMit(alle[i])) n++;
      }
      auf(index);
    }, true);

    document.addEventListener('keydown', function (e) {
      if (!offen()) return;
      if (e.key === 'Escape')     { zu(); }
      if (e.key === 'ArrowLeft')  { zeigen(zeiger - 1); }
      if (e.key === 'ArrowRight') { zeigen(zeiger + 1); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* 🔴 EIN FESTES setTimeout REICHT NICHT - am 17.08.2026 gemessen.
     Mit setTimeout(start, 800) war der Block nach einem frischen
     Seitenaufruf NICHT aktiv: die App hatte ihre Galerie da noch nicht
     gebaut, und danach versuchte es niemand mehr. Beim ersten Test lief
     es nur, weil zufaellig mehr Zeit vergangen war - also nicht
     verlaesslich, sondern Glueck.
     Deshalb wird gewartet, BIS die Galerie da ist: ein Beobachter am
     body, der sich selbst abmeldet, sobald er greift. Der Deckel von
     15 s verhindert, dass er auf Seiten ohne Konfigurator ewig laeuft. */
  if (!listenerStehen && window.MutationObserver) {
    var beob = new MutationObserver(function () {
      if (!galerieDa()) return;
      start();
      if (listenerStehen) beob.disconnect();
    });
    beob.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { beob.disconnect(); }, 15000);
  }
})();

/* ===================================================================
 * Metallbau Odenthal - Maß-Empfehlung unter dem Feld         v1.0.0
 * AUSGELIEFERT IN: Theme 2.05 (203762991436), 17.08.2026
 *
 * Stefans Frage vom 17.08.2026 zu der Luecke unter dem Maßfeld:
 * "hier koennen wir nachtragen?" — ja. Der seitliche Zuschlag steht
 * bisher nur im ⓘ-Tooltip, und der oeffnet seit heute nur noch per
 * Klick. Wer ihn nicht anklickt, traegt die Fensterbreite ein und
 * bekommt ein zu kleines Bauteil.
 *
 * ⚠️ DER TEXT WIRD NICHT HIER GEPFLEGT, sondern aus dem Tooltip
 * gelesen (Abschnitt .mo-t-tipp). Grund: Der Zuschlag ist je Bauart
 * verschieden — Fenstergitter 140/70 mm, Franzoesischer Balkon
 * 160/80 mm — und steht in params.info JEDER Config. Zwei Quellen
 * fuer dieselbe Zahl laufen frueher oder spaeter auseinander; hier
 * gibt es weiterhin genau eine.
 *
 * Es wird nur der erste Satz uebernommen (das Beispiel in
 * .mo-t-beispiel bleibt dem Tooltip vorbehalten) — unter dem Feld ist
 * Platz fuer eine Zeile, nicht fuer einen Absatz.
 *
 * ⚠️ AUSSENWAND UND LAIBUNG TRAGEN VERSCHIEDENE TEXTE. In der Laibung
 * wird NICHTS addiert, dort zaehlt das lichte Maß. Welcher Block gilt,
 * entscheidet die Klasse mo-bef-laibung am <html> — dieselbe, an der
 * schon die Aufmaß-Skizze haengt (Block mo_aufmass_skizze).
 * =================================================================== */
(function () {
  'use strict';
  if (!window.MO_LPO_AKTIV) return;  /* LPO aus: Block ruht - siehe LPO-SCHALTER oben (26.09.2026) */

  var ID      = 'mo-mass-empfehlung';
  var STIL_ID = 'mo-mass-empfehlung-stil';

  function massKnoten() {
    return document.querySelector('.cl-po--option[data-option="Maße"]')
        || document.querySelector('.cl-po--option[data-option="Maße:"]');
  }

  function laibung() {
    return document.documentElement.classList.contains('mo-bef-laibung');
  }

  /* Den Tipp-Absatz aus dem Tooltip-HTML holen. Das Attribut ist reiner
     Text, deshalb wird er in ein losgeloestes Element geparst — nichts
     davon landet im Dokument. */
  function tippText() {
    var knoten = massKnoten();
    if (!knoten) return '';
    var traeger = knoten.querySelector('[data-tippy-content]');
    if (!traeger) return '';
    var roh = traeger.getAttribute('data-tippy-content') || '';
    if (roh.indexOf('mo-t-tipp') === -1) return '';

    var hilf = document.createElement('div');
    hilf.innerHTML = roh;
    var bereich = hilf.querySelector(laibung() ? '.mo-t-laibung' : '.mo-t-aussen');
    var tipp = bereich ? bereich.querySelector('.mo-t-tipp') : null;
    if (!tipp) return '';

    /* Das Beispiel bleibt im Tooltip - hier ist Platz fuer eine Zeile. */
    var beispiel = tipp.querySelector('.mo-t-beispiel');
    if (beispiel) beispiel.remove();

    /* ⚠️ MOBIL IST DAS LABEL ZWEI ZEILEN LANG. "Empfohlener
       Befestigungsabstand:" braucht bei 281 px Kastenbreite allein zwei
       Zeilen, der ganze Kasten vier - gemessen 89 px am 21.08.2026. Der
       Kasten steht direkt unter dem gleichnamigen Feld, der Bezug ist
       also ohnehin da.

       ⚠️ GEKUERZT WIRD NUR DAS LABEL, NIE DIE ZAHL. Die kommt weiterhin
       ausschliesslich aus params.info der Config - fuer Fenstergitter
       140/70 mm, fuer Franzoesische Balkone 160/80 mm. Genau deshalb
       liest dieser Block den Text ueberhaupt aus dem Tooltip statt ihn
       zu fuehren; eine zweite Quelle fuer dieselbe Zahl laeuft frueher
       oder spaeter auseinander.

       Greift nur beim Aussenwand-Text. Die Laibung sagt "Empfohlen:
       lichtes Maß minus 5-10 mm" und ist schon kurz genug. */
    if (matchMedia('(max-width: 749px)').matches) {
      var kopf = tipp.querySelector('strong');
      if (kopf && /^Empfohlener\s+Befestigungsabstand:?$/.test(kopf.textContent.trim())) {
        kopf.textContent = 'Empfehlung:';
      }
    }
    return tipp.innerHTML.replace(/<br\s*\/?>\s*$/i, '').trim();
  }

  function stilEinmal() {
    if (document.getElementById(STIL_ID)) return;
    var s = document.createElement('style');
    s.id = STIL_ID;
    s.textContent =
        '#' + ID + '{margin:6px 0 2px;padding:8px 10px;'
      + 'background:rgba(234,91,11,.08);border-left:3px solid #ea5b0b;'
      + 'border-radius:4px;font-size:14px;line-height:1.4;color:#333;'
      /* Sicherheitsnetz: .cl-po--panel steht auf overflow:hidden -
         ohne Umbruch wuerde ein langer Text dort abgeschnitten. */
      + 'overflow-wrap:break-word;word-break:normal}'
      + '#' + ID + ' strong{color:#c04a08}'
      + '@media screen and (max-width:749px){#' + ID + '{font-size:13px}}';
    document.head.appendChild(s);
  }

  /* 🔴 DIE AUFMASS-SKIZZE STEHT ABSOLUT — am 17.08.2026 gemessen:
     span.cl-po--info, position:absolute, rund 204 px breit, rechts in
     der Maß-Option. Sie nimmt damit KEINEN Platz im Fluss ein, und die
     Empfehlungszeile lief unter ihr durch (Stefan: "abgeschnitten").
     Der Rand wird gemessen statt geraten, weil die Skizze je nach
     Fensterbreite 150-320 px misst. */
  function randRechts(knoten, zeile) {
    var skizze = knoten.querySelector('.cl-po--info');
    if (!skizze || getComputedStyle(skizze).position !== 'absolute') {
      zeile.style.marginRight = '';
      return;
    }
    var s = skizze.getBoundingClientRect();
    var k = knoten.getBoundingClientRect();
    var z = zeile.getBoundingClientRect();
    /* Nur wenn sie sich auch senkrecht ueberschneiden - sonst ist der
       Rand unnoetig und verschenkt Breite. */
    var senkrechtUeberlappt = s.bottom > z.top && s.top < z.bottom;
    if (!senkrechtUeberlappt || s.width <= 0) {
      zeile.style.marginRight = '';
      return;
    }
    var frei = Math.max(0, Math.round(k.right - s.left) + 12);
    zeile.style.marginRight = frei + 'px';
  }

  function zeigen() {
    var knoten = massKnoten();
    if (!knoten) return;

    var text = tippText();
    var zeile = document.getElementById(ID);

    if (!text) {                       /* Config ohne Tipp - nichts anzeigen */
      if (zeile) zeile.hidden = true;
      return;
    }

    stilEinmal();

    /* Nach einem Neuaufbau der Optionen haengt die Zeile womoeglich in
       einem entfernten Knoten - dann neu einsetzen. */
    if (zeile && zeile.parentElement !== knoten) {
      zeile.parentElement.removeChild(zeile);
      zeile = null;
    }
    if (!zeile) {
      zeile = document.createElement('div');
      zeile.id = ID;
      zeile.setAttribute('role', 'note');
      knoten.appendChild(zeile);
    }
    if (zeile.innerHTML !== text) zeile.innerHTML = text;
    zeile.hidden = false;
    randRechts(knoten, zeile);
  }

  /* Zwei getrennte Merker: Beim ersten Lauf fehlt der Wrapper
     womoeglich noch, die Listener stehen dann aber schon. */
  var listenerStehen  = false;
  var beobachterSteht = false;

  function start() {
    zeigen();

    if (!listenerStehen) {
      listenerStehen = true;
      /* Die Befestigungsart wechselt den Text - option:changed feuert
         die App, die Klasse setzt der Aufmaß-Block kurz darauf. */
      window.addEventListener('option:changed', function () { setTimeout(zeigen, 60); });
      document.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('.cl-po--option')) setTimeout(zeigen, 60);
      }, true);
      /* Die Skizze waechst und schrumpft mit dem Fenster - der Rand
         muss dann neu gemessen werden. */
      var bremse = null;
      window.addEventListener('resize', function () {
        clearTimeout(bremse);
        bremse = setTimeout(zeigen, 150);
      });
    }

    if (!beobachterSteht) {
      var wrap = document.querySelector('.cl-po--wrapper');
      if (wrap && window.MutationObserver) {
        beobachterSteht = true;
        var laeuft = false;
        new MutationObserver(function () {
          if (laeuft) return;
          laeuft = true;
          setTimeout(function () { laeuft = false; zeigen(); }, 0);
        }).observe(wrap, { childList: true, subtree: true });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  setTimeout(start, 900);

  /* 🔴 EIN FESTES TIMEOUT REICHT NICHT — am 17.08.2026 zum zweiten Mal
     erlebt (nach der Galerie-Lightbox). Rendert die App ihre Optionen
     spaeter als 900 ms, findet start() die Maß-Option nicht, der
     Beobachter wird mangels .cl-po--wrapper nie gesetzt — und danach
     versucht es niemand mehr. Die Zeile fehlte dann komplett.
     Deshalb warten, BIS die Maß-Option existiert. */
  if (!beobachterSteht && window.MutationObserver) {
    var warteBeob = new MutationObserver(function () {
      if (!massKnoten()) return;
      start();
      if (beobachterSteht) warteBeob.disconnect();
    });
    warteBeob.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { warteBeob.disconnect(); }, 15000);
  }
})();




/* ============================================================================
 * Metallbau Odenthal — Bildlupe, shopweit          v1.0.0 · 18.08.2026
 * ============================================================================
 * Stefan: „wenn man hier ein Bild anklickt vergroessern. mobil und destop." —
 * danach: „beide patches auch der andere sollen Shopweit sein."
 *
 * Ein Klick (oder Tipp) auf ein Inhaltsbild zeigt es formatfuellend. Blaettern
 * mit Pfeilen, Wischen und den Pfeiltasten innerhalb DESSELBEN Abschnitts,
 * schliessen mit Esc, dem X oder einem Klick daneben.
 *
 * ⚠️ WARUM REGELN UND KEINE SELEKTORLISTE: Der erste Anlauf sass in den
 * Sections selbst (`mo-fertigung.liquid`, `image-with-text.liquid`). Das trug
 * nur die Startseite und „Unser Unternehmen" — jede weitere Seite bringt eigene
 * Behaelter mit, der Meisterbrief etwa `ai-certificate-image-wrapper-<hash>`.
 * Eine Aufzaehlung waere nie vollstaendig gewesen. Deshalb entscheidet hier
 * eine Regel, und die beiden Sections wurden auf ihren Urzustand zurueckgesetzt
 * — es gibt genau EINE Lupe im Shop.
 *
 * ⚠️ AUSGENOMMEN sind Kopf, Fuss, Warenkorb, Produktgalerie und Konfigurator.
 * Die Produktgalerie hat ihre eigene Lightbox (`#mo-galerie-lightbox` weiter
 * oben in dieser Datei); zwei Klickwege auf demselben Bild wuerden sich
 * gegenseitig aufmachen. Verlinkte Bilder bleiben ebenfalls aussen vor — dort
 * gehoert der Klick dem Link.
 *
 * Das Aussehen steht in `custom.css`, Abschnitt 66.
 * ============================================================================ */
(function () {
  'use strict';

  /* Bereiche, in denen kein Bild angefasst wird. */
  var AUSGENOMMEN = [
    '#shopify-section-header', '#shopify-section-footer', 'header', 'footer',
    '.announcement-bar', '.breadcrumbs', '.header-wrapper',
    '.product__media-list', '.product__media', 'product-modal', 'media-gallery',
    /* ⚠️ Der ganze Konfigurator ueber den Teilstring, nicht ueber einzelne
       Klassen: Der erste Anlauf nannte `.cl-po--wrapper` und
       `.cl-po--gallery-main` — die MINIATUREN der App heissen aber
       `.cl-po--gallery-thumbnail` und lagen ausserhalb beider. Ein Klick darauf
       schaltet das Hauptbild um; die Lupe hatte ihn geschluckt. */
    '[class*="cl-po--"]', '#mo-galerie-lightbox',
    'cart-drawer', '.cart-items', '.cart-item', '.drawer',
    '.mo-lupe',
    /* ⚠️ Am 18.08. an der Startseite nachgemessen und nachgetragen: Diese drei
       tragen einen Klick, der WOANDERS hingehoert — die Lupe haette ihn
       geschluckt. Das Hero-Bild ist Hintergrund fuer Text und Knopf, die
       Kategoriekachel fuehrt in die Kategorie, die Produktkachel zum Produkt.
       (Verlinkte Bilder faengt `closest('a')` ab; diese drei sind es NICHT —
       der Knopf liegt daneben, nicht um das Bild herum.) */
    '.slideshow__media', '.banner__media',
    '.collection-image-wrapper',
    '.card__media', '.card-wrapper', '.card',
    /* Personenfotos bleiben klein — Stefans Ansage vom 18.08.2026:
       „die Bilder von stefan und Alina nicht vergroessern koennen".
       `.dmb-person` traegt beide Portraets im Abschnitt „menschen". */
    '.dmb-person',
    /* Zurueckgenommen am 18.08.2026 nachts, Stefans Ansage: „Kollektions-
       bilder und diese grossen auch rueckgaengig nicht anklickbar machen."
       Beide werden ohnehin formatfuellend gezeigt (Kollektionskopf 485 x 876,
       „Bild mit Text" bis 485 x 695) — eine Lupe bringt dort nichts dazu.
       ⚠️ Das ist die Ruecknahme der Erweiterung vom selben Abend; wer sie
       wiederhaben will, nimmt genau diese zwei Zeilen heraus. */
    '.collection-hero', '.collection-hero__image-container',
    '.image-with-text__media',
    /* Notbremse fuer jeden weiteren Fall: Diese Klasse oder dieses Attribut an
       ein Bild ODER an einen Behaelter darueber, und die Lupe laesst es in
       Ruhe. Damit braucht der naechste Ausschluss keine Code-Aenderung mehr. */
    '.mo-lupe-aus', '[data-mo-lupe-aus]'
  ].join(',');

  /* Kleiner als das ist Beiwerk — Symbole, Zahlungslogos, Schriftzuege.
     ⚠️ 90 statt der zuerst gewaehlten 200/140: Im Bildmosaik der Fertigung sind
     zwei Kacheln nur 145 und 98 px breit, die fielen sonst heraus — von fuenf
     Bildern liessen sich nur drei oeffnen. Die Hoehe traegt den Ausschluss:
     Das Kopf-Logo ist 150 x 40, jedes Zahlungssymbol kleiner. */
  var MIN_BREITE = 90, MIN_HOEHE = 90;

  var box = null;

  /* ---------------------------------------------------------------- Overlay */
  function overlay() {
    if (box) return box;
    box = document.createElement('div');
    box.className = 'mo-lupe';
    box.id = 'mo-lupe';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Bild in gross');
    box.innerHTML =
      '<button type="button" class="mo-lupe__zu" aria-label="Schliessen">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>' +
      '</button>' +
      '<button type="button" class="mo-lupe__pf mo-lupe__pf--vor" aria-label="Vorheriges Bild">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>' +
      '</button>' +
      '<img class="mo-lupe__bild" alt="">' +
      '<button type="button" class="mo-lupe__pf mo-lupe__pf--zur" aria-label="Naechstes Bild">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>' +
      '</button>' +
      '<p class="mo-lupe__zaehler"></p>';
    document.body.appendChild(box);

    box.bild = box.querySelector('.mo-lupe__bild');
    box.zaehler = box.querySelector('.mo-lupe__zaehler');
    box.knopfZu = box.querySelector('.mo-lupe__zu');
    box.pfVor = box.querySelector('.mo-lupe__pf--vor');
    box.pfZur = box.querySelector('.mo-lupe__pf--zur');
    box.liste = [];
    box.i = 0;

    box.knopfZu.addEventListener('click', schliessen);
    box.pfVor.addEventListener('click', function () { zeige(box.i - 1); });
    box.pfZur.addEventListener('click', function () { zeige(box.i + 1); });
    /* Klick auf den dunklen Grund schliesst — auf das Bild selbst nicht. */
    box.addEventListener('click', function (e) { if (e.target === box) schliessen(); });

    /* Wischen im Overlay. Schwelle 40px, damit ein Tippen mit zitternder Hand
       nicht schon blaettert. */
    var wx = 0, wy = 0, aktiv = false;
    box.addEventListener('pointerdown', function (e) { wx = e.clientX; wy = e.clientY; aktiv = true; }, { passive: true });
    box.addEventListener('pointerup', function (e) {
      if (!aktiv) return;
      aktiv = false;
      var dx = e.clientX - wx;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(e.clientY - wy)) zeige(box.i + (dx < 0 ? 1 : -1));
    }, { passive: true });

    return box;
  }

  /* ------------------------------------------------- groesste Fassung holen */
  function grossQuelle(bild) {
    var best = bild.currentSrc || bild.src, breiteste = 0;
    (bild.getAttribute('srcset') || '').split(',').forEach(function (teil) {
      var m = teil.trim().match(/^(\S+)\s+(\d+)w$/);
      if (m && parseInt(m[2], 10) > breiteste) { breiteste = parseInt(m[2], 10); best = m[1]; }
    });
    /* ⚠️ Ist das Original breiter als die groesste srcset-Angabe, direkt danach
       fragen: Die Fertigungsbilder sind 1086 px breit, ihr srcset endet aber
       bei 900 — sonst zeigt die Lupe weniger, als vorhanden ist. Gedeckelt auf
       1800, denn `image_url` skaliert NICHT hoch; ein groesserer Wert waere ein
       Versprechen, das Shopify nie einloest. */
    var echt = parseInt(bild.getAttribute('width') || '0', 10);
    if (echt > breiteste && /[?&]width=\d+/.test(best)) {
      best = best.replace(/([?&]width=)\d+/, '$1' + Math.min(echt, 1800));
    }
    return best;
  }

  function zeige(i) {
    var n = box.liste.length;
    if (!n) return;
    box.i = (i + n) % n;                       /* laeuft rund */
    var q = box.liste[box.i];
    box.bild.src = grossQuelle(q);
    box.bild.alt = q.alt || '';
    box.zaehler.textContent = n > 1 ? (box.i + 1) + ' / ' + n : '';
    box.pfVor.hidden = box.pfZur.hidden = (n < 2);
    if (n > 1) {                               /* Nachbarn vorladen */
      [box.i + 1, box.i - 1].forEach(function (k) {
        var nb = box.liste[(k + n) % n];
        if (nb) { var v = new Image(); v.src = grossQuelle(nb); }
      });
    }
  }

  function oeffnen(liste, i, zurueck) {
    overlay();
    box.liste = liste;
    box.zurueck = zurueck || null;
    box.overflowVorher = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';    /* Seite still */
    document.body.classList.add('mo-lupe-offen');          /* Chat weicht */
    box.hidden = false;
    zeige(i);
    /* ⚠️ Zeitgeber statt requestAnimationFrame: rAF haengt an gezeichneten
       Bildern und feuert in einem Fenster, das nicht zeichnet (Vorschaupanel,
       Hintergrundtab), nie — das Overlay bliebe unsichtbar. */
    setTimeout(function () { box.classList.add('ist-da'); }, 16);
    box.knopfZu.focus();
  }

  function schliessen() {
    if (!box || box.hidden) return;
    box.classList.remove('ist-da');
    setTimeout(function () {
      box.hidden = true;
      box.bild.removeAttribute('src');          /* Speicher wieder frei */
      document.documentElement.style.overflow = box.overflowVorher || '';
      document.body.classList.remove('mo-lupe-offen');
      if (box.zurueck && box.zurueck.focus) box.zurueck.focus();
    }, 180);
  }

  /* ------------------------------------------------------- taugt das Bild? */
  function taugt(bild) {
    if (!bild || bild.tagName !== 'IMG') return false;
    if (bild.closest('a')) return false;                    /* Klick gehoert dem Link */
    if (bild.closest(AUSGENOMMEN)) return false;
    if (/placeholder/i.test(bild.className || '')) return false;
    var r = bild.getBoundingClientRect();
    return r.width >= MIN_BREITE && r.height >= MIN_HOEHE;
  }

  /* Die Gruppe zum Blaettern ist der umgebende Abschnitt. Sie wird beim Klick
     frisch gebildet, nicht beim Start gemerkt — sonst fehlen nachgeladene
     Bilder, und die Reihenfolge stimmt nach einem Section-Neuaufbau nicht mehr. */
  function gruppe(bild) {
    var abschnitt = bild.closest('[id^="shopify-section-"]') || document.body;
    var alle = Array.prototype.slice.call(abschnitt.querySelectorAll('img')).filter(taugt);
    return alle.length ? alle : [bild];
  }

  /* --------------------------------------------- Bilder kenntlich machen */
  function vorbereiten() {
    var bilder = document.querySelectorAll('img:not([data-mo-lupe])');
    Array.prototype.forEach.call(bilder, function (bild) {
      if (!taugt(bild)) return;
      bild.setAttribute('data-mo-lupe', '1');
      bild.classList.add('mo-lupe-bereit');
      /* Tastaturbedienung. ⚠️ Es wird KEIN Element eingefuegt: In Bildrastern
         haengen die Aufteilungen an `:nth-child`, ein zusaetzlicher Knopf
         wuerde sie verschieben. */
      bild.setAttribute('tabindex', '0');
      bild.setAttribute('role', 'button');
      bild.setAttribute('aria-label', (bild.alt ? bild.alt + ' — ' : '') + 'Bild gross anzeigen');
    });
  }

  /* ------------------------------------------------------------ Bedienung */
  /* ⚠️ Bewegungsschwelle: Auf dem Handy endet jedes Scrollen mit einem Klick
     auf dem Element, unter dem der Finger loslaesst — und Bildraster sind dort
     Wisch-Streifen. Ohne die 10px ginge beim Scrollen staendig die Lupe auf.
     ⚠️ `pointermove` feuert auch OHNE gedrueckten Finger (die Maus faehrt
     darueber) — daher der Merker `unten`. Ohne ihn haette jede Mausbewegung
     ueber einem Bild den naechsten Klick verschluckt. */
  var sx = 0, sy = 0, unten = false, gewischt = false;
  document.addEventListener('pointerdown', function (e) {
    sx = e.clientX; sy = e.clientY; unten = true; gewischt = false;
  }, { passive: true, capture: true });
  document.addEventListener('pointermove', function (e) {
    if (unten && (Math.abs(e.clientX - sx) > 10 || Math.abs(e.clientY - sy) > 10)) gewischt = true;
  }, { passive: true, capture: true });
  document.addEventListener('pointerup', function () { unten = false; }, { passive: true, capture: true });
  document.addEventListener('pointercancel', function () { unten = false; gewischt = true; }, { passive: true, capture: true });

  document.addEventListener('click', function (e) {
    if (gewischt) return;
    var bild = e.target;
    if (!bild || bild.tagName !== 'IMG' || !bild.classList.contains('mo-lupe-bereit')) return;
    if (box && !box.hidden) return;                        /* schon offen */
    e.preventDefault();
    var g = gruppe(bild);
    oeffnen(g, Math.max(0, g.indexOf(bild)), bild);
  });

  document.addEventListener('keydown', function (e) {
    if (box && !box.hidden) {
      if (e.key === 'Escape') { e.preventDefault(); schliessen(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); zeige(box.i - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); zeige(box.i + 1); }
      return;
    }
    /* Enter/Leertaste auf einem Bild oeffnet ebenfalls. */
    var a = document.activeElement;
    if (a && a.tagName === 'IMG' && a.classList.contains('mo-lupe-bereit') &&
        (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      var g = gruppe(a);
      oeffnen(g, Math.max(0, g.indexOf(a)), a);
    }
  });

  /* Erst wenn das Layout steht — vorher liefert `getBoundingClientRect` bei
     Bildern ohne Groessenangabe 0 und die Regel wuerde sie aussortieren.
     Danach noch einmal bei jedem Section-Neuaufbau im Theme-Editor. */
  if (document.readyState === 'complete') vorbereiten();
  else addEventListener('load', vorbereiten);
  document.addEventListener('shopify:section:load', vorbereiten);
})();


/* ============================================================================
 * Metallbau Odenthal - VORSCHAU ZEIGEN, WENN EINE FARBE GEWAEHLT IST  v1.0.0
 * Stand: 19.08.2026
 *
 * DAS PROBLEM, GEMESSEN AN FG 02
 * Stefan: "wenn ich schwarz auswaehle kommt nicht die Farbe". Gemessen war
 * genau das Gegenteil der Fall: Die App HATTE Aussenwand_RAL_9005_x1200.jpg
 * geladen und das Canvas HATTE gezeichnet (toDataURL 1.092.370 Zeichen). Nur
 * stand die Galerie auf Slide 0 - dem verzinkten Produktfoto. Der Kunde sieht
 * seine Farbe angehakt und daneben ein verzinktes Gitter.
 *
 * WANN ES AUFTRITT
 * Beim Klick schaltet die App selbst auf den Vorschau-Slide um, da ist alles
 * richtig. Der Fehler zeigt sich, wenn die Seite mit bereits gesetzter Auswahl
 * aufgebaut wird - der Browser stellt die Radiobuttons beim Neuladen wieder
 * her, die App merkt davon nichts und laesst die Galerie auf Slide 0 stehen.
 *
 * WAS DIESER BLOCK TUT
 * Einmal nach dem Aufbau der Galerie: Ist eine ANDERE als die erste Farbe
 * gewaehlt, wird auf den Vorschau-Slide geschaltet. Danach kein Eingriff mehr,
 * damit der Kunde in Ruhe durch die Fotos blaettern kann.
 *
 * WARUM UEBER DAS MINIATURBILD
 * Am 19.08. beide Wege im Browser gemessen: Ein Splide-Objekt haengt NICHT am
 * Element (.splide ist undefined, keine splide-Schluessel), splide.go() faellt
 * damit aus. Der Klick auf das zugehoerige Miniaturbild schaltet zuverlaessig
 * um - gepruefter Weg.
 *
 * GILT FUER ALLE KONFIGURATOREN. Der Block haengt an .cl-po--gallery-main,
 * nicht an einem Produkt oder Tag - Fenstergitter, Franzoesische Balkone,
 * Stangen, Handlauf und jeder kuenftige Konfigurator sind mit erfasst.
 *
 * RUECKBAU: diesen Block loeschen.
 * ============================================================================ */
(function () {
  'use strict';
  if (!window.MO_LPO_AKTIV) return;  /* LPO aus: Block ruht - siehe LPO-SCHALTER oben (26.09.2026) */

  var FRIST = 15000;   /* wie bei der Lightbox: irgendwann ist Schluss */
  var erledigt = false;

  function slides() {
    var h = document.querySelector('.cl-po--gallery-main');
    return h ? h.querySelectorAll('.splide__slide:not(.is-clone)') : [];
  }

  function canvasIndex(sl) {
    for (var i = 0; i < sl.length; i++) if (sl[i].querySelector('canvas')) return i;
    return -1;
  }

  /* Vorbelegt ist immer die ERSTE Kachel (Feuerverzinkt). Weicht die Auswahl
     davon ab, hat der Kunde selbst gewaehlt - und will sein Ergebnis sehen. */
  function eigeneFarbe() {
    var gruppe = document.querySelector('[data-option="Oberfläche"]');
    if (!gruppe) return false;
    var alle = gruppe.querySelectorAll('input');
    var gew  = gruppe.querySelector('input:checked');
    return !!(alle.length && gew && gew.value !== alle[0].value);
  }

  function umschalten() {
    var sl = slides();
    if (!sl.length) return false;
    var ziel = canvasIndex(sl);
    if (ziel < 0) return false;                 /* Vorschau aus - nichts zu tun */

    var aktiv = -1;
    for (var i = 0; i < sl.length; i++) if (sl[i].classList.contains('is-active')) aktiv = i;
    if (aktiv === ziel) return true;            /* steht schon richtig */

    var thumbs = document.querySelectorAll(
      '.cl-po--gallery-thumbs .splide__slide:not(.is-clone),' +
      '.cl-po--gallery-thumbnails .splide__slide:not(.is-clone)');
    if (!thumbs[ziel]) return false;
    thumbs[ziel].click();
    return true;
  }

  function versuchen() {
    if (erledigt) return true;
    if (!document.querySelector('.cl-po--gallery-main')) return false;
    if (!eigeneFarbe()) { erledigt = true; return true; }   /* Standardfarbe: Foto zeigen */
    if (!umschalten()) return false;
    erledigt = true;
    return true;
  }

  /* ⭐ Auch NACH dem Laden noetig. Am 19.08. im Vorschau-Theme gemessen: Ein
     Klick auf RAL 9005 liess die Galerie auf Slide 0 stehen - die App schaltet
     also nicht zuverlaessig selbst um. Genau das war Stefans Meldung: "wenn ich
     schwarz auswaehle kommt nicht die Farbe".

     Ein Farbklick heisst "zeig mir diese Farbe", deshalb wird hier IMMER
     umgeschaltet - anders als beim Laden, wo die Standardfarbe das Produktfoto
     stehen laesst.

     Zweimal versucht, weil die App asynchron zeichnet: Der erste Anlauf kommt
     oft zu frueh, der zweite sitzt. Umschalten auf einen bereits aktiven Slide
     ist wirkungslos, doppelt schadet also nicht. */
  function beiFarbwechsel() {
    setTimeout(umschalten, 400);
    setTimeout(umschalten, 1400);
  }

  function start() {
    versuchen();

    /* Delegiert am Dokument: Die App baut ihre Optionen neu auf, ein Listener
       an der Gruppe selbst ueberlebte das nicht. */
    document.addEventListener('change', function (ev) {
      if (!ev.target || !ev.target.closest) return;
      if (!ev.target.closest('[data-option="Oberfläche"]')) return;
      beiFarbwechsel();
    }, { passive: true });

    if (erledigt) return;
    /* Kein festes Timeout - die App baut ihre Galerie asynchron auf.
       Gleiche Falle wie bei der Lightbox am 17.08.2026. */
    var beob = new MutationObserver(function () {
      if (versuchen()) beob.disconnect();
    });
    beob.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { beob.disconnect(); }, FRIST);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ============================================================================
 * Metallbau Odenthal — Befestigungsart: Bild-Tooltip mobil aus   20.08.2026
 * ============================================================================
 * Stefan: „Befestigungsart tooltipp sollte nur ausgemacht werden mobil mehr
 * nicht erstmal."
 *
 * Die App haengt an jede Swatch-Kachel einen Tippy-Tooltip. Bei der
 * Befestigungsart ist sein Inhalt ein BILD (gemessen: `data-tippy-content`
 * beginnt mit `<img src=…FG-01_Ka…>`); auf dem Handy legt es sich beim
 * Antippen quer ueber den Konfigurator.
 *
 * ⚠️ NUR die Befestigungsart. Farbauswahl und Spitzenform tragen ebenfalls
 * Tooltips, dort steht aber nur Text (gemessen) — die bleiben.
 * ⚠️ Die Aufmass-Skizze („Messanleitung antippen") ist ein anderes Element
 * (`.cl-po--info` an `Befestigungsabstand`) und wird nicht angefasst.
 *
 * ⚠️ Warum JS und nicht CSS: Tippy haengt das Popup an den <body>; dort ist
 * nicht mehr zu erkennen, von welcher Option es stammt. Ueber `_tippy.disable()`
 * wird gezielt der Ausloeser stillgelegt.
 *
 * ⚠️ Warum ein Beobachter: Die App baut ihre Optionen bei jeder Aenderung neu
 * und legt dabei frische Tippy-Instanzen an. Ein einmaliger Durchlauf wuerde
 * beim ersten Klick wieder ueberschrieben.
 * ============================================================================ */
(function () {
  'use strict';
  if (!window.MO_LPO_AKTIV) return;  /* LPO aus: Block ruht - siehe LPO-SCHALTER oben (26.09.2026) */
  var MOBIL = '(max-width: 749px)';
  var ZIELE = '[data-option="Befestigung"] [data-tippy-content],' +
              '[data-option="Schritt_Befestigungsart"] [data-tippy-content]';

  /* 🔴 NACHTRAG 21.08.2026 — die Breite wurde nur EINMAL geprueft.
     Stefan: „tooltipp hatten wir weg gemacht jetzt ist es wieder da?"
     Nachgemessen und reproduziert: Wird die Seite bei Desktop-Breite geladen
     und DANACH verkleinert (Fenster schmal ziehen, Tablet drehen, Handy von
     quer auf hoch), blieben beide Ausloeser `enabled:true` und der Tooltip
     kam wieder. Grund: `start()` stieg bei Desktop-Breite sofort aus, der
     Beobachter lief also nie an, und einen resize-Haken gab es nicht.

     Jetzt haengt der Block an der Media-Query selbst. Beim Wechsel zurueck
     auf Desktop werden die Ausloeser wieder eingeschaltet — sonst blieben
     sie fuer den Rest des Besuchs aus, obwohl sie am Rechner erwuenscht sind.

     ⚠️ Der Beobachter laeuft weiterhin NUR mobil. Ein Dauerbeobachter am
     documentElement kostet Ladezeit (siehe mo_aufmass_skizze.js). */
  function anwenden() {
    var mobil = matchMedia(MOBIL).matches;
    var treffer = document.querySelectorAll(ZIELE);
    Array.prototype.forEach.call(treffer, function (el) {
      if (!el._tippy || !el._tippy.state) return;
      if (mobil) {
        if (el._tippy.state.isEnabled) { el._tippy.hide(); el._tippy.disable(); }
      } else if (!el._tippy.state.isEnabled) {
        el._tippy.enable();
      }
    });
  }

  /* Gedrosselt: Der Beobachter feuert bei jedem Neuaufbau der App-Optionen,
     das waeren sonst Dutzende Durchlaeufe je Klick. */
  var warte = null;
  function angestossen() {
    if (warte) return;
    warte = setTimeout(function () { warte = null; anwenden(); }, 200);
  }

  var beob = null;
  function beobachten(an) {
    if (an && !beob) {
      beob = new MutationObserver(angestossen);
      beob.observe(document.documentElement, { childList: true, subtree: true });
    } else if (!an && beob) {
      beob.disconnect();
      beob = null;
    }
  }

  function aufBreite() {
    beobachten(matchMedia(MOBIL).matches);
    anwenden();
  }

  function start() {
    aufBreite();
    var mq = matchMedia(MOBIL);
    /* addListener ist veraltet, aber aeltere iOS-Safari kennen addEventListener
       auf MediaQueryList noch nicht. */
    if (mq.addEventListener) mq.addEventListener('change', aufBreite);
    else if (mq.addListener) mq.addListener(aufBreite);

    /* ⚠️ change auf der MediaQueryList ALLEIN reicht nicht. Am 21.08.
       gemessen: nach einem Breitenwechsel blieb enabled auf true, obwohl
       die Query matchte - das Ereignis kam nicht an. resize feuert
       verlaesslich, also beides. Gedrosselt, damit das Ziehen am
       Fensterrand nicht Dutzende Durchlaeufe ausloest. */
    var warteBreite = null;
    addEventListener('resize', function () {
      clearTimeout(warteBreite);
      warteBreite = setTimeout(aufBreite, 150);
    });
  }

  if (document.readyState === 'complete') start();
  else addEventListener('load', start);
})();
/* ============================================================================
 * Metallbau Odenthal - Galeriepfeile der Theme-Produktgalerie
 * v1.0.0  20.08.2026
 * ----------------------------------------------------------------------------
 * WARUM: Stefan wollte am 20.08. Pfeile am grossen Bild der normalen
 * Produktgalerie (Montageset Lochstein zweischalig o. ae.). Beim Einschalten
 * kam heraus: Dawns Pfeile blaettern in diesem Theme UEBERHAUPT NICHT - auch
 * die des Miniaturstreifens nicht, die laengst sichtbar waren. Gemessen:
 * Klick auf "weiter" laesst scrollLeft auf 0 stehen, der Zaehler bleibt bei 1.
 *
 * Die Ursache liegt in Dawn selbst: SliderComponent haengt seine Klick-Handler
 * im CONSTRUCTOR an (nicht im connectedCallback). Laeuft das Upgrade des
 * Custom Elements, bevor die Knoepfe im DOM stehen, greift der Waechter
 * "if (!this.slider || !this.nextButton) return" - die Komponente lebt, aber
 * ohne Handler. Von aussen sieht sie vollstaendig aus (totalPages stimmt),
 * deshalb faellt es nicht auf.
 *
 * WAS DIESER BLOCK TUT: Er faehrt die beiden Slider der Produktgalerie selbst
 * an - in der Capture-Phase mit stopImmediatePropagation, damit das Verhalten
 * eindeutig ist, egal ob Dawns Handler haengt oder nicht.
 *
 * ⚠️ NICHT nach Dawns fester Schrittweite springen. sliderItemOffset ist ein
 * EINZIGER Wert (hier 320), die Abstaende sind aber ungleich - gemessen
 * 15/335/655/1009/1329, also 320, 320, 354, 320. Ab dem dritten Bild laeuft
 * eine feste Schrittweite aus dem Tritt. Dieser Block zielt deshalb auf den
 * offsetLeft des Nachbarslides.
 *
 * ⚠️ NUR die Produktgalerie. Andere slider-component im Shop (Startseite,
 * Kollektionen) bleiben unangetastet - dort ist nicht geprueft, ob Dawns
 * Handler haengt, und ein stopImmediatePropagation wuerde ihn abschneiden.
 *
 * ⚠️ Dawn baut die Galerie bei jedem Variantenwechsel neu. Der Beobachter
 * meldet sich deshalb NICHT ab; die Markierung data-mo-pfeile verhindert
 * doppeltes Anhaengen.
 *
 * Gemessen bei 375 x 812 auf montageset-lochstein-zweischalig: 1 bis 5 und
 * zurueck, Positionen 0/320/640/994/1310, Zaehler laeuft mit, "zurueck" auf
 * Bild 1 und "weiter" auf Bild 5 korrekt ausgegraut, kein Ueberlaufen.
 * Die Kachelgroesse selbst steckt in custom.css Abschnitt 71 und 72.
 * ========================================================================= */
(function () {
  'use strict';

  var ZIEL = '.main-product-slider, .thumbnail-slider';

  function ruesteAus(sc) {
    if (!sc || sc.dataset.moPfeile) return;
    var liste = sc.querySelector('[id^="Slider-"]');
    var zur   = sc.querySelector('button[name="previous"]');
    var wei   = sc.querySelector('button[name="next"]');
    if (!liste || !wei) return;
    sc.dataset.moPfeile = '1';

    function slides() {
      return Array.prototype.filter.call(liste.children, function (e) {
        return e.clientWidth > 0;
      });
    }
    function ziele() {
      var s = slides();
      if (!s.length) return [];
      var null_ = s[0].offsetLeft;
      return s.map(function (e) { return e.offsetLeft - null_; });
    }
    function aktiv() {
      var z = ziele(), p = liste.scrollLeft, i = 0;
      z.forEach(function (v, k) { if (v <= p + 8) i = k; });
      return i;
    }
    function stand() {
      var z = ziele(), i = aktiv();
      if (zur) zur.disabled = i <= 0;
      wei.disabled = i >= z.length - 1;
      var a = sc.querySelector('.slider-counter--current');
      if (a) a.textContent = i + 1;
    }
    function springe(richtung) {
      var z = ziele();
      if (!z.length) return;
      var i = Math.min(Math.max(aktiv() + richtung, 0), z.length - 1);
      liste.scrollTo({ left: z[i], behavior: 'smooth' });
    }

    [[zur, -1], [wei, 1]].forEach(function (paar) {
      if (!paar[0]) return;
      paar[0].addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        springe(paar[1]);
      }, true);
    });

    liste.addEventListener('scroll', stand, { passive: true });
    stand();
  }

  function durchlauf() {
    document.querySelectorAll(ZIEL).forEach(ruesteAus);
  }

  function start() {
    if (!document.querySelector(ZIEL)) return;
    durchlauf();
    var beob = new MutationObserver(function () { durchlauf(); });
    beob.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


/* ============================================================================
 * Metallbau Odenthal - "JETZT KONFIGURIEREN" LANDET AM KONFIGURATOR   v1.0.0
 * Stand: 20.08.2026, 23:00
 *
 * WOFUER
 * Stefan: "brauche ich jetzt konfigurieren button sauber."
 *
 * GEMESSEN VORHER (fenstergitter-01, 1904 px): Der Knopf `.mo-fe-knopf` aus der
 * Section `mo-fertigung` traegt `href="#MainContent"` - er springt also an den
 * SEITENANFANG. Der Konfigurator stand danach bei `top: 438`, also gut
 * anderthalb Bildschirmdrittel unterhalb der Kante: Der Kunde drueckt "Jetzt
 * konfigurieren" und sieht zuerst Bewertungsleiste, Titel, Preis und die
 * Vorteilsliste. Erst danach kommt, wonach er gedrueckt hat.
 *
 * WAS DIESER BLOCK TUT
 * Er faengt den Klick ab und scrollt stattdessen zum Konfigurator selbst -
 * genauer: zum ersten Schritt, sonst zum Wrapper.
 *
 * ⚠️ KEIN FESTER ANKER IM TEMPLATE. Der Wrapper traegt die Config-UUID als id
 * (`cld1mz2nxbum`, `clcmvhyoecsx`, `clf2igcpiwur`, `cl5mcchywldt` …) - die ist
 * je Konfigurator anders. Ein `href="#<uuid>"` muesste in acht Vorlagen
 * gepflegt werden und braeche beim naechsten neuen Konfigurator. Deshalb hier
 * einmal zentral ueber die Klasse.
 *
 * ⚠️ ABSTAND WIRD GEMESSEN, NICHT GERATEN. Oben klebt der Kopf, und seit dem
 * 20.08. darunter die Schrittleiste. Beide werden zur Klickzeit ausgemessen;
 * das Ziel landet 16 px darunter.
 *
 * ⚠️ Der Knopf bleibt ein <a href="#MainContent">. Ohne JavaScript funktioniert
 * er also weiter wie bisher - er springt dann nur weniger genau.
 *
 * RUECKBAU: diesen Block loeschen.
 * ============================================================================ */
(function () {
  'use strict';

  function ziel() {
    return document.querySelector('.cl-po--options > .cl-po--option[data-option^="Schritt_"]') ||
           document.querySelector('.cl-po--wrapper') ||
           document.querySelector('.cl-po--options');
  }

  /* ⚠️ HOEHE MESSEN, NICHT DIE UNTERKANTE. Erster Anlauf nahm
     `getBoundingClientRect().bottom` - und lag daneben: Zur Klickzeit steht der
     Kunde weit unten, der Kopf ist da noch gar nicht geklebt (oder aus dem Bild
     gescrollt), seine Unterkante also klein oder negativ. Er klebt erst, wenn
     die Seite oben ankommt. Gemessen am 20.08.: Ziel landete auf top 16, der
     Kopf deckte davon 66 px zu.
     Die HOEHE dagegen ist in beiden Zustaenden dieselbe. */
  function frei() {
    var h = 0;
    ['#shopify-section-header', '.mo-leiste'].forEach(function (s) {
      var e = document.querySelector(s);
      if (!e) return;
      var cs = getComputedStyle(e);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      var r = e.getBoundingClientRect();
      if (r.height > 0) h += r.height;
    });
    return h;
  }

  function start() {
    document.addEventListener('click', function (ev) {
      var knopf = ev.target && ev.target.closest ? ev.target.closest('.mo-fe-knopf') : null;
      if (!knopf) return;
      var z = ziel();
      if (!z) return;                       /* keine Konfiguratorseite: Anker bleibt */
      ev.preventDefault();
      var oben = window.scrollY + z.getBoundingClientRect().top - (frei() + 16);
      /* ⚠️ `behavior: instant` ist Pflicht. Ohne es gilt `scroll-behavior:
         smooth` aus base.css - und die weiche Fahrt ueber 3.284 px wurde
         unterwegs abgebrochen: Am 20.08. gemessen, der Aufruf lautete korrekt
         `{top: 458.84}`, die Seite blieb trotzdem bei 3.743 stehen. Wer hier
         wieder auf smooth stellt, baut denselben Blindgaenger ein. */
      window.scrollTo({ top: Math.max(0, oben), behavior: 'instant' });
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();


/* ============================================================================
 * SCHLIESSKNOPF FUER DIE BILD-TOOLTIPS                            v1.1.0
 * Stand: 21.08.2026
 *
 * WOFUER
 * Stefan: "tooltipp wollte ich weg x können von den Wandaufbau."
 *
 * Die Kacheln im Konfigurator tragen Tippy-Tooltips, deren Inhalt ein BILD ist
 * (data-tippy-content = "<img ...>"). Am 21.08. an "Lochstein - Wandaufbau"
 * gemessen:
 *
 *   trigger: "click"      - der Tooltip geht per Antippen auf, nicht per Hover
 *   interactive: true     - ein Tipp IN den Tooltip schliesst ihn deshalb nicht
 *   Knoepfe: 0            - es gab keinen Weg, ihn bewusst zuzumachen
 *   Box 350 x 176, Bild 318 x 155, zIndex 9999
 *
 * Auf dem Handy deckt so ein Bild die halbe Auswahl zu, und der Kunde steht
 * davor ohne sichtbaren Ausweg. Dieser Block haengt deshalb in JEDE
 * Tooltip-Box mit Bild einen Schliessknopf oben rechts.
 *
 * 25 Traeger gibt es im Konfigurator, 7 davon mit Bild - der Knopf kommt nur
 * an die 7, reiner Text braucht ihn nicht.
 *
 * ⚠ NICHT die Bildlupe anfassen. Das ist ein anderes Bauteil (#mo-lupe, eigener
 * Block weiter oben) und hat ihren Schliessknopf laengst - Stefans Ansage vom
 * 21.08.: "nichts ändern an der lupe".
 *
 * ⚠ Die Box entsteht erst beim Antippen und wird danach wieder aus dem DOM
 * genommen. Deshalb ein MutationObserver an document.body, der sich NICHT
 * abmeldet - gleiches Muster wie beim +/- Knopf der Vorschau.
 *
 * ⚠ 44 x 44 px ist Pflicht, nicht Geschmack (WCAG 2.5.8). Der Knopf sitzt
 * halb ueber der oberen rechten Ecke, damit er das Bild nicht verdeckt.
 *
 * RUECKBAU: diesen Block loeschen.
 * ============================================================================ */
(function () {
  'use strict';

  var KNOPF = 'mo-tt-zu';

  function tippyInstanzen() {
    var alle = document.querySelectorAll('[data-tippy-content]');
    var raus = [];
    for (var i = 0; i < alle.length; i++) if (alle[i]._tippy) raus.push(alle[i]._tippy);
    return raus;
  }

  /* Die sichtbare Instanz schliessen. Ueber die Instanzen zu gehen ist
     zuverlaessiger als von der Box aus zurueckzusuchen - Tippy haengt keine
     Rueckreferenz an [data-tippy-root]. */
  function zumachen() {
    var alle = tippyInstanzen();
    for (var i = 0; i < alle.length; i++) {
      try { if (alle[i].state && alle[i].state.isVisible) alle[i].hide(); } catch (e) {}
    }
  }

  function stil() {
    if (document.getElementById('mo-tt-zu-stil')) return;
    var s = document.createElement('style');
    s.id = 'mo-tt-zu-stil';
    s.textContent =
        '.' + KNOPF + '{position:absolute;top:-14px;right:-14px;width:44px;height:44px;'
      + 'border:0;border-radius:50%;background:#1f2937;color:#fff;font-size:22px;line-height:1;'
      + 'cursor:pointer;z-index:2;display:flex;align-items:center;justify-content:center;'
      + 'box-shadow:0 2px 8px rgba(0,0,0,.35);padding:0}'
      + '.' + KNOPF + ':hover,.' + KNOPF + ':focus-visible{background:#cb4f0a}'
      /* Die Box darf den Knopf nicht abschneiden. */
      + '[data-tippy-root] .tippy-box{overflow:visible!important}';
    document.head.appendChild(s);
  }

  function einhaengen() {
    var boxen = document.querySelectorAll('[data-tippy-root] .tippy-box');
    for (var i = 0; i < boxen.length; i++) {
      var box = boxen[i];
      if (!box.querySelector('img')) continue;          /* nur Bild-Tooltips */
      if (box.querySelector('.' + KNOPF)) continue;     /* schon versorgt     */
      var inhalt = box.querySelector('.tippy-content') || box;
      if (getComputedStyle(inhalt).position === 'static') inhalt.style.position = 'relative';
      var k = document.createElement('button');
      k.type = 'button';
      k.className = KNOPF;
      k.setAttribute('aria-label', 'Vorschau schliessen');
      k.innerHTML = '&times;';
      k.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        zumachen();
      });
      inhalt.appendChild(k);
    }
  }

  function start() {
    stil();
    einhaengen();
    /* Meldet sich bewusst nie ab: die Boxen kommen und gehen mit jedem Antippen.

       ⚠ `childList` allein reicht NICHT. Tippy baut die Box nicht jedes Mal neu,
       sondern verwendet sie wieder und schaltet nur `data-state` / `style` um -
       dann feuert keine Kind-Mutation. Am 21.08. gemessen: so bekamen nur
       4 von 6 Bild-Tooltips ihren Knopf. Deshalb zusaetzlich auf Attribute
       hoeren. */
    new MutationObserver(einhaengen).observe(document.body, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['data-state', 'style', 'class']
    });
    /* Netz fuer den Rest: Der Tooltip geht per Klick auf (trigger: "click"),
       also nach jedem Klick kurz nachfassen. einhaengen() ist idempotent -
       ein zweiter Durchlauf kostet nichts. */
    document.addEventListener('click', function () {
      setTimeout(einhaengen, 60);
      setTimeout(einhaengen, 350);
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();


/* ===================================================================
   mo_galerie_aufmass.js                          21.08.2026, 14:10
   -------------------------------------------------------------------
   Zwei Dinge, beide von Stefan am 21.08. bestellt:

   1) Klick ins Massfeld -> die Galerie springt auf das Aufmassbild.
   2) Die eingetragenen Masse stehen als Overlay IM Galeriebild, an
      derselben Stelle wie in der kleinen Skizze daneben.

   ⚠️ DAS BILD BRINGT DIE BESCHRIFTUNG SCHON MIT. "Befestigungsabstand:"
   und "Hoehe:" sind rot eingezeichnet, jeweils mit Doppelpunkt und
   freiem Raum dahinter. Hier kommt NUR die Zahl dazu. Deshalb steht
   auch ohne Eingabe schon etwas da - Stefans Vorgabe "bevor wir
   eintragen befestigungsabstand und hoehe sichtbar" ist damit erfuellt,
   ohne die Massfelder vorzubelegen (das haette aus dem "ab"-Preis einen
   konkreten Preis gemacht, siehe Memory ab-preis-ohne-masse).

   🔴 FESTE KOORDINATEN GEHEN NICHT. Am 21.08. alle fuenf Bilder
   vermessen - sie stammen NICHT aus einer Vorlage:

     FG01 1200x1323  Text endet 68.6%  "Hoehe" ab 44.7%
     FG02 1200x1539  Text endet 71.3%  "Hoehe" ab 40.2%
     FG03 1200x1134  Text endet 74.6%  "Hoehe" NICHT GEFUNDEN
     FG09 1200x1349  Text endet 72.3%  "Hoehe" ab 15.1%
     FG29 1200x1349  wie FG09

   Deshalb vermisst dieser Block JEDES Bild selbst: rote Pixel im
   Canvas, daraus Textende, Textspur und Masslinie. Findet er nichts
   Verlaessliches, zeichnet er NICHTS - lieber keine Zahl als eine, die
   in der Zeichnung sitzt. Das trifft heute FG03.

   ⚠️ object-fit ist `contain`: das <img> misst 430x430, das Bild darin
   nur 390x430. Die Prozente muessen auf den ECHTEN Bildbereich, nicht
   auf den Rahmen - sonst sitzt alles 20px daneben.

   Der Rotton wird aus dem Bild gegriffen, nicht geraten.
   =================================================================== */
(function () {
  'use strict';

  var CACHE = {};                    /* Vermessung je Bild-URL */
  var MIN_PLATZ = 8;                 /* Prozent; darunter wird nicht gezeichnet */

  function galerieHaupt()  { return document.querySelector('.cl-po--gallery-main'); }
  function galerieThumbs() { return document.querySelector('.cl-po--gallery-thumbnails'); }

  function istAufmass(im) {
    var s = im && im.getAttribute('src');
    return !!s && /Aufma/i.test(s);
  }

  /* Index und Slide des Aufmassbilds; -1 / null wenn es keins gibt. */
  function aufmassIndex() {
    var g = galerieHaupt(); if (!g) return -1;
    var sl = g.querySelectorAll('.splide__slide');
    for (var i = 0; i < sl.length; i++) if (istAufmass(sl[i].querySelector('img'))) return i;
    return -1;
  }
  function aufmassSlide() {
    var i = aufmassIndex();
    return i < 0 ? null : galerieHaupt().querySelectorAll('.splide__slide')[i];
  }

  /* ---- Bild vermessen ------------------------------------------------
     Liefert Prozentwerte oder null. Ergebnis wird je URL gemerkt. */
  function vermessen(url, fertig) {
    if (Object.prototype.hasOwnProperty.call(CACHE, url)) return fertig(CACHE[url]);
    /* ⚠️ ÜBER DIE SITZUNG GEMERKT. Das Vermessen laedt das Bild per
       crossOrigin ein zweites Mal (107 KB, eigener Cache-Eintrag). Da das
       Overlay jetzt auch ohne Eingabe zeichnet, waere das sonst auf JEDER
       Produktseite faellig. Die Werte eines Bildes aendern sich nicht. */
    try {
      var gemerkt = sessionStorage.getItem('mo-gal-' + url);
      if (gemerkt !== null) { CACHE[url] = JSON.parse(gemerkt); return fertig(CACHE[url]); }
    } catch (e) {}
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onerror = function () { fertig(CACHE[url] = null); };
    img.onload = function () {
      var W = img.naturalWidth, H = img.naturalHeight;
      var c = document.createElement('canvas');
      c.width = W; c.height = H;
      var ctx = c.getContext('2d');
      ctx.drawImage(img, 0, 0);
      var d;
      /* Fremd-CDN ohne CORS-Kopf -> getImageData wirft. Dann kein Overlay. */
      try { d = ctx.getImageData(0, 0, W, H).data; }
      catch (e) { return fertig(CACHE[url] = null); }

      function rot(px, y) {
        var i = (y * W + px) * 4, r = d[i], g = d[i + 1], b = d[i + 2];
        return r > 110 && r - g > 40 && r - b > 40;
      }

      /* (a) waagrechte Beschriftung im oberen Siebtel */
      var tY = [], tX = [];
      for (var y = 0; y < H * 0.14; y++) {
        var n = 0;
        for (var px = 0; px < W; px += 2) if (rot(px, y)) n++;
        if (n >= 25) tY.push(y);
      }
      if (!tY.length) return fertig(CACHE[url] = null);
      var y0 = tY[0], y1 = tY[tY.length - 1];
      for (var px2 = 0; px2 < W; px2++) {
        var n2 = 0;
        for (var yy = y0; yy <= y1; yy++) if (rot(px2, yy)) n2++;
        if (n2 >= 6) tX.push(px2);
      }
      if (!tX.length) return fertig(CACHE[url] = null);

      /* (b) Masslinie rechts daneben: rechtestes rotes Pixel unter dem Text */
      var linX = 0;
      for (var y5 = y1 + 3; y5 < y1 + 80 && y5 < H; y5++) {
        for (var px5 = W - 1; px5 > W * 0.55; px5--) {
          if (rot(px5, y5)) { if (px5 > linX) linX = px5; break; }
        }
      }
      if (!linX) linX = Math.round(W * 0.96);   /* keine Linie gefunden: Bildrand */

      /* (c) senkrechte Beschriftung am rechten Rand */
      var rX = [], rY = [];
      for (var px3 = Math.floor(W * 0.84); px3 < W; px3++) {
        var n3 = 0;
        for (var y3 = Math.floor(H * 0.05); y3 < H * 0.9; y3++) if (rot(px3, y3)) n3++;
        if (n3 >= 25) rX.push(px3);
      }
      var erg = {
        querTextVon:  tX[0] / W * 100,
        querTextEnde: tX[tX.length - 1] / W * 100,
        querMitteY:   ((y0 + y1) / 2) / H * 100,
        querGrenze:   linX / W * 100,
        hoch: null
      };
      if (rX.length) {
        var x0 = rX[0], x1 = rX[rX.length - 1];
        for (var y4 = 0; y4 < H; y4++) {
          var n4 = 0;
          for (var px4 = x0; px4 <= x1; px4++) if (rot(px4, y4)) n4++;
          if (n4 >= 6) rY.push(y4);
        }
        if (rY.length) {
          erg.hoch = {
            mitteX:    ((x0 + x1) / 2) / W * 100,
            textOben:  rY[0] / H * 100,
            textUnten: rY[rY.length - 1] / H * 100,
            grenze:   Math.max(2, (rY[0] / H * 100) - 40)   /* Platz nach oben */
          };
        }
      }
      /* Farbe aus dem Text greifen statt raten */
      var best = [241, 68, 81], score = -1;
      for (var y6 = y0; y6 <= y1; y6++) {
        for (var px6 = tX[0]; px6 <= tX[tX.length - 1]; px6 += 3) {
          var i6 = (y6 * W + px6) * 4, r6 = d[i6], g6 = d[i6 + 1], b6 = d[i6 + 2];
          var s6 = r6 - (g6 + b6) / 2;
          if (s6 > score) { score = s6; best = [r6, g6, b6]; }
        }
      }
      erg.farbe = 'rgb(' + best.join(',') + ')';
      try { sessionStorage.setItem('mo-gal-' + url, JSON.stringify(erg)); } catch (e) {}
      fertig(CACHE[url] = erg);
    };
    img.src = url;
  }

  /* ---- Werte und Beschriftung aus den Massfeldern -------------------- */
  function massFelder() {
    var m = document.querySelector('.cl-po--option[data-option^="Schritt_Mas"]')
         || document.querySelector('.cl-po--option[data-option^="Ma"]');
    if (!m) return [];
    return [].slice.call(m.querySelectorAll('.cl-po--dimension-item input'));
  }

  /* ⚠️ DIE BESCHRIFTUNG WIRD NICHT GESCHRIEBEN, SONDERN GELESEN.
     Sie steht im <label> des jeweiligen Massfelds - damit stimmt sie auch
     dort, wo die Achse anders heisst (Breite, lichtes Mass, Laenge...).
     Das Label traegt ein weiches Trennzeichen ("Befestigungs&shy;abstand"),
     das muss raus, sonst steht es im Bild. */
  function beschriftung(feld) {
    var item = feld && feld.closest ? feld.closest('.cl-po--dimension-item') : null;
    var lab = item ? item.querySelector('.cl-po--label') : null;
    if (!lab) return '';
    return (lab.textContent || '').replace(/­/g, '').replace(/\s+/g, ' ').replace(/:\s*$/, '').trim();
  }
  /* ⚠️ OHNE EINGABE STEHT DIE BESCHRIFTUNG DA, NICHT NICHTS.
     Stefan am 21.08.: „wenn nichts zu messen ist vorher Befestigungsabstand
     x Höhe stehen haben das das nicht leer ist?"
     Das Galeriebild traegt „Befestigungsabstand:" mit einem Doppelpunkt, der
     auf eine Zahl wartet - allein sieht das unfertig aus. Ohne Eingabe legt
     das Overlay deshalb die Beschriftung OHNE Doppelpunkt darueber, genau wie
     es die kleine Skizze daneben schon immer macht. */
  function zeile(feld) {
    if (!feld) return '';
    var b = beschriftung(feld);
    var w = feld.value.trim();
    if (!w) return b;                       /* leer: nur die Beschriftung */
    return (b ? b + ': ' : '') + w + ' mm';
  }

  /* ---- Overlay zeichnen ---------------------------------------------- */
  function zeichnen() {
    var slide = aufmassSlide();
    if (!slide) return;
    var im = slide.querySelector('img');
    if (!im || !im.naturalWidth) return;

    /* 🔴 ERST PRUEFEN, DANN VERMESSEN. Am 21.08. gemessen: das Vermessen
       laedt das Bild ein ZWEITES Mal (107 KB) - `crossOrigin=anonymous`
       erzeugt einen eigenen Cache-Eintrag, getrennt von dem des <img>.
       Stand die Pruefung wie zuvor NACH dem Vermessen, kostete das die
       107 KB auf JEDER Produktseite, auch wenn nie ein Mass eingetragen
       wurde. Jetzt laedt es nur, wenn wirklich etwas zu zeichnen ist. */
    var f = massFelder();
    var tQuer = zeile(f[0]), tHoch = zeile(f[1]);
    var huelleAlt = slide.querySelector('.mo-gal-huelle');
    if (!tQuer && !tHoch) { if (huelleAlt) huelleAlt.remove(); return; }

    vermessen(im.getAttribute('src'), function (M) {
      var alt = slide.querySelector('.mo-gal-huelle');
      if (alt) alt.remove();
      if (!M) return;                       /* nicht verlaesslich vermessen */

      /* echten Bildbereich bestimmen (object-fit: contain) */
      var r = im.getBoundingClientRect(), sr = slide.getBoundingClientRect();
      if (!r.width) return;
      var sc = Math.min(r.width / im.naturalWidth, r.height / im.naturalHeight);
      var bw = im.naturalWidth * sc, bh = im.naturalHeight * sc;

      var h = document.createElement('div');
      h.className = 'mo-gal-huelle';
      h.style.cssText = 'position:absolute;pointer-events:none;z-index:3;'
        + 'left:' + ((r.left - sr.left) + (r.width - bw) / 2) + 'px;'
        + 'top:'  + ((r.top - sr.top) + (r.height - bh) / 2) + 'px;'
        + 'width:' + bw + 'px;height:' + bh + 'px;';
      if (getComputedStyle(slide).position === 'static') slide.style.position = 'relative';
      slide.appendChild(h);

      /* ---- Schrift ----------------------------------------------------
         🔴 ZWEITER ANLAUF, 21.08. Erst stand nur die ZAHL hinter dem
         eingezeichneten Doppelpunkt - jede in eigener Groesse (15/18 px),
         in Montserrat 700. Stefan: "kann man das auch sauberer darstellen?"
         und "den text kommplett neu machen und zentriert?".

         Jetzt wird die ganze Zeile neu gesetzt, auf weissem Feld, mittig
         auf der Beschriftung des Bildes - das deckt den eingezeichneten
         Text ab und sieht aus wie die kleine Skizze daneben, die es genauso
         macht (weisses Feld, roter Text).

         ⚠️ ÜBERDECKEN MIT WANDFARBE GEHT NICHT. Am 21.08. gemessen: der
         Putz hinter dem Text streut 96-115 pro Kanal. Eine glatte Flaeche
         in Mittelfarbe faellt dort sofort auf. Weiss wirkt dagegen wie ein
         gewolltes Beschriftungsfeld.

         ⚠️ Schmale Schrift, nicht Montserrat: die Beschriftung im Bild hat
         je Zeichen ein Verhaeltnis Breite:Hoehe von 0,49. Montserrat liegt
         bei 0,6 und in 700 zusaetzlich schwerer. */
      var FAM = '"Arial Narrow","Roboto Condensed","Helvetica Neue",Arial,sans-serif';

      /* Grundgroesse = die der eingezeichneten Beschriftung (Grossbuchstabe
         4 % der Bildbreite entspricht font-size 5,56 %), dann so weit
         herunter, bis beide Zeilen ins Bild passen. */
      var probe = document.createElement('span');
      probe.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;'
        + 'font-weight:600;line-height:1.15;letter-spacing:.01em;padding:2px 7px;font-family:' + FAM;
      document.body.appendChild(probe);
      function breite(t, groesse) {
        probe.style.fontSize = groesse + 'px';
        probe.textContent = t;
        return probe.getBoundingClientRect().width;
      }
      var fs = Math.round(bw * 0.0556);
      while (fs > 9) {
        var passt = (!tQuer || breite(tQuer, fs) <= bw * 0.94)
                 && (!tHoch || breite(tHoch, fs) <= bh * 0.80);
        if (passt) break;
        fs--;
      }
      probe.remove();
      if (fs <= 9) return;

      function feld(txt, hoch) {
        if (!txt) return;
        var s = document.createElement('span');
        s.className = 'mo-gal-zahl';
        s.style.cssText = 'position:absolute;color:' + M.farbe + ';font-family:' + FAM + ';'
          + 'font-weight:600;line-height:1.15;white-space:nowrap;letter-spacing:.01em;'
          + 'font-variant-numeric:tabular-nums;background:#fff;padding:2px 7px;border-radius:2px;'
          + 'font-size:' + fs + 'px;';
        s.textContent = txt;
        if (hoch) {
          s.style.left = M.hoch.mitteX + '%';
          s.style.top  = ((M.hoch.textOben + M.hoch.textUnten) / 2) + '%';
          s.style.transform = 'translate(-50%,-50%) rotate(-90deg)';
        } else {
          s.style.left = ((M.querTextVon + M.querTextEnde) / 2) + '%';
          s.style.top  = M.querMitteY + '%';
          s.style.transform = 'translate(-50%,-50%)';
        }
        h.appendChild(s);
      }
      feld(tQuer, false);
      if (M.hoch) feld(tHoch, true);
    });
  }

  /* ---- Galerie auf die Zeichnung schalten ---------------------------
     🔴 EIN KLICK GENUEGT NICHT. Am 21.08. gemessen: beim ERSTEN Fokus
     nach dem Laden verpufft der Thumbnail-Klick - Splide ist da noch
     nicht montiert. Beim zweiten Mal ging es. Deshalb bis zu drei
     Anlaeufe im Abstand von 250 ms; sobald das Bild steht, wird
     abgebrochen. Nach spaetestens 750 ms ist der Spuk vorbei, da
     blaettert noch niemand von Hand dazwischen. */
  function zurZeichnung() {
    var i = aufmassIndex();
    if (i < 0) return;                       /* Modell ohne Aufmassbild: nichts tun */

    (function versuch(rest) {
      var g = galerieHaupt(), t = galerieThumbs();
      if (!g || !t) return;
      var haupt = g.querySelectorAll(".splide__slide");
      if (haupt[i] && haupt[i].classList.contains("is-active")) return;   /* steht schon da */
      var ts = t.querySelectorAll(".splide__slide");
      if (ts[i]) (ts[i].querySelector("img") || ts[i]).click();
      if (rest > 0) setTimeout(function () { versuch(rest - 1); }, 250);
    })(2);
  }

  /* ---- Verdrahtung ---------------------------------------------------
     🔴 KEINE HANDLER AN DIE FELDER HAENGEN. Am 21.08. genau das gebaut
     und gemessen: der Umschalter feuerte beim ersten Klick nicht. Grund:
     die App baut die Massfelder nach dem Verdrahten NEU auf, der Handler
     sitzt danach auf einem verworfenen Knoten. Ein Beobachter, der sich
     nach dem ersten Erfolg abhaengt, merkt davon nichts.

     Deshalb Delegation am Dokument - das ueberlebt jeden Neuaufbau und
     braucht keinen Dauerbeobachter (der hat am 21.08. schon einmal die
     Ladezeit gekostet, siehe mo_aufmass_skizze.js).
     "focusin" statt "focus", weil nur focusin nach oben blubbert. */
  var MASSFELD = '.cl-po--dimension-item input';
  var geplant = null;

  function anstossen() {
    clearTimeout(geplant);
    geplant = setTimeout(zeichnen, 120);
  }
  function trifft(el) {
    return el && el.matches && el.matches(MASSFELD);
  }

  function start() {
    document.addEventListener('focusin', function (e) {
      if (trifft(e.target)) zurZeichnung();
    });
    document.addEventListener('input', function (e) {
      if (trifft(e.target)) anstossen();
    });
    /* Die -/+ Knoepfe schreiben den Wert ohne input-Ereignis. */
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.cl-po--dimension-container')) anstossen();
    });
    addEventListener('resize', anstossen);
    /* Galerie und Konfigurator kommen aus der App - ein paar Mal nachfassen. */
    [400, 1200, 2500, 5000].forEach(function (ms) { setTimeout(anstossen, ms); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();


/* ===================================================================
   mo_aufmass_vorladen.js                          21.08.2026, 14:40
   -------------------------------------------------------------------
   Uebergabepunkt B23. Stefans Frage: „warum brauchen die Maße so lange
   wegen dem HTML?" — die Vermutung war richtig.

   Gemessen am 21.08. (Desktop 1440, warmer Cache):

     832 ms  Dokument fertig
    1358 ms  options.js geladen (1,47 MB roh)
    2238 ms  Skizzenbild wird ERST JETZT angefordert
    2419 ms  Bild da

   🔴 URSACHE: Die Bildadresse steht zwar im HTML, aber als data-Attribut
   am versteckten Traeger (`<div hidden data-mo-metafelder
   data-aufmass-bild-aussenwand="…">` aus main-product.liquid). Der
   Preload-Scanner des Browsers liest NUR `<img src>` und `<link>` — ein
   data-Attribut ist fuer ihn Text. Angefordert wird das Bild deshalb
   erst, wenn das JS daraus ein background-image macht, und das geht
   fruehestens nach dem Rendern der App.

   ⚠️ KEIN `<link rel=preload>` und kein fetchpriority="high". Die Skizze
   sitzt bei y = 883 px und liegt bei 900er Fensterhoehe unter der Falz,
   waehrend die Seite ohnehin 86 Bilder / 3,2 MB laedt. Hohe Prioritaet
   naehme dem Produktbild oben Bandbreite. DOMContentLoaded ist frueh
   genug: das sind rund 800 ms vor dem bisherigen Zeitpunkt.

   ⚠️ DIE ADRESSE MUSS BYTE-GLEICH SEIN, sonst holt der Browser zweimal.
   Deshalb wird sie hier NICHT umgeschrieben (auch nicht die Breite) —
   genommen wird genau der Wert, den das JS spaeter auch setzt.

   ⚠️ Zwei Varianten im Traeger: Aussenwand und Laibung. Vorgeladen wird
   die, die beim Start gilt — die Klasse `mo-bef-laibung` am <html> setzt
   mo_aufmass_skizze.js. Steht sie noch nicht, ist Aussenwand der
   Standard. Beide vorzuladen waere ein Request zu viel fuer ein Bild,
   das der Kunde vielleicht nie sieht.

   ⚠️ Erwartung, ehrlich: Die Skizze erscheint dadurch NICHT frueher als
   der Konfigurator — die rund 2,2 s bis dahin bleiben, das ⓘ existiert
   vorher gar nicht. Was verschwindet, ist das Nachklappen. Beim
   Erstbesuch auf Mobilfunk ist der Gewinn deutlich, bei warmem Cache
   liegt er bei rund 180 ms.
   =================================================================== */
(function () {
  'use strict';
  /* 26.09.2026 (PageSpeed): abgeschaltet. Die Aufmass-Skizze laedt seit 03.09. selbst per srcset
     480/640/960 in passender Groesse; die hier vorgeladene 800er wurde in 10 von 10 Messungen
     nie angezeigt und lud im LCP-Fenster mit (bis 110 KB je Seite). RUECKBAU: diese Zeilen loeschen. */
  return;

  function vorladen() {
    var t = document.querySelector('[data-aufmass-bild-aussenwand]');
    if (!t) return;                                  /* Produkt ohne Skizze */
    var laibung = document.documentElement.classList.contains('mo-bef-laibung');
    var u = laibung
      ? t.getAttribute('data-aufmass-bild-laibung')
      : t.getAttribute('data-aufmass-bild-aussenwand');
    if (!u) u = t.getAttribute('data-aufmass-bild-aussenwand');
    if (!u) return;
    /* Ein losgeloestes Image() genuegt — es landet im HTTP-Cache, das
       spaetere background-image trifft dann auf einen Treffer. */
    var bild = new Image();
    bild.decoding = 'async';
    bild.src = u;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vorladen);
  } else {
    vorladen();
  }
})();


/* ===================================================================
   mo_lightbox_spaet.js                            21.08.2026, 15:10
   -------------------------------------------------------------------
   Die Lightbox laedt ihre Bilder erst, wenn sie geoeffnet wird.

   🔴 DER BEFUND: Am 21.08. gemessen, `fenstergitter-01`, 2.08.0:
   55 Bilder / 3.382 KB auf der Seite, davon 663 KB dasselbe Motiv
   mehrfach. Ursache: Im DOM liegen ZWEI Galerien. Sichtbar ist die
   LPO-Splide-Galerie; daneben steht Dawns Lightbox
   (`<product-modal class="product-media-modal">`) mit 29 Bildern, ALLE
   mit `srcset` - unsichtbar (visibility:hidden, opacity:0), aber
   vollstaendig geladen. Von dort kommen die unskalierten Originale
   (501 / 574 / 372 KB).

   🔴 WARUM NUR DAS MODAL UND NICHTS SONST — Stefans Auflage:
   „vorsichtig das nicht montagesets kaputt gehen".
   Nachgemessen: Bei den Montagesets gibt es **keine LPO-Galerie**
   (`.cl-po--gallery-main` = null). Dort ist Dawns Galerie die EINZIGE
   sichtbare. Wer pauschal alle `srcset` der Produktseite leert, macht
   diese Seiten bildlos. Deshalb fasst dieser Block ausschliesslich
   Bilder INNERHALB des Modals an - die sichtbare Galerie liegt in
   beiden Faellen ausserhalb davon.

   ✅ Die Bildlupe ist nicht betroffen: gemessen 0 Lupen-Elemente im
   Modal, 11 ausserhalb. Siehe [[bildlupe-shopweit]].

   ⚠️ Geweckt wird bei DREI Gelegenheiten, damit das Bild moeglichst
   schon da ist, wenn das Modal aufgeht:
     1. `pointerdown` auf einem Oeffner (frueheste Vorwarnung)
     2. das `open`-Attribut am Modal (der sichere Fall)
     3. Tastatur: Enter/Leertaste auf einem Oeffner
   Danach haengt sich der Beobachter ab - einmal geweckt bleibt wach.
   =================================================================== */
(function () {
  'use strict';

  var MODAL   = 'product-modal, .product-media-modal, .media-modal';
  var OEFFNER = '.product__modal-opener, .product-media-modal__toggle, [data-media-id]';

  function modalKnoten() { return document.querySelector(MODAL); }

  function schlafen(m) {
    var n = 0;
    [].slice.call(m.querySelectorAll('img')).forEach(function (i) {
      if (i.getAttribute('data-mo-schlaeft')) return;
      var ss = i.getAttribute('srcset');
      var s  = i.getAttribute('src');
      if (!ss && !s) return;
      if (ss) { i.setAttribute('data-mo-srcset', ss); i.removeAttribute('srcset'); }
      if (s)  { i.setAttribute('data-mo-src', s);     i.removeAttribute('src'); }
      i.setAttribute('data-mo-schlaeft', '1');
      n++;
    });
    return n;
  }

  var geweckt = false;
  function wecken() {
    if (geweckt) return;
    var m = modalKnoten();
    if (!m) return;
    geweckt = true;
    [].slice.call(m.querySelectorAll('img[data-mo-schlaeft]')).forEach(function (i) {
      var ss = i.getAttribute('data-mo-srcset');
      var s  = i.getAttribute('data-mo-src');
      /* srcset zuerst, sonst laedt der Browser kurz die src-Variante */
      if (ss) { i.setAttribute('srcset', ss); i.removeAttribute('data-mo-srcset'); }
      if (s)  { i.setAttribute('src', s);     i.removeAttribute('data-mo-src'); }
      i.removeAttribute('data-mo-schlaeft');
    });
  }

  function start() {
    var m = modalKnoten();
    if (!m) return;                       /* Seite ohne Lightbox: nichts tun */
    /* Steht das Modal schon offen, gar nicht erst schlafen legen. */
    if (m.hasAttribute('open')) return;
    if (!schlafen(m)) return;

    /* (1) frueheste Vorwarnung: der Finger geht runter */
    document.addEventListener('pointerdown', function (e) {
      if (e.target && e.target.closest && e.target.closest(OEFFNER)) wecken();
    }, true);
    /* (3) Tastatur */
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') &&
          document.activeElement && document.activeElement.closest &&
          document.activeElement.closest(OEFFNER)) wecken();
    }, true);
    /* (2) der sichere Fall: Dawn setzt beim Oeffnen `open` */
    var beob = new MutationObserver(function () {
      if (m.hasAttribute('open')) { wecken(); beob.disconnect(); }
    });
    beob.observe(m, { attributes: true, attributeFilter: ['open'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();


/* ============================================================================
 * KAUFLEISTE: BILD IN SEINER GROESSE HOLEN                            v1.0.0
 * Stand: 22.08.2026
 *
 * WAS ES TUT
 * Das Custom Element ProductStickyForm kopiert das Galerie-Hauptbild per
 * innerHTML in die klebende Kaufleiste — mitsamt seinem srcset aus zwoelf
 * Groessen und einem `sizes`, das fuer die grosse Galerie gedacht ist. In der
 * Leiste ist das Bild aber nur **64 x 64 px** gross.
 *
 * Gemessen am 22.08.2026 auf /products/fenstergitter-01:
 *     angefordert 1100 px  ->  angezeigt 64 px  ->  207 KB
 * Das war der groesste Einzelposten der ganzen Produktseite.
 *
 * WIE
 * srcset und sizes weg, dann `src` auf `&width=128` (64 x 2 fuer Retina).
 * Shopify liefert daraus rund 5 KB statt 207.
 *
 * 🔴 srcset MUSS zuerst weg. Bleibt es stehen, gewinnt es gegen src — der
 * Browser laedt weiter die grosse Fassung und der Eingriff verpufft.
 *
 * ⚠️ Die Leiste schreibt ihren Inhalt bei jedem Scroll neu (die Schreibbremse
 * weiter oben verwirft nur gleiche Werte). Deshalb ein DAUERHAFTER Beobachter
 * und kein einmaliger Lauf.
 *
 * ⚠️ `&width=` skaliert NICHT hoch. Ist das Original kleiner, kommt das
 * Original — kein Schaden, aber auch kein Gewinn.
 * ========================================================================== */
(function () {
  'use strict';

  var LEISTE = '.product-sticky-image';
  var BREITE = 128;

  function klein(img) {
    if (!img || img.getAttribute('data-mo-klein') === '1') return;
    var src = img.getAttribute('src') || img.currentSrc || '';
    if (!src) return;
    // Nur Shopify-Adressen anfassen — fremde Quellen kennen den Parameter nicht.
    if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(src)) return;

    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    img.removeAttribute('sizes');

    var ohne = src.replace(/([?&])width=\d+&?/g, '$1').replace(/[?&]$/, '');
    img.setAttribute('src', ohne + (ohne.indexOf('?') > -1 ? '&' : '?') + 'width=' + BREITE);
    img.setAttribute('data-mo-klein', '1');
    img.setAttribute('loading', 'lazy');
    img.setAttribute('decoding', 'async');
  }

  function durchgehen() {
    document.querySelectorAll(LEISTE + ' img').forEach(klein);
  }

  function starten() {
    var box = document.querySelector(LEISTE);
    if (!box) return false;
    durchgehen();
    // Dauerhaft: die Leiste ersetzt ihren Inhalt beim Scrollen.
    new MutationObserver(durchgehen).observe(box, { childList: true, subtree: true });
    return true;
  }

  if (!starten()) {
    // Die Leiste kommt erst mit dem Custom Element. Kurz warten, dann aufgeben.
    var wache = new MutationObserver(function () {
      if (starten()) wache.disconnect();
    });
    wache.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { wache.disconnect(); }, 15000);
  }
})();
